!function (e, o) {
  for (var n in o) e[n] = o[n];
}(exports, function (n) {
  var t = {};
  function r(e) {
    if (t[e]) return t[e].exports;
    var o = t[e] = {
      i: e,
      l: !1,
      exports: {}
    };
    return n[e].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
  }
  return r.m = n, r.c = t, r.d = function (e, o, n) {
    r.o(e, o) || Object.defineProperty(e, o, {
      enumerable: !0,
      get: n
    });
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r.t = function (o, e) {
    if (1 & e && (o = r(o)), 8 & e) return o;
    if (4 & e && "object" == typeof o && o && o.__esModule) return o;
    var n = Object.create(null);
    if (r.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: o
    }), 2 & e && "string" != typeof o) for (var t in o) r.d(n, t, function (e) {
      return o[e];
    }.bind(null, t));
    return n;
  }, r.n = function (e) {
    var o = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return r.d(o, "a", o), o;
  }, r.o = function (e, o) {
    return Object.prototype.hasOwnProperty.call(e, o);
  }, r.p = "", r(r.s = 186);
}([function (e, o) {
  e.exports = require("react");
}, function (e, o) {
  e.exports = require("classnames");
}, function (e, o, n) {
  "use strict";

  Object.defineProperty(o, "__esModule", {
    value: !0
  }), o.getHtmlAttributes = function (e) {
    return {
      id: e.id,
      style: e.style
    };
  };
}, function (e, o, n) {
  "use strict";

  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var t = n(0).createContext("light");
  o.ThemeContext = t;
}, function (e, n, o) {
  "use strict";

  Object.defineProperty(n, "__esModule", {
    value: !0
  }), function (e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }(o(7));
}, function (e, o) {
  var a = {
      xxs: "2px",
      xs: "4px",
      s: "8px",
      m: "16px",
      l: "32px",
      xl: "64px",
      xxl: "128px"
    },
    _ = {
      smallHeight: "1rem",
      mediumHeight: "16px",
      largeHeight: "2rem"
    },
    l = {
      "small-text": "12px",
      "default-text": "14px",
      "small-heading-text": "16px",
      "medium-heading-text": "18px",
      "large-heading-text": "24px",
      "extra-large-text": "40px"
    },
    s = {
      light: "100",
      regular: "400",
      medium: "500",
      bold: "700"
    },
    c = {
      iconFontSmall: "ABB-UI-Icons-16x16",
      iconFontMedium: "ABB-UI-Icons-24x24",
      iconFontLarge: "ABB-UI-Icons-32x32",
      defaultFont: "ABB Voice",
      backupFont: "Arial"
    },
    b = {
      "color-accent-10": "#E0F0FF",
      "color-accent-20": "#C5E0FA",
      "color-accent-30": "#9EBFF7",
      "color-accent-40": "#77A3FC",
      "color-accent-50": "#4C85FF",
      "color-accent-60": "#3366FF",
      "color-accent-70": "#2A35FF",
      "color-accent-80": "#2C20D4",
      "color-accent-90": "#160C9C",
      "color-accent-100": "#080261",
      "color-action-10": "#E8F4FF",
      "color-action-20": "#DBEDFF",
      "color-action-30": "#B4D0FF",
      "color-action-40": "#7EA8FF",
      "color-action-50": "#4580FF",
      "color-action-60": "#3366FF",
      "color-action-70": "#2A35FF",
      "color-action-80": "#1B0DD8",
      "color-action-90": "#0E048F",
      "color-action-100": "#080261",
      "color-grey-0": "#FFFFFF",
      "color-grey-5": "#F5F5F5",
      "color-grey-10": "#EBEBEB",
      "color-grey-20": "#DBDBDB",
      "color-grey-30": "#BABABA",
      "color-grey-40": "#9F9F9F",
      "color-grey-50": "#848484",
      "color-grey-60": "#686868",
      "color-grey-70": "#525252",
      "color-grey-80": "#3D3D3D",
      "color-grey-85": "#2E2E2E",
      "color-grey-90": "#1F1F1F",
      "color-grey-95": "#171717",
      "color-grey-100": "#0F0F0F",
      "color-grey-110": "#000000",
      "abb-brand-black": "#000000",
      "abb-purple-10": "#FAE3FA",
      "abb-purple-20": "#FAC5FA",
      "abb-purple-30": "#F291F2",
      "abb-purple-40": "#E670E6",
      "abb-purple-50": "#CC50CC",
      "abb-purple-60": "#A13FA1",
      "abb-purple-70": "#8F188F",
      "abb-purple-80": "#7A097A",
      "abb-purple-90": "#4A014A",
      "abb-purple-100": "#240024",
      "abb-magenta-10": "#FFE3F0",
      "abb-magenta-20": "#FFC7E4",
      "abb-magenta-30": "#FF94C9",
      "abb-magenta-40": "#FF6BB5",
      "abb-magenta-50": "#E64997",
      "abb-magenta-60": "#C2347B",
      "abb-magenta-70": "#A8135D",
      "abb-magenta-80": "#820D48",
      "abb-magenta-90": "#52032A",
      "abb-magenta-100": "#2E0016",
      "abb-blue-10": "#DEF4FA",
      "abb-blue-20": "#B3E6FF",
      "abb-blue-30": "#6CD5FF",
      "abb-blue-40": "#2FC8F7",
      "abb-blue-50": "#00ACEC",
      "abb-blue-60": "#1B7AC2",
      "abb-blue-70": "#005CA3",
      "abb-blue-80": "#004480",
      "abb-blue-90": "#00284A",
      "abb-blue-100": "#031324",
      "abb-teal-10": "#D7F7F3",
      "abb-teal-20": "#B5EBE2",
      "abb-teal-30": "#7ED6C6",
      "abb-teal-40": "#5ABFAE",
      "abb-teal-50": "#3DA190",
      "abb-teal-60": "#3B786E",
      "abb-teal-70": "#195C50",
      "abb-teal-80": "#16453D",
      "abb-teal-90": "#092923",
      "abb-teal-100": "#001712",
      "abb-green-10": "#E2F7DF",
      "abb-green-20": "#BFEDBB",
      "abb-green-30": "#98D694",
      "abb-green-40": "#75BA70",
      "abb-green-50": "#51A34B",
      "abb-green-60": "#477A43",
      "abb-green-70": "#1E6119",
      "abb-green-80": "#1B4718",
      "abb-green-90": "#10290E",
      "abb-green-100": "#011A00",
      "abb-yellow-10": "#FAF5B6",
      "abb-yellow-20": "#EDE56F",
      "abb-yellow-30": "#D6C918",
      "abb-yellow-40": "#B5AA0D",
      "abb-yellow-50": "#968D0B",
      "abb-yellow-60": "#756E09",
      "abb-yellow-70": "#524C00",
      "abb-yellow-80": "#3B3813",
      "abb-yellow-90": "#242102",
      "abb-yellow-100": "#121101",
      "abb-gold-10": "#FFEDDB",
      "abb-gold-20": "#FFD3A8",
      "abb-gold-30": "#F2AC66",
      "abb-gold-40": "#D98F45",
      "abb-gold-50": "#C27121",
      "abb-gold-60": "#A65503",
      "abb-gold-70": "#753B00",
      "abb-gold-80": "#542C04",
      "abb-gold-90": "#331B02",
      "abb-gold-100": "#1A0E00",
      "abb-orange-10": "#FFEAE8",
      "abb-orange-20": "#FFCEC4",
      "abb-orange-30": "#FF9F8C",
      "abb-orange-40": "#F57C64",
      "abb-orange-50": "#ED5739",
      "abb-orange-60": "#D93616",
      "abb-orange-70": "#A82005",
      "abb-orange-80": "#751A08",
      "abb-orange-90": "#4D0D00",
      "abb-orange-100": "#290700",
      "abb-red-10": "#FFE8EA",
      "abb-red-20": "#FFC9CD",
      "abb-red-30": "#FF99A0",
      "abb-red-40": "#FF757E",
      "abb-red-50": "#FF4754",
      "abb-red-60": "#E12E2E",
      "abb-red-70": "#CC0815",
      "abb-red-80": "#A30005",
      "abb-red-90": "#5C0006",
      "abb-red-100": "#3E0000",
      "abb-alarm-yellow": "#FFD800",
      "abb-alarm-orange": "#FF7300",
      "abb-alarm-red": "#F03040",
      "abb-alarm-magenta": "#CB2BD5",
      "abb-alarm-blue": "#3366FF",
      "abb-alarm-green": "#0CA919",
      "color-state-ok": "#329A5D",
      "color-state-warning": "#FF7300",
      "color-state-error": "#F03040",
      "color-state-unknown": "#848484",
      "color-state-notice": "#FFD800"
    },
    m = {
      "abb-brand-red": "#ff000f",
      "color-action-light": b["color-action-60"],
      "color-action-light-hover": b["color-action-70"],
      "color-action-light-pressed": b["color-action-80"],
      "color-action-light-disabled": b["color-action-50"],
      "color-accent-light": b["color-accent-60"],
      "color-accent-light-hover": b["color-accent-70"],
      "color-accent-light-pressed": b["color-accent-80"],
      "color-accent-light-disabled": b["color-accent-50"],
      "color-action-dark": b["color-action-60"],
      "color-action-dark-hover": b["color-action-50"],
      "color-action-dark-pressed": b["color-action-40"],
      "color-action-dark-disabled": b["color-action-70"],
      "color-accent-dark": b["color-accent-60"],
      "color-accent-dark-hover": b["color-accent-50"],
      "color-accent-dark-pressed": b["color-accent-40"],
      "color-accent-dark-disabled": b["color-accent-70"],
      "color-content-background-light": b["color-grey-0"],
      "color-content-background-dark": b["color-grey-85"],
      "color-app-background-light": b["color-grey-10"],
      "color-app-background-dark": b["color-grey-100"],
      "abb-bar-background": b["color-grey-90"],
      "primary-text-on-light": b["color-grey-90"],
      "secondary-text-on-light": b["color-grey-60"],
      "primary-text-on-dark": b["color-grey-20"],
      "secondary-text-on-dark": b["color-grey-50"],
      "text-on-color": b["color-grey-0"],
      "input-border-on-light": b["color-grey-30"],
      "input-border-on-light-hover": b["color-grey-40"],
      "input-border-on-light-pressed": b["color-grey-50"],
      "input-bg-on-light": b["color-grey-0"],
      "input-bg-on-light-hover": b["color-grey-10"],
      "input-bg-on-light-pressed": b["color-grey-20"],
      "input-bg-on-dark": b["color-grey-90"],
      "input-bg-on-dark-hover": b["color-grey-80"],
      "input-bg-on-dark-pressed": b["color-grey-70"],
      "input-border-on-dark": b["color-grey-70"],
      "input-border-on-dark-hover": b["color-grey-60"],
      "input-border-on-dark-pressed": b["color-grey-50"],
      "button-bg-on-light": b["color-grey-20"],
      "button-bg-on-light-hover": b["color-grey-30"],
      "button-bg-on-light-pressed": b["color-grey-40"],
      "button-border-on-light": b["color-grey-40"],
      "button-border-on-light-hover": b["color-grey-50"],
      "button-border-on-light-pressed": b["color-grey-60"],
      "button-bg-on-dark": b["color-grey-70"],
      "button-bg-on-dark-hover": b["color-grey-60"],
      "button-bg-on-dark-pressed": b["color-grey-50"],
      "button-border-on-dark": b["color-grey-50"],
      "button-border-on-dark-hover": b["color-grey-40"],
      "button-border-on-dark-pressed": b["color-grey-30"]
    },
    p = {
      "transition-curve": "cubic-bezier(0.18, 0.24, 0.29, 0.96)",
      "transition-l": "500ms cubic-bezier(0.18, 0.24, 0.29, 0.96)",
      "transition-m": "400ms cubic-bezier(0.18, 0.24, 0.29, 0.96)",
      "transition-s": "300ms cubic-bezier(0.18, 0.24, 0.29, 0.96)",
      "transition-xs": "200ms cubic-bezier(0.18, 0.24, 0.29, 0.96)"
    },
    u = {
      "transparent-on-light": "rgba(" + m["color-content-background-dark"] + ", 0)",
      "half-opacity-on-light": "rgba(" + m["color-content-background-dark"] + ", 0.5)",
      "full-opacity-on-light": m["color-content-background-light"],
      "transparent-on-dark": "rgba(" + m["color-content-background-dark"] + ", 0)",
      "half-opacity-on-dark": "rgba(" + m["color-app-background-dark"] + ", 0.5)",
      "full-opacity-on-dark": m["color-content-background-dark"]
    },
    d = {
      "icon-s": "16px",
      "icon-m": "24px",
      "icon-l": "32px"
    },
    h = {
      borderRadius: "4px",
      elementSmall: "32px",
      elementMedium: "40px",
      elementLarge: "48px"
    },
    B = {
      appHeaderZIndex: 2,
      dialogOverlayZIndex: 1e3,
      popupOverlayZIndex: 999,
      popupContainerZIndex: 1e3
    };
  e.exports = {
    getVariables: function getVariables() {
      var e = [];
      for (var o in b) {
        if ((t = {})[o] = b[o], "#" !== b[o][0]) {
          var n = "Invalid color code: " + o + " --\x3e " + b[o];
          throw console.log(n), new Error(n);
        }
        e.push(t);
      }
      for (var o in m) (t = {})[o] = m[o], e.push(t);
      for (var o in a) (t = {})[o] = a[o], e.push(t);
      for (var o in l) (t = {})[o] = l[o], e.push(t);
      for (var o in _) (t = {})[o] = _[o], e.push(t);
      for (var o in p) (t = {})[o] = p[o], e.push(t);
      for (var o in u) (t = {})[o] = u[o], e.push(t);
      for (var o in d) (t = {})[o] = d[o], e.push(t);
      for (var o in h) (t = {})[o] = h[o], e.push(t);
      for (var o in B) (t = {})[o] = B[o], e.push(t);
      for (var o in s) (t = {})[o] = s[o], e.push(t);
      for (var o in c) (t = {})[o] = c[o], e.push(t);
      e.push({
        "font-size": "13px"
      });
      for (var t = {}, r = 0; r < e.length; r++) {
        var i = Object.keys(e[r])[0];
        t[i] = e[r][i];
      }
      return t;
    }
  };
}, function (e, o, n) {
  "use strict";

  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var t = {
      deprecation: [],
      experimental: []
    },
    r = !1;
  o.suppressDeprecationWarnings = function (e) {
    void 0 === e && (e = !0), r = e;
  };
  var i = !(o.showDeprecationWarning = function (e, o) {
    if (void 0 === o && (o = "This component is deprecated, do not use it: "), !r && -1 === t.deprecation.indexOf(e)) {
      t.deprecation.push(e);
      var n = o + e;
      console.error(n);
    }
  });
  o.suppressExperimentalWarnings = function (e) {
    void 0 === e && (e = !0), i = e;
  }, o.showExperimentalWarning = function (e, o) {
    if (void 0 === o && (o = "This component is experimental, do not use it yet for production: "), !i && -1 === t.experimental.indexOf(e)) {
      t.experimental.push(e);
      var n = o + e;
      console.error(n);
    }
  };
}, function (e, o, n) {
  "use strict";

  var _t,
    r = this && this.__extends || (_t = function t(e, o) {
      return (_t = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    B = this && this.__assign || function () {
      return (B = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var A = n(0),
    C = n(1),
    f = n(2),
    y = n(5).getVariables(),
    i = n(8),
    a = n(9),
    _ = n(10),
    g = n(11),
    v = {
      16: i,
      24: a,
      32: _
    },
    U = {
      small: "16",
      medium: "24",
      large: "32"
    };
  function l(e) {
    return e.toLowerCase();
  }
  function s(e) {
    return e.toUpperCase();
  }
  function X(e) {
    return e.replace(/\-/g, " ").replace(/\_/g, " ").replace(/\s[a-z]/g, s).replace(/\s+/g, "").replace(/^[A-Z]/g, l);
  }
  var c = function (o) {
    function e(e) {
      return o.call(this, e) || this;
    }
    return r(e, o), e.prototype.render = function () {
      var e = this.props,
        o = e.onClick,
        n = e.style,
        t = e.sizeClass,
        r = e.className,
        i = e.color;
      if ("string" != typeof this.props.name) throw new Error("Invalid icon name specification: name must be a string");
      if (this.props.name && -1 === this.props.name.indexOf("/") && "empty" !== this.props.name) throw new Error('Invalid icon name specification (must include family and icon, separated with "/", OR one of the following special icons: [empty])');
      var a = this.props.name + "/",
        _ = U[t] || U.medium,
        l = a.split("/"),
        s = l[0],
        c = l[1],
        b = _ + "px",
        m = i ? {
          color: y[i] || i
        } : {},
        p = B({
          display: "inline-block",
          width: b,
          height: b,
          fontSize: b
        }, m, n),
        u = [g.root];
      if (r && u.push(r), a && "empty" !== s) {
        if (0 !== a.indexOf("abb/")) throw new Error("Invalid icon set. Use one of: [abb]");
        var d = v[_];
        u.push(d[X("icon_abb_" + _)]);
        var h = d[X("icon-abb_" + c + "_" + _)];
        if (!h) throw new Error("Icon not found: " + c);
        return u.push(h), A.createElement("i", B({}, f.getHtmlAttributes(this.props), {
          className: C(u),
          onClick: o,
          style: B({}, p)
        }));
      }
      return A.createElement("i", B({}, f.getHtmlAttributes(this.props), {
        className: r,
        onClick: o,
        style: B({
          display: "inline-block"
        }, p)
      }));
    }, e.defaultProps = {
      style: {},
      sizeClass: "small",
      onClick: function onClick(e) {}
    }, e;
  }(A.Component);
  o.Icon = c, o.default = c;
}, function (e, o, n) {
  e.exports = {
    iconAbb16: "ABB_CommonUX_style__icon_abb_16",
    iconAbbAddUser16: "ABB_CommonUX_style__icon-abb_add-user_16",
    iconAbbAlarmBell16: "ABB_CommonUX_style__icon-abb_alarm-bell_16",
    iconAbbAlignBottom16: "ABB_CommonUX_style__icon-abb_align-bottom_16",
    iconAbbAlignHorizontalCenter16: "ABB_CommonUX_style__icon-abb_align-horizontal-center_16",
    iconAbbAlignLeft16: "ABB_CommonUX_style__icon-abb_align-left_16",
    iconAbbAlignRight16: "ABB_CommonUX_style__icon-abb_align-right_16",
    iconAbbAlignTop16: "ABB_CommonUX_style__icon-abb_align-top_16",
    iconAbbAlignVerticalCenter16: "ABB_CommonUX_style__icon-abb_align-vertical-center_16",
    iconAbbAnalyzeDocument16: "ABB_CommonUX_style__icon-abb_analyze-document_16",
    iconAbbAnchor16: "ABB_CommonUX_style__icon-abb_anchor_16",
    iconAbbAudioOff16: "ABB_CommonUX_style__icon-abb_audio-off_16",
    iconAbbAudioOn16: "ABB_CommonUX_style__icon-abb_audio-on_16",
    iconAbbBackground16: "ABB_CommonUX_style__icon-abb_background_16",
    iconAbbBarChart16: "ABB_CommonUX_style__icon-abb_bar-chart_16",
    iconAbbBatteryCharging16: "ABB_CommonUX_style__icon-abb_battery-charging_16",
    iconAbbBatteryEmpty16: "ABB_CommonUX_style__icon-abb_battery-empty_16",
    iconAbbBatteryFull16: "ABB_CommonUX_style__icon-abb_battery-full_16",
    iconAbbBatteryHalf16: "ABB_CommonUX_style__icon-abb_battery-half_16",
    iconAbbBatteryHigh16: "ABB_CommonUX_style__icon-abb_battery-high_16",
    iconAbbBatteryLow16: "ABB_CommonUX_style__icon-abb_battery-low_16",
    iconAbbBinaryData16: "ABB_CommonUX_style__icon-abb_binary-data_16",
    iconAbbBluetooth16: "ABB_CommonUX_style__icon-abb_bluetooth_16",
    iconAbbBoolean16: "ABB_CommonUX_style__icon-abb_boolean_16",
    iconAbbBriefcase16: "ABB_CommonUX_style__icon-abb_briefcase_16",
    iconAbbBringToFront16: "ABB_CommonUX_style__icon-abb_bring-to-front_16",
    iconAbbBroadcast16: "ABB_CommonUX_style__icon-abb_broadcast_16",
    iconAbbCalculator16: "ABB_CommonUX_style__icon-abb_calculator_16",
    iconAbbCalendar16: "ABB_CommonUX_style__icon-abb_calendar_16",
    iconAbbCall16: "ABB_CommonUX_style__icon-abb_call_16",
    iconAbbCamera16: "ABB_CommonUX_style__icon-abb_camera_16",
    iconAbbCart16: "ABB_CommonUX_style__icon-abb_cart_16",
    iconAbbCertificateDocument116: "ABB_CommonUX_style__icon-abb_certificate-document-1_16",
    iconAbbCertificateDocument216: "ABB_CommonUX_style__icon-abb_certificate-document-2_16",
    iconAbbChat16: "ABB_CommonUX_style__icon-abb_chat_16",
    iconAbbCheckMark16: "ABB_CommonUX_style__icon-abb_check-mark_16",
    iconAbbCheckMarkCircle116: "ABB_CommonUX_style__icon-abb_check-mark-circle-1_16",
    iconAbbCheckMarkCircle216: "ABB_CommonUX_style__icon-abb_check-mark-circle-2_16",
    iconAbbClose16: "ABB_CommonUX_style__icon-abb_close_16",
    iconAbbComment16: "ABB_CommonUX_style__icon-abb_comment_16",
    iconAbbComputer16: "ABB_CommonUX_style__icon-abb_computer_16",
    iconAbbConnect16: "ABB_CommonUX_style__icon-abb_connect_16",
    iconAbbControllerCabinet16: "ABB_CommonUX_style__icon-abb_controller-cabinet_16",
    iconAbbControlsAndSettings16: "ABB_CommonUX_style__icon-abb_controls-and-settings_16",
    iconAbbCopy16: "ABB_CommonUX_style__icon-abb_copy_16",
    iconAbbCut16: "ABB_CommonUX_style__icon-abb_cut_16",
    iconAbbDashboard16: "ABB_CommonUX_style__icon-abb_dashboard_16",
    iconAbbDatabase16: "ABB_CommonUX_style__icon-abb_database_16",
    iconAbbDatabaseNew16: "ABB_CommonUX_style__icon-abb_database-new_16",
    iconAbbDecimal16: "ABB_CommonUX_style__icon-abb_decimal_16",
    iconAbbDevices16: "ABB_CommonUX_style__icon-abb_devices_16",
    iconAbbDisconnect16: "ABB_CommonUX_style__icon-abb_disconnect_16",
    iconAbbDistribution16: "ABB_CommonUX_style__icon-abb_distribution_16",
    iconAbbDocument16: "ABB_CommonUX_style__icon-abb_document_16",
    iconAbbDollar16: "ABB_CommonUX_style__icon-abb_dollar_16",
    iconAbbDoubleDown16: "ABB_CommonUX_style__icon-abb_double-down_16",
    iconAbbDoubleLeft16: "ABB_CommonUX_style__icon-abb_double-left_16",
    iconAbbDoubleRight16: "ABB_CommonUX_style__icon-abb_double-right_16",
    iconAbbDoubleUp16: "ABB_CommonUX_style__icon-abb_double-up_16",
    iconAbbDown16: "ABB_CommonUX_style__icon-abb_down_16",
    iconAbbDownArrow16: "ABB_CommonUX_style__icon-abb_down-arrow_16",
    iconAbbDownload16: "ABB_CommonUX_style__icon-abb_download_16",
    iconAbbDrive16: "ABB_CommonUX_style__icon-abb_drive_16",
    iconAbbEdit16: "ABB_CommonUX_style__icon-abb_edit_16",
    iconAbbEndCall16: "ABB_CommonUX_style__icon-abb_end-call_16",
    iconAbbEnvelope16: "ABB_CommonUX_style__icon-abb_envelope_16",
    iconAbbErrorCircle116: "ABB_CommonUX_style__icon-abb_error-circle-1_16",
    iconAbbErrorCircle216: "ABB_CommonUX_style__icon-abb_error-circle-2_16",
    iconAbbEuro16: "ABB_CommonUX_style__icon-abb_euro_16",
    iconAbbEvent16: "ABB_CommonUX_style__icon-abb_event_16",
    iconAbbExport16: "ABB_CommonUX_style__icon-abb_export_16",
    iconAbbFactory16: "ABB_CommonUX_style__icon-abb_factory_16",
    iconAbbFilter16: "ABB_CommonUX_style__icon-abb_filter_16",
    iconAbbFolder16: "ABB_CommonUX_style__icon-abb_folder_16",
    iconAbbFolderNew16: "ABB_CommonUX_style__icon-abb_folder-new_16",
    iconAbbFolderOpen16: "ABB_CommonUX_style__icon-abb_folder-open_16",
    iconAbbForward16: "ABB_CommonUX_style__icon-abb_forward_16",
    iconAbbFullscreen16: "ABB_CommonUX_style__icon-abb_fullscreen_16",
    iconAbbGauge16: "ABB_CommonUX_style__icon-abb_gauge_16",
    iconAbbGbp16: "ABB_CommonUX_style__icon-abb_gbp_16",
    iconAbbGlobe16: "ABB_CommonUX_style__icon-abb_globe_16",
    iconAbbGroup16: "ABB_CommonUX_style__icon-abb_group_16",
    iconAbbHelpCircle116: "ABB_CommonUX_style__icon-abb_help-circle-1_16",
    iconAbbHelpCircle216: "ABB_CommonUX_style__icon-abb_help-circle-2_16",
    iconAbbHide16: "ABB_CommonUX_style__icon-abb_hide_16",
    iconAbbHistory16: "ABB_CommonUX_style__icon-abb_history_16",
    iconAbbHome16: "ABB_CommonUX_style__icon-abb_home_16",
    iconAbbHourGlass16: "ABB_CommonUX_style__icon-abb_hour-glass_16",
    iconAbbImage16: "ABB_CommonUX_style__icon-abb_image_16",
    iconAbbImport16: "ABB_CommonUX_style__icon-abb_import_16",
    iconAbbInformationCircle116: "ABB_CommonUX_style__icon-abb_information-circle-1_16",
    iconAbbInformationCircle216: "ABB_CommonUX_style__icon-abb_information-circle-2_16",
    iconAbbKey16: "ABB_CommonUX_style__icon-abb_key_16",
    iconAbbLabel16: "ABB_CommonUX_style__icon-abb_label_16",
    iconAbbLeft16: "ABB_CommonUX_style__icon-abb_left_16",
    iconAbbLeftArrow16: "ABB_CommonUX_style__icon-abb_left-arrow_16",
    iconAbbLevel16: "ABB_CommonUX_style__icon-abb_level_16",
    iconAbbLightBulb16: "ABB_CommonUX_style__icon-abb_light-bulb_16",
    iconAbbLink16: "ABB_CommonUX_style__icon-abb_link_16",
    iconAbbList16: "ABB_CommonUX_style__icon-abb_list_16",
    iconAbbLocation16: "ABB_CommonUX_style__icon-abb_location_16",
    iconAbbLockClosed16: "ABB_CommonUX_style__icon-abb_lock-closed_16",
    iconAbbLockOpen16: "ABB_CommonUX_style__icon-abb_lock-open_16",
    iconAbbLogIn16: "ABB_CommonUX_style__icon-abb_log-in_16",
    iconAbbLogOut16: "ABB_CommonUX_style__icon-abb_log-out_16",
    iconAbbMagnet16: "ABB_CommonUX_style__icon-abb_magnet_16",
    iconAbbMakeSameHeight16: "ABB_CommonUX_style__icon-abb_make-same-height_16",
    iconAbbMakeSameSize16: "ABB_CommonUX_style__icon-abb_make-same-size_16",
    iconAbbMakeSameWidth16: "ABB_CommonUX_style__icon-abb_make-same-width_16",
    iconAbbMap16: "ABB_CommonUX_style__icon-abb_map_16",
    iconAbbMatrix16: "ABB_CommonUX_style__icon-abb_matrix_16",
    iconAbbMaximize16: "ABB_CommonUX_style__icon-abb_maximize_16",
    iconAbbMenu16: "ABB_CommonUX_style__icon-abb_menu_16",
    iconAbbMenuNarrow16: "ABB_CommonUX_style__icon-abb_menu-narrow_16",
    iconAbbMicrophone16: "ABB_CommonUX_style__icon-abb_microphone_16",
    iconAbbMicrophoneOff16: "ABB_CommonUX_style__icon-abb_microphone-off_16",
    iconAbbMinimize16: "ABB_CommonUX_style__icon-abb_minimize_16",
    iconAbbMinus16: "ABB_CommonUX_style__icon-abb_minus_16",
    iconAbbMinusInCircle16: "ABB_CommonUX_style__icon-abb_minus-in-circle_16",
    iconAbbMissedCall16: "ABB_CommonUX_style__icon-abb_missed-call_16",
    iconAbbMoon16: "ABB_CommonUX_style__icon-abb_moon_16",
    iconAbbMore16: "ABB_CommonUX_style__icon-abb_more_16",
    iconAbbMotor16: "ABB_CommonUX_style__icon-abb_motor_16",
    iconAbbNetwork16: "ABB_CommonUX_style__icon-abb_network_16",
    iconAbbNewDocument16: "ABB_CommonUX_style__icon-abb_new-document_16",
    iconAbbNumericals16: "ABB_CommonUX_style__icon-abb_numericals_16",
    iconAbbObject16: "ABB_CommonUX_style__icon-abb_object_16",
    iconAbbObjectContainer116: "ABB_CommonUX_style__icon-abb_object-container-1_16",
    iconAbbObjectContainer216: "ABB_CommonUX_style__icon-abb_object-container-2_16",
    iconAbbOpenInNewWindow16: "ABB_CommonUX_style__icon-abb_open-in-new-window_16",
    iconAbbPanel16: "ABB_CommonUX_style__icon-abb_panel_16",
    iconAbbPaperClip16: "ABB_CommonUX_style__icon-abb_paper-clip_16",
    iconAbbPaste16: "ABB_CommonUX_style__icon-abb_paste_16",
    iconAbbPause16: "ABB_CommonUX_style__icon-abb_pause_16",
    iconAbbPieChart16: "ABB_CommonUX_style__icon-abb_pie-chart_16",
    iconAbbPin16: "ABB_CommonUX_style__icon-abb_pin_16",
    iconAbbPlay16: "ABB_CommonUX_style__icon-abb_play_16",
    iconAbbPlugin16: "ABB_CommonUX_style__icon-abb_plugin_16",
    iconAbbPlus16: "ABB_CommonUX_style__icon-abb_plus_16",
    iconAbbPlusInCircle16: "ABB_CommonUX_style__icon-abb_plus-in-circle_16",
    iconAbbPopOutWindow16: "ABB_CommonUX_style__icon-abb_pop-out-window_16",
    iconAbbPowerOnOff16: "ABB_CommonUX_style__icon-abb_power-on-off_16",
    iconAbbPressure16: "ABB_CommonUX_style__icon-abb_pressure_16",
    iconAbbPrint16: "ABB_CommonUX_style__icon-abb_print_16",
    iconAbbPump16: "ABB_CommonUX_style__icon-abb_pump_16",
    iconAbbQrCode16: "ABB_CommonUX_style__icon-abb_qr-code_16",
    iconAbbRearrange16: "ABB_CommonUX_style__icon-abb_rearrange_16",
    iconAbbRedo16: "ABB_CommonUX_style__icon-abb_redo_16",
    iconAbbRefresh16: "ABB_CommonUX_style__icon-abb_refresh_16",
    iconAbbReports16: "ABB_CommonUX_style__icon-abb_reports_16",
    iconAbbResistor16: "ABB_CommonUX_style__icon-abb_resistor_16",
    iconAbbRewind16: "ABB_CommonUX_style__icon-abb_rewind_16",
    iconAbbRight16: "ABB_CommonUX_style__icon-abb_right_16",
    iconAbbRightArrow16: "ABB_CommonUX_style__icon-abb_right-arrow_16",
    iconAbbRobot16: "ABB_CommonUX_style__icon-abb_robot_16",
    iconAbbRobotCabinet16: "ABB_CommonUX_style__icon-abb_robot-cabinet_16",
    iconAbbRobotTool16: "ABB_CommonUX_style__icon-abb_robot-tool_16",
    iconAbbRotateLeft9016: "ABB_CommonUX_style__icon-abb_rotate-left-90_16",
    iconAbbRotateLeft18016: "ABB_CommonUX_style__icon-abb_rotate-left-180_16",
    iconAbbRotateRight27016: "ABB_CommonUX_style__icon-abb_rotate-right-270_16",
    iconAbbRotateLeft27016: "ABB_CommonUX_style__icon-abb_rotate-left-270_16",
    iconAbbRotateRight9016: "ABB_CommonUX_style__icon-abb_rotate-right-90_16",
    iconAbbRotateRight18016: "ABB_CommonUX_style__icon-abb_rotate-right-180_16",
    iconAbbSave16: "ABB_CommonUX_style__icon-abb_save_16",
    iconAbbSaveAs16: "ABB_CommonUX_style__icon-abb_save-as_16",
    iconAbbScreen16: "ABB_CommonUX_style__icon-abb_screen_16",
    iconAbbSearch16: "ABB_CommonUX_style__icon-abb_search_16",
    iconAbbSendToBack16: "ABB_CommonUX_style__icon-abb_send-to-back_16",
    iconAbbServer16: "ABB_CommonUX_style__icon-abb_server_16",
    iconAbbSettings16: "ABB_CommonUX_style__icon-abb_settings_16",
    iconAbbShare16: "ABB_CommonUX_style__icon-abb_share_16",
    iconAbbShortcut16: "ABB_CommonUX_style__icon-abb_shortcut_16",
    iconAbbShuffle16: "ABB_CommonUX_style__icon-abb_shuffle_16",
    iconAbbSkipToEnd16: "ABB_CommonUX_style__icon-abb_skip-to-end_16",
    iconAbbSkipToStart16: "ABB_CommonUX_style__icon-abb_skip-to-start_16",
    iconAbbSld116: "ABB_CommonUX_style__icon-abb_sld-1_16",
    iconAbbSld216: "ABB_CommonUX_style__icon-abb_sld-2_16",
    iconAbbSmartphone16: "ABB_CommonUX_style__icon-abb_smartphone_16",
    iconAbbSortAlphabetDown16: "ABB_CommonUX_style__icon-abb_sort-alphabet-down_16",
    iconAbbSortAlphabetUp16: "ABB_CommonUX_style__icon-abb_sort-alphabet-up_16",
    iconAbbSortDateDown116: "ABB_CommonUX_style__icon-abb_sort-date-down-1_16",
    iconAbbSortDateDown216: "ABB_CommonUX_style__icon-abb_sort-date-down-2_16",
    iconAbbSortDateUp116: "ABB_CommonUX_style__icon-abb_sort-date-up-1_16",
    iconAbbSortDateUp216: "ABB_CommonUX_style__icon-abb_sort-date-up-2_16",
    iconAbbSpecification16: "ABB_CommonUX_style__icon-abb_specification_16",
    iconAbbStairs16: "ABB_CommonUX_style__icon-abb_stairs_16",
    iconAbbStar16: "ABB_CommonUX_style__icon-abb_star_16",
    iconAbbStop16: "ABB_CommonUX_style__icon-abb_stop_16",
    iconAbbSun16: "ABB_CommonUX_style__icon-abb_sun_16",
    iconAbbSun216: "ABB_CommonUX_style__icon-abb_sun-2_16",
    iconAbbSynchronize16: "ABB_CommonUX_style__icon-abb_synchronize_16",
    iconAbbSystem16: "ABB_CommonUX_style__icon-abb_system_16",
    iconAbbTable16: "ABB_CommonUX_style__icon-abb_table_16",
    iconAbbTemperature16: "ABB_CommonUX_style__icon-abb_temperature_16",
    iconAbbTemperatureCelsius116: "ABB_CommonUX_style__icon-abb_temperature-celsius-1_16",
    iconAbbTemperatureCelsius216: "ABB_CommonUX_style__icon-abb_temperature-celsius-2_16",
    iconAbbTemperatureFahrenheit116: "ABB_CommonUX_style__icon-abb_temperature-fahrenheit-1_16",
    iconAbbTemperatureFahrenheit216: "ABB_CommonUX_style__icon-abb_temperature-fahrenheit-2_16",
    iconAbbTemplate16: "ABB_CommonUX_style__icon-abb_template_16",
    iconAbbTemplateNew16: "ABB_CommonUX_style__icon-abb_template-new_16",
    iconAbbTest16: "ABB_CommonUX_style__icon-abb_test_16",
    iconAbbText16: "ABB_CommonUX_style__icon-abb_text_16",
    iconAbbTime16: "ABB_CommonUX_style__icon-abb_time_16",
    iconAbbTimeAndDate16: "ABB_CommonUX_style__icon-abb_time-and-date_16",
    iconAbbTrack116: "ABB_CommonUX_style__icon-abb_track-1_16",
    iconAbbTrack216: "ABB_CommonUX_style__icon-abb_track-2_16",
    iconAbbTransformer16: "ABB_CommonUX_style__icon-abb_transformer_16",
    iconAbbTrash16: "ABB_CommonUX_style__icon-abb_trash_16",
    iconAbbTreeView16: "ABB_CommonUX_style__icon-abb_tree-view_16",
    iconAbbTrend116: "ABB_CommonUX_style__icon-abb_trend-1_16",
    iconAbbTrend216: "ABB_CommonUX_style__icon-abb_trend-2_16",
    iconAbbTurbocharger16: "ABB_CommonUX_style__icon-abb_turbocharger_16",
    iconAbbUndo16: "ABB_CommonUX_style__icon-abb_undo_16",
    iconAbbUnpin16: "ABB_CommonUX_style__icon-abb_unpin_16",
    iconAbbUp16: "ABB_CommonUX_style__icon-abb_up_16",
    iconAbbUpArrow16: "ABB_CommonUX_style__icon-abb_up-arrow_16",
    iconAbbUpload16: "ABB_CommonUX_style__icon-abb_upload_16",
    iconAbbUsb16: "ABB_CommonUX_style__icon-abb_usb_16",
    iconAbbUser16: "ABB_CommonUX_style__icon-abb_user_16",
    iconAbbUserInCircle16: "ABB_CommonUX_style__icon-abb_user-in-circle_16",
    iconAbbVideoCameraOff16: "ABB_CommonUX_style__icon-abb_video-camera-off_16",
    iconAbbVideoCameraOn16: "ABB_CommonUX_style__icon-abb_video-camera-on_16",
    iconAbbVideoChat16: "ABB_CommonUX_style__icon-abb_video-chat_16",
    iconAbbView16: "ABB_CommonUX_style__icon-abb_view_16",
    iconAbbVoltage16: "ABB_CommonUX_style__icon-abb_voltage_16",
    iconAbbWarningCircle116: "ABB_CommonUX_style__icon-abb_warning-circle-1_16",
    iconAbbWarningCircle216: "ABB_CommonUX_style__icon-abb_warning-circle-2_16",
    iconAbbWarningTriangle16: "ABB_CommonUX_style__icon-abb_warning-triangle_16",
    iconAbbWrench16: "ABB_CommonUX_style__icon-abb_wrench_16",
    iconAbbZoomIn16: "ABB_CommonUX_style__icon-abb_zoom-in_16",
    iconAbbZoomOut16: "ABB_CommonUX_style__icon-abb_zoom-out_16",
    iconAbbTrend324: "ABB_CommonUX_style__icon-abb_trend-3_24",
    iconAbbTrendScatter24: "ABB_CommonUX_style__icon-abb_trend-scatter_24",
    iconAbbSortAscending16: "ABB_CommonUX_style__icon-abb_sort-ascending_16",
    iconAbbSortDescending16: "ABB_CommonUX_style__icon-abb_sort-descending_16",
    iconAbbAdvancedSettings16: "ABB_CommonUX_style__icon-abb_advanced-settings_16",
    iconAbbAlign16: "ABB_CommonUX_style__icon-abb_align_16",
    iconAbbAxis16: "ABB_CommonUX_style__icon-abb_axis_16",
    iconAbbCalibrationMethods16: "ABB_CommonUX_style__icon-abb_calibration-methods_16",
    iconAbbConnection16: "ABB_CommonUX_style__icon-abb_connection_16",
    iconAbbConnectionStatus16: "ABB_CommonUX_style__icon-abb_connection-status_16",
    iconAbbCreateBackup16: "ABB_CommonUX_style__icon-abb_create-backup_16",
    iconAbbDataEditor16: "ABB_CommonUX_style__icon-abb_data-editor_16",
    iconAbbExecution16: "ABB_CommonUX_style__icon-abb_execution-16",
    iconAbbHardwareDevices16: "ABB_CommonUX_style__icon-abb_hardware-devices_16",
    iconAbbIoDevices16: "ABB_CommonUX_style__icon-abb_io-devices_16",
    iconAbbJoystick16: "ABB_CommonUX_style__icon-abb_joystick-16",
    iconAbbLeadThrough16: "ABB_CommonUX_style__icon-abb_lead-through_16",
    iconAbbJogLinear16: "ABB_CommonUX_style__icon-abb_jog-linear_16",
    iconAbbDocumentExcel16: "ABB_CommonUX_style__icon-abb_document-excel_16",
    iconAbbDocumentPdf16: "ABB_CommonUX_style__icon-abb_document-pdf_16",
    iconAbbDocumentWord16: "ABB_CommonUX_style__icon-abb_document-word_16",
    iconAbbModifyRapidPosition16: "ABB_CommonUX_style__icon-abb_modify-rapid-position_16",
    iconAbbSoftwareModule16: "ABB_CommonUX_style__icon-abb_software-module_16",
    iconAbbNetworkStatus116: "ABB_CommonUX_style__icon-abb_network-status-1_16",
    iconAbbNetworkStatus216: "ABB_CommonUX_style__icon-abb_network-status-2_16",
    iconAbbPayload16: "ABB_CommonUX_style__icon-abb_payload_16",
    iconAbbJogPlanar16: "ABB_CommonUX_style__icon-abb_jog-planar_16",
    iconAbbSoftwareProgramAndModules16: "ABB_CommonUX_style__icon-abb_software-program-and-modules_16",
    iconAbbSoftwareProgramEditor16: "ABB_CommonUX_style__icon-abb_software-program-editor_16",
    iconAbbSoftwareProgram16: "ABB_CommonUX_style__icon-abb_software-program_16",
    iconAbbProgramPointer16: "ABB_CommonUX_style__icon-abb_program-pointer_16",
    iconAbbRapidTasks16: "ABB_CommonUX_style__icon-abb_rapid-tasks_16",
    iconAbbJogReorient16: "ABB_CommonUX_style__icon-abb_jog-reorient_16",
    iconAbbResetUserData16: "ABB_CommonUX_style__icon-abb_reset-user-data_16",
    iconAbbRestoreBackup16: "ABB_CommonUX_style__icon-abb_restore-backup_16",
    iconAbbSelect16: "ABB_CommonUX_style__icon-abb_select_16",
    iconAbbSoftwareRoutins16: "ABB_CommonUX_style__icon-abb_software-routins_16",
    iconAbbNetworkSignalStrengthLevel116: "ABB_CommonUX_style__icon-abb_network-signal-strength-level-1_16",
    iconAbbNetworkSignalStrengthLevel216: "ABB_CommonUX_style__icon-abb_network-signal-strength-level-2_16",
    iconAbbNetworkSignalStrengthLevel316: "ABB_CommonUX_style__icon-abb_network-signal-strength-level-3_16",
    iconAbbIoSignals16: "ABB_CommonUX_style__icon-abb_io-signals_16",
    iconAbbSoftwareResources16: "ABB_CommonUX_style__icon-abb_software-resources_16",
    iconAbbStartInstaller16: "ABB_CommonUX_style__icon-abb_start-installer_16",
    iconAbbStepIn16: "ABB_CommonUX_style__icon-abb_step-in_16",
    iconAbbStepOut16: "ABB_CommonUX_style__icon-abb_step-out_16",
    iconAbbStepOver16: "ABB_CommonUX_style__icon-abb_step-over_16",
    iconAbbTouch16: "ABB_CommonUX_style__icon-abb_touch_16",
    iconAbbVideo16: "ABB_CommonUX_style__icon-abb_video_16",
    iconAbbTurnClockwise16: "ABB_CommonUX_style__icon-abb_turn-clockwise_16",
    iconAbbTurnClockwiseOffTargetSpeed16: "ABB_CommonUX_style__icon-abb_turn-clockwise-off-target-speed_16",
    iconAbbTurnCounterClockwiseOffTargetSpeed16: "ABB_CommonUX_style__icon-abb_turn-counter-clockwise-off-target-speed_16",
    iconAbbAddDrives16: "ABB_CommonUX_style__icon-abb_add-drives_16",
    iconAbbBearing16: "ABB_CommonUX_style__icon-abb_bearing_16",
    iconAbbCloud16: "ABB_CommonUX_style__icon-abb_cloud_16",
    iconAbbDeleteDrives16: "ABB_CommonUX_style__icon-abb_delete-drives_16",
    iconAbbDownloadFromCloud16: "ABB_CommonUX_style__icon-abb_download-from-cloud_16",
    iconAbbDriveConnected16: "ABB_CommonUX_style__icon-abb_drive-connected_16",
    iconAbbDrivesError16: "ABB_CommonUX_style__icon-abb_drives-error_16",
    iconAbbFieldbus16: "ABB_CommonUX_style__icon-abb_fieldbus_16",
    iconAbbGenerator16: "ABB_CommonUX_style__icon-abb_generator_16",
    iconAbbMaximumValue16: "ABB_CommonUX_style__icon-abb_maximum-value_16",
    iconAbbMinimumValue16: "ABB_CommonUX_style__icon-abb_minimum-value_16",
    iconAbbNotAllowed16: "ABB_CommonUX_style__icon-abb_not-allowed_16",
    iconAbbPowertrain16: "ABB_CommonUX_style__icon-abb_powertrain_16",
    iconAbbPreventTurningFault16: "ABB_CommonUX_style__icon-abb_prevent-turning-fault_16",
    iconAbbTargetValueRange16: "ABB_CommonUX_style__icon-abb_target-value-range_16",
    iconAbbThumbnailView16: "ABB_CommonUX_style__icon-abb_thumbnail-view_16",
    iconAbbTrain16: "ABB_CommonUX_style__icon-abb_train_16",
    iconAbbTurnCounterClockwise16: "ABB_CommonUX_style__icon-abb_turn-counter-clockwise_16",
    iconAbbWheel16: "ABB_CommonUX_style__icon-abb_wheel_16",
    iconAbbWifiNetworkDisconnected16: "ABB_CommonUX_style__icon-abb_wifi-network-disconnected_16",
    iconAbbWriteToDefault16: "ABB_CommonUX_style__icon-abb_write-to-default_16",
    iconAbbWriteToDefaultDisabled16: "ABB_CommonUX_style__icon-abb_write-to-default-disabled_16",
    iconAbbCaretDown16: "ABB_CommonUX_style__icon-abb_caret-down_16",
    iconAbbCaretLeft16: "ABB_CommonUX_style__icon-abb_caret-left_16",
    iconAbbCaretRight16: "ABB_CommonUX_style__icon-abb_caret-right_16",
    iconAbbCaretUp16: "ABB_CommonUX_style__icon-abb_caret-up_16",
    iconAbbCloseLight16: "ABB_CommonUX_style__icon-abb_close-light_16",
    iconAbbTriangleDown16: "ABB_CommonUX_style__icon-abb-triangle-down_16",
    iconAbbTriangleLeft16: "ABB_CommonUX_style__icon-abb-triangle-left_16",
    iconAbbTriangleRight16: "ABB_CommonUX_style__icon-abb-triangle-right_16",
    iconAbbTriangleUp16: "ABB_CommonUX_style__icon-abb-triangle-up_16",
    iconAbbCheckMarkLight16: "ABB_CommonUX_style__icon-abb_check-mark-light_16",
    iconAbbNumberedList16: "ABB_CommonUX_style__icon-abb_numbered-list_16",
    iconAbbTextBold16: "ABB_CommonUX_style__icon-abb_text-bold_16",
    iconAbbTextItalic16: "ABB_CommonUX_style__icon-abb_text-italic_16",
    iconAbbTextUnderline16: "ABB_CommonUX_style__icon-abb_text-underline_16"
  };
}, function (e, o, n) {
  e.exports = {
    iconAbb24: "ABB_CommonUX_style__icon_abb_24",
    iconAbbAddUser24: "ABB_CommonUX_style__icon-abb_add-user_24",
    iconAbbAlarmBell24: "ABB_CommonUX_style__icon-abb_alarm-bell_24",
    iconAbbAlignBottom24: "ABB_CommonUX_style__icon-abb_align-bottom_24",
    iconAbbAlignHorizontalCenter24: "ABB_CommonUX_style__icon-abb_align-horizontal-center_24",
    iconAbbAlignLeft24: "ABB_CommonUX_style__icon-abb_align-left_24",
    iconAbbAlignRight24: "ABB_CommonUX_style__icon-abb_align-right_24",
    iconAbbAlignTop24: "ABB_CommonUX_style__icon-abb_align-top_24",
    iconAbbAlignVerticalCenter24: "ABB_CommonUX_style__icon-abb_align-vertical-center_24",
    iconAbbAnalyzeDocument24: "ABB_CommonUX_style__icon-abb_analyze-document_24",
    iconAbbAnchor24: "ABB_CommonUX_style__icon-abb_anchor_24",
    iconAbbAudioOff24: "ABB_CommonUX_style__icon-abb_audio-off_24",
    iconAbbAudioOn24: "ABB_CommonUX_style__icon-abb_audio-on_24",
    iconAbbBackground24: "ABB_CommonUX_style__icon-abb_background_24",
    iconAbbBarChart24: "ABB_CommonUX_style__icon-abb_bar-chart_24",
    iconAbbBatteryCharging24: "ABB_CommonUX_style__icon-abb_battery-charging_24",
    iconAbbBatteryEmpty24: "ABB_CommonUX_style__icon-abb_battery-empty_24",
    iconAbbBatteryFull24: "ABB_CommonUX_style__icon-abb_battery-full_24",
    iconAbbBatteryHalf24: "ABB_CommonUX_style__icon-abb_battery-half_24",
    iconAbbBatteryHigh24: "ABB_CommonUX_style__icon-abb_battery-high_24",
    iconAbbBatteryLow24: "ABB_CommonUX_style__icon-abb_battery-low_24",
    iconAbbBinaryData24: "ABB_CommonUX_style__icon-abb_binary-data_24",
    iconAbbBluetooth24: "ABB_CommonUX_style__icon-abb_bluetooth_24",
    iconAbbBoolean24: "ABB_CommonUX_style__icon-abb_boolean_24",
    iconAbbBriefcase24: "ABB_CommonUX_style__icon-abb_briefcase_24",
    iconAbbBringToFront24: "ABB_CommonUX_style__icon-abb_bring-to-front_24",
    iconAbbBroadcast24: "ABB_CommonUX_style__icon-abb_broadcast_24",
    iconAbbCalculator24: "ABB_CommonUX_style__icon-abb_calculator_24",
    iconAbbCalendar24: "ABB_CommonUX_style__icon-abb_calendar_24",
    iconAbbCall24: "ABB_CommonUX_style__icon-abb_call_24",
    iconAbbCamera24: "ABB_CommonUX_style__icon-abb_camera_24",
    iconAbbCart24: "ABB_CommonUX_style__icon-abb_cart_24",
    iconAbbCertificateDocument124: "ABB_CommonUX_style__icon-abb_certificate-document-1_24",
    iconAbbCertificateDocument224: "ABB_CommonUX_style__icon-abb_certificate-document-2_24",
    iconAbbChat24: "ABB_CommonUX_style__icon-abb_chat_24",
    iconAbbCheckMark24: "ABB_CommonUX_style__icon-abb_check-mark_24",
    iconAbbCheckMarkCircle124: "ABB_CommonUX_style__icon-abb_check-mark-circle-1_24",
    iconAbbCheckMarkCircle224: "ABB_CommonUX_style__icon-abb_check-mark-circle-2_24",
    iconAbbClose24: "ABB_CommonUX_style__icon-abb_close_24",
    iconAbbComment24: "ABB_CommonUX_style__icon-abb_comment_24",
    iconAbbComputer24: "ABB_CommonUX_style__icon-abb_computer_24",
    iconAbbConnect24: "ABB_CommonUX_style__icon-abb_connect_24",
    iconAbbControllerCabinet24: "ABB_CommonUX_style__icon-abb_controller-cabinet_24",
    iconAbbControlsAndSettings24: "ABB_CommonUX_style__icon-abb_controls-and-settings_24",
    iconAbbCopy24: "ABB_CommonUX_style__icon-abb_copy_24",
    iconAbbCut24: "ABB_CommonUX_style__icon-abb_cut_24",
    iconAbbDashboard24: "ABB_CommonUX_style__icon-abb_dashboard_24",
    iconAbbDatabase24: "ABB_CommonUX_style__icon-abb_database_24",
    iconAbbDatabaseNew24: "ABB_CommonUX_style__icon-abb_database-new_24",
    iconAbbDecimal24: "ABB_CommonUX_style__icon-abb_decimal_24",
    iconAbbDevices24: "ABB_CommonUX_style__icon-abb_devices_24",
    iconAbbDisconnect24: "ABB_CommonUX_style__icon-abb_disconnect_24",
    iconAbbDistribution24: "ABB_CommonUX_style__icon-abb_distribution_24",
    iconAbbDocument24: "ABB_CommonUX_style__icon-abb_document_24",
    iconAbbDollar24: "ABB_CommonUX_style__icon-abb_dollar_24",
    iconAbbDoubleDown24: "ABB_CommonUX_style__icon-abb_double-down_24",
    iconAbbDoubleLeft24: "ABB_CommonUX_style__icon-abb_double-left_24",
    iconAbbDoubleRight24: "ABB_CommonUX_style__icon-abb_double-right_24",
    iconAbbDoubleUp24: "ABB_CommonUX_style__icon-abb_double-up_24",
    iconAbbDown24: "ABB_CommonUX_style__icon-abb_down_24",
    iconAbbDownArrow24: "ABB_CommonUX_style__icon-abb_down-arrow_24",
    iconAbbDownload24: "ABB_CommonUX_style__icon-abb_download_24",
    iconAbbDrive24: "ABB_CommonUX_style__icon-abb_drive_24",
    iconAbbEdit24: "ABB_CommonUX_style__icon-abb_edit_24",
    iconAbbEndCall24: "ABB_CommonUX_style__icon-abb_end-call_24",
    iconAbbEnvelope24: "ABB_CommonUX_style__icon-abb_envelope_24",
    iconAbbErrorCircle124: "ABB_CommonUX_style__icon-abb_error-circle-1_24",
    iconAbbErrorCircle224: "ABB_CommonUX_style__icon-abb_error-circle-2_24",
    iconAbbEuro24: "ABB_CommonUX_style__icon-abb_euro_24",
    iconAbbEvent24: "ABB_CommonUX_style__icon-abb_event_24",
    iconAbbExport24: "ABB_CommonUX_style__icon-abb_export_24",
    iconAbbFactory24: "ABB_CommonUX_style__icon-abb_factory_24",
    iconAbbFilter24: "ABB_CommonUX_style__icon-abb_filter_24",
    iconAbbFolder24: "ABB_CommonUX_style__icon-abb_folder_24",
    iconAbbFolderNew24: "ABB_CommonUX_style__icon-abb_folder-new_24",
    iconAbbFolderOpen24: "ABB_CommonUX_style__icon-abb_folder-open_24",
    iconAbbForward24: "ABB_CommonUX_style__icon-abb_forward_24",
    iconAbbFullscreen24: "ABB_CommonUX_style__icon-abb_fullscreen_24",
    iconAbbGauge24: "ABB_CommonUX_style__icon-abb_gauge_24",
    iconAbbGbp24: "ABB_CommonUX_style__icon-abb_gbp_24",
    iconAbbGlobe24: "ABB_CommonUX_style__icon-abb_globe_24",
    iconAbbGroup24: "ABB_CommonUX_style__icon-abb_group_24",
    iconAbbHelpCircle124: "ABB_CommonUX_style__icon-abb_help-circle-1_24",
    iconAbbHelpCircle224: "ABB_CommonUX_style__icon-abb_help-circle-2_24",
    iconAbbHide24: "ABB_CommonUX_style__icon-abb_hide_24",
    iconAbbHistory24: "ABB_CommonUX_style__icon-abb_history_24",
    iconAbbHome24: "ABB_CommonUX_style__icon-abb_home_24",
    iconAbbHourGlass24: "ABB_CommonUX_style__icon-abb_hour-glass_24",
    iconAbbImage24: "ABB_CommonUX_style__icon-abb_image_24",
    iconAbbImport24: "ABB_CommonUX_style__icon-abb_import_24",
    iconAbbInformationCircle124: "ABB_CommonUX_style__icon-abb_information-circle-1_24",
    iconAbbInformationCircle224: "ABB_CommonUX_style__icon-abb_information-circle-2_24",
    iconAbbKey24: "ABB_CommonUX_style__icon-abb_key_24",
    iconAbbLabel24: "ABB_CommonUX_style__icon-abb_label_24",
    iconAbbLeft24: "ABB_CommonUX_style__icon-abb_left_24",
    iconAbbLeftArrow24: "ABB_CommonUX_style__icon-abb_left-arrow_24",
    iconAbbLevel24: "ABB_CommonUX_style__icon-abb_level_24",
    iconAbbLightBulb24: "ABB_CommonUX_style__icon-abb_light-bulb_24",
    iconAbbLink24: "ABB_CommonUX_style__icon-abb_link_24",
    iconAbbList24: "ABB_CommonUX_style__icon-abb_list_24",
    iconAbbLocation24: "ABB_CommonUX_style__icon-abb_location_24",
    iconAbbLockClosed24: "ABB_CommonUX_style__icon-abb_lock-closed_24",
    iconAbbLockOpen24: "ABB_CommonUX_style__icon-abb_lock-open_24",
    iconAbbLogIn24: "ABB_CommonUX_style__icon-abb_log-in_24",
    iconAbbLogOut24: "ABB_CommonUX_style__icon-abb_log-out_24",
    iconAbbMagnet24: "ABB_CommonUX_style__icon-abb_magnet_24",
    iconAbbMakeSameHeight24: "ABB_CommonUX_style__icon-abb_make-same-height_24",
    iconAbbMakeSameSize24: "ABB_CommonUX_style__icon-abb_make-same-size_24",
    iconAbbMakeSameWidth24: "ABB_CommonUX_style__icon-abb_make-same-width_24",
    iconAbbMap24: "ABB_CommonUX_style__icon-abb_map_24",
    iconAbbMatrix24: "ABB_CommonUX_style__icon-abb_matrix_24",
    iconAbbMaximize24: "ABB_CommonUX_style__icon-abb_maximize_24",
    iconAbbMenu24: "ABB_CommonUX_style__icon-abb_menu_24",
    iconAbbMenuNarrow24: "ABB_CommonUX_style__icon-abb_menu-narrow_24",
    iconAbbMicrophone24: "ABB_CommonUX_style__icon-abb_microphone_24",
    iconAbbMicrophoneOff24: "ABB_CommonUX_style__icon-abb_microphone-off_24",
    iconAbbMinimize24: "ABB_CommonUX_style__icon-abb_minimize_24",
    iconAbbMinus24: "ABB_CommonUX_style__icon-abb_minus_24",
    iconAbbMinusInCircle24: "ABB_CommonUX_style__icon-abb_minus-in-circle_24",
    iconAbbMissedCall24: "ABB_CommonUX_style__icon-abb_missed-call_24",
    iconAbbMoon24: "ABB_CommonUX_style__icon-abb_moon_24",
    iconAbbMore24: "ABB_CommonUX_style__icon-abb_more_24",
    iconAbbMotor24: "ABB_CommonUX_style__icon-abb_motor_24",
    iconAbbNetwork24: "ABB_CommonUX_style__icon-abb_network_24",
    iconAbbNewDocument24: "ABB_CommonUX_style__icon-abb_new-document_24",
    iconAbbNumericals24: "ABB_CommonUX_style__icon-abb_numericals_24",
    iconAbbObject24: "ABB_CommonUX_style__icon-abb_object_24",
    iconAbbObjectContainer124: "ABB_CommonUX_style__icon-abb_object-container-1_24",
    iconAbbObjectContainer224: "ABB_CommonUX_style__icon-abb_object-container-2_24",
    iconAbbOpenInNewWindow24: "ABB_CommonUX_style__icon-abb_open-in-new-window_24",
    iconAbbPanel24: "ABB_CommonUX_style__icon-abb_panel_24",
    iconAbbPaperClip24: "ABB_CommonUX_style__icon-abb_paper-clip_24",
    iconAbbPaste24: "ABB_CommonUX_style__icon-abb_paste_24",
    iconAbbPause24: "ABB_CommonUX_style__icon-abb_pause_24",
    iconAbbPieChart24: "ABB_CommonUX_style__icon-abb_pie-chart_24",
    iconAbbPin24: "ABB_CommonUX_style__icon-abb_pin_24",
    iconAbbPlay24: "ABB_CommonUX_style__icon-abb_play_24",
    iconAbbPlugin24: "ABB_CommonUX_style__icon-abb_plugin_24",
    iconAbbPlus24: "ABB_CommonUX_style__icon-abb_plus_24",
    iconAbbPlusInCircle24: "ABB_CommonUX_style__icon-abb_plus-in-circle_24",
    iconAbbPopOutWindow24: "ABB_CommonUX_style__icon-abb_pop-out-window_24",
    iconAbbPowerOnOff24: "ABB_CommonUX_style__icon-abb_power-on-off_24",
    iconAbbPressure24: "ABB_CommonUX_style__icon-abb_pressure_24",
    iconAbbPrint24: "ABB_CommonUX_style__icon-abb_print_24",
    iconAbbPump24: "ABB_CommonUX_style__icon-abb_pump_24",
    iconAbbQrCode24: "ABB_CommonUX_style__icon-abb_qr-code_24",
    iconAbbRearrange24: "ABB_CommonUX_style__icon-abb_rearrange_24",
    iconAbbRedo24: "ABB_CommonUX_style__icon-abb_redo_24",
    iconAbbRefresh24: "ABB_CommonUX_style__icon-abb_refresh_24",
    iconAbbReports24: "ABB_CommonUX_style__icon-abb_reports_24",
    iconAbbResistor24: "ABB_CommonUX_style__icon-abb_resistor_24",
    iconAbbRewind24: "ABB_CommonUX_style__icon-abb_rewind_24",
    iconAbbRight24: "ABB_CommonUX_style__icon-abb_right_24",
    iconAbbRightArrow24: "ABB_CommonUX_style__icon-abb_right-arrow_24",
    iconAbbRobot24: "ABB_CommonUX_style__icon-abb_robot_24",
    iconAbbRobotCabinet24: "ABB_CommonUX_style__icon-abb_robot-cabinet_24",
    iconAbbRobotTool24: "ABB_CommonUX_style__icon-abb_robot-tool_24",
    iconAbbRotateLeft9024: "ABB_CommonUX_style__icon-abb_rotate-left-90_24",
    iconAbbRotateLeft18024: "ABB_CommonUX_style__icon-abb_rotate-left-180_24",
    iconAbbRotateRight27024: "ABB_CommonUX_style__icon-abb_rotate-right-270_24",
    iconAbbRotateLeft270241: "ABB_CommonUX_style__icon-abb_rotate-left-270_241",
    iconAbbRotateRight9024: "ABB_CommonUX_style__icon-abb_rotate-right-90_24",
    iconAbbRotateRight18024: "ABB_CommonUX_style__icon-abb_rotate-right-180_24",
    iconAbbSave24: "ABB_CommonUX_style__icon-abb_save_24",
    iconAbbSaveAs24: "ABB_CommonUX_style__icon-abb_save-as_24",
    iconAbbScreen24: "ABB_CommonUX_style__icon-abb_screen_24",
    iconAbbSearch24: "ABB_CommonUX_style__icon-abb_search_24",
    iconAbbSendToBack24: "ABB_CommonUX_style__icon-abb_send-to-back_24",
    iconAbbServer24: "ABB_CommonUX_style__icon-abb_server_24",
    iconAbbSettings24: "ABB_CommonUX_style__icon-abb_settings_24",
    iconAbbShare24: "ABB_CommonUX_style__icon-abb_share_24",
    iconAbbShortcut24: "ABB_CommonUX_style__icon-abb_shortcut_24",
    iconAbbShuffle24: "ABB_CommonUX_style__icon-abb_shuffle_24",
    iconAbbSkipToEnd24: "ABB_CommonUX_style__icon-abb_skip-to-end_24",
    iconAbbSkipToStart24: "ABB_CommonUX_style__icon-abb_skip-to-start_24",
    iconAbbSld124: "ABB_CommonUX_style__icon-abb_sld-1_24",
    iconAbbSld224: "ABB_CommonUX_style__icon-abb_sld-2_24",
    iconAbbSmartphone24: "ABB_CommonUX_style__icon-abb_smartphone_24",
    iconAbbSortAlphabetDown24: "ABB_CommonUX_style__icon-abb_sort-alphabet-down_24",
    iconAbbSortAlphabetUp24: "ABB_CommonUX_style__icon-abb_sort-alphabet-up_24",
    iconAbbSortDateDown124: "ABB_CommonUX_style__icon-abb_sort-date-down-1_24",
    iconAbbSortDateDown224: "ABB_CommonUX_style__icon-abb_sort-date-down-2_24",
    iconAbbSortDateUp124: "ABB_CommonUX_style__icon-abb_sort-date-up-1_24",
    iconAbbSortDateUp224: "ABB_CommonUX_style__icon-abb_sort-date-up-2_24",
    iconAbbSpecification24: "ABB_CommonUX_style__icon-abb_specification_24",
    iconAbbStairs24: "ABB_CommonUX_style__icon-abb_stairs_24",
    iconAbbStar24: "ABB_CommonUX_style__icon-abb_star_24",
    iconAbbStop24: "ABB_CommonUX_style__icon-abb_stop_24",
    iconAbbSun24: "ABB_CommonUX_style__icon-abb_sun_24",
    iconAbbSun224: "ABB_CommonUX_style__icon-abb_sun-2_24",
    iconAbbSynchronize24: "ABB_CommonUX_style__icon-abb_synchronize_24",
    iconAbbSystem24: "ABB_CommonUX_style__icon-abb_system_24",
    iconAbbTable24: "ABB_CommonUX_style__icon-abb_table_24",
    iconAbbTemperature24: "ABB_CommonUX_style__icon-abb_temperature_24",
    iconAbbTemperatureCelsius124: "ABB_CommonUX_style__icon-abb_temperature-celsius-1_24",
    iconAbbTemperatureCelsius224: "ABB_CommonUX_style__icon-abb_temperature-celsius-2_24",
    iconAbbTemperatureFahrenheit124: "ABB_CommonUX_style__icon-abb_temperature-fahrenheit-1_24",
    iconAbbTemperatureFahrenheit224: "ABB_CommonUX_style__icon-abb_temperature-fahrenheit-2_24",
    iconAbbTemplate24: "ABB_CommonUX_style__icon-abb_template_24",
    iconAbbTemplateNew24: "ABB_CommonUX_style__icon-abb_template-new_24",
    iconAbbTest24: "ABB_CommonUX_style__icon-abb_test_24",
    iconAbbText24: "ABB_CommonUX_style__icon-abb_text_24",
    iconAbbTime24: "ABB_CommonUX_style__icon-abb_time_24",
    iconAbbTimeAndDate24: "ABB_CommonUX_style__icon-abb_time-and-date_24",
    iconAbbTrack124: "ABB_CommonUX_style__icon-abb_track-1_24",
    iconAbbTrack224: "ABB_CommonUX_style__icon-abb_track-2_24",
    iconAbbTransformer24: "ABB_CommonUX_style__icon-abb_transformer_24",
    iconAbbTrash24: "ABB_CommonUX_style__icon-abb_trash_24",
    iconAbbTreeView24: "ABB_CommonUX_style__icon-abb_tree-view_24",
    iconAbbTrend124: "ABB_CommonUX_style__icon-abb_trend-1_24",
    iconAbbTrend224: "ABB_CommonUX_style__icon-abb_trend-2_24",
    iconAbbTurbocharger24: "ABB_CommonUX_style__icon-abb_turbocharger_24",
    iconAbbUndo24: "ABB_CommonUX_style__icon-abb_undo_24",
    iconAbbUnpin24: "ABB_CommonUX_style__icon-abb_unpin_24",
    iconAbbUp24: "ABB_CommonUX_style__icon-abb_up_24",
    iconAbbUpArrow24: "ABB_CommonUX_style__icon-abb_up-arrow_24",
    iconAbbUpload24: "ABB_CommonUX_style__icon-abb_upload_24",
    iconAbbUsb24: "ABB_CommonUX_style__icon-abb_usb_24",
    iconAbbUser24: "ABB_CommonUX_style__icon-abb_user_24",
    iconAbbUserInCircle24: "ABB_CommonUX_style__icon-abb_user-in-circle_24",
    iconAbbVideoCameraOff24: "ABB_CommonUX_style__icon-abb_video-camera-off_24",
    iconAbbVideoCameraOn24: "ABB_CommonUX_style__icon-abb_video-camera-on_24",
    iconAbbVideoChat24: "ABB_CommonUX_style__icon-abb_video-chat_24",
    iconAbbView24: "ABB_CommonUX_style__icon-abb_view_24",
    iconAbbVoltage24: "ABB_CommonUX_style__icon-abb_voltage_24",
    iconAbbWarningCircle124: "ABB_CommonUX_style__icon-abb_warning-circle-1_24",
    iconAbbWarningCircle224: "ABB_CommonUX_style__icon-abb_warning-circle-2_24",
    iconAbbWarningTriangle24: "ABB_CommonUX_style__icon-abb_warning-triangle_24",
    iconAbbWrench24: "ABB_CommonUX_style__icon-abb_wrench_24",
    iconAbbZoomIn24: "ABB_CommonUX_style__icon-abb_zoom-in_24",
    iconAbbZoomOut24: "ABB_CommonUX_style__icon-abb_zoom-out_24",
    iconAbbTrend324: "ABB_CommonUX_style__icon-abb_trend-3_24",
    iconAbbTrendScatter24: "ABB_CommonUX_style__icon-abb_trend-scatter_24",
    iconAbbSortAscending24: "ABB_CommonUX_style__icon-abb_sort-ascending_24",
    iconAbbSortDescending16: "ABB_CommonUX_style__icon-abb_sort-descending_16",
    iconAbbAdvancedSettings24: "ABB_CommonUX_style__icon-abb_advanced-settings_24",
    iconAbbAlign24: "ABB_CommonUX_style__icon-abb_align_24",
    iconAbbRobotAxis24: "ABB_CommonUX_style__icon-abb_robot-axis_24",
    iconAbbCalibration24: "ABB_CommonUX_style__icon-abb_calibration_24",
    iconAbbConnection24: "ABB_CommonUX_style__icon-abb_connection_24",
    iconAbbNetworkStatus24: "ABB_CommonUX_style__icon-abb_network-status_24",
    iconAbbCreateBackup24: "ABB_CommonUX_style__icon-abb_create-backup_24",
    iconAbbDataEditor24: "ABB_CommonUX_style__icon-abb_data-editor_24",
    iconAbbExecution24: "ABB_CommonUX_style__icon-abb_execution-24",
    iconAbbHardwareDevices24: "ABB_CommonUX_style__icon-abb_hardware-devices_24",
    iconAbbIoDevices24: "ABB_CommonUX_style__icon-abb_io-devices_24",
    iconAbbJoystick24: "ABB_CommonUX_style__icon-abb_joystick_24",
    iconAbbLeadThrough24: "ABB_CommonUX_style__icon-abb_lead-through_24",
    iconAbbJogLinear24: "ABB_CommonUX_style__icon-abb_jog-linear_24",
    iconAbbDocumentExcel24: "ABB_CommonUX_style__icon-abb_document-excel_24",
    iconAbbDocumentPdf24: "ABB_CommonUX_style__icon-abb_document-pdf_24",
    iconAbbDocumentWord24: "ABB_CommonUX_style__icon-abb_document-word_24",
    iconAbbModifyRapidPosition24: "ABB_CommonUX_style__icon-abb_modify-rapid-position_24",
    iconAbbSoftwareModule24: "ABB_CommonUX_style__icon-abb_software-module_24",
    iconAbbNetworkStatus124: "ABB_CommonUX_style__icon-abb_network-status-1_24",
    iconAbbNetworkStatus224: "ABB_CommonUX_style__icon-abb_network-status-2_24",
    iconAbbPayload24: "ABB_CommonUX_style__icon-abb_payload_24",
    iconAbbJogPlanar24: "ABB_CommonUX_style__icon-abb_jog-planar_24",
    iconAbbSoftwareProgramAndModules24: "ABB_CommonUX_style__icon-abb_software-program-and-modules_24",
    iconAbbSoftwareProgramEditor24: "ABB_CommonUX_style__icon-abb_software-program-editor_24",
    iconAbbSoftwareProgram24: "ABB_CommonUX_style__icon-abb_software-program_24",
    iconAbbProgramPointer24: "ABB_CommonUX_style__icon-abb_program-pointer_24",
    iconAbbRapidTasks24: "ABB_CommonUX_style__icon-abb_rapid-tasks_24",
    iconAbbJogReorient24: "ABB_CommonUX_style__icon-abb_jog-reorient_24",
    iconAbbResetUserData24: "ABB_CommonUX_style__icon-abb_reset-user-data_24",
    iconAbbRestoreBackup24: "ABB_CommonUX_style__icon-abb_restore-backup_24",
    iconAbbSelect24: "ABB_CommonUX_style__icon-abb_select_24",
    iconAbbSoftwareRoutins24: "ABB_CommonUX_style__icon-abb_software-routins_24",
    iconAbbNetworkSignalStrengthLevel124: "ABB_CommonUX_style__icon-abb_network-signal-strength-level-1_24",
    iconAbbNetworkSignalStrengthLevel2241: "ABB_CommonUX_style__icon-abb_network-signal-strength-level-2_24_1",
    iconAbbNetworkSignalStrengthLevel324: "ABB_CommonUX_style__icon-abb_network-signal-strength-level-3_24",
    iconAbbIoSignals24: "ABB_CommonUX_style__icon-abb_io-signals_24",
    iconAbbSoftwareResources24: "ABB_CommonUX_style__icon-abb_software-resources_24",
    iconAbbStartInstaller24: "ABB_CommonUX_style__icon-abb_start-installer_24",
    iconAbbStepIn24: "ABB_CommonUX_style__icon-abb_step-in_24",
    iconAbbStepOut24: "ABB_CommonUX_style__icon-abb_step-out_24",
    iconAbbStepOver24: "ABB_CommonUX_style__icon-abb_step-over_24",
    iconAbbTouch24: "ABB_CommonUX_style__icon-abb_touch_24",
    iconAbbVideo24: "ABB_CommonUX_style__icon-abb_video_24",
    iconAbbTurnClockwise24: "ABB_CommonUX_style__icon-abb_turn-clockwise_24",
    iconAbbTurnClockwiseOffTargetSpeed24: "ABB_CommonUX_style__icon-abb_turn-clockwise-off-target-speed_24",
    iconAbbTurnCounterClockwiseOffTargetSpeed24: "ABB_CommonUX_style__icon-abb_turn-counter-clockwise-off-target-speed_24",
    iconAbbAddDrives24: "ABB_CommonUX_style__icon-abb_add-drives_24",
    iconAbbBearing24: "ABB_CommonUX_style__icon-abb_bearing_24",
    iconAbbCloud24: "ABB_CommonUX_style__icon-abb_cloud_24",
    iconAbbDeleteDrives24: "ABB_CommonUX_style__icon-abb_delete-drives_24",
    iconAbbDownloadFromCloud24: "ABB_CommonUX_style__icon-abb_download-from-cloud_24",
    iconAbbDriveConnected24: "ABB_CommonUX_style__icon-abb_drive-connected_24",
    iconAbbDrivesError24: "ABB_CommonUX_style__icon-abb_drives-error_24",
    iconAbbFieldbus24: "ABB_CommonUX_style__icon-abb_fieldbus_24",
    iconAbbGenerator24: "ABB_CommonUX_style__icon-abb_generator_24",
    iconAbbMaximumValue24: "ABB_CommonUX_style__icon-abb_maximum-value_24",
    iconAbbMinimumValue24: "ABB_CommonUX_style__icon-abb_minimum-value_24",
    iconAbbNotAllowed24: "ABB_CommonUX_style__icon-abb_not-allowed_24",
    iconAbbPowertrain24: "ABB_CommonUX_style__icon-abb_powertrain_24",
    iconAbbPreventTurningFault24: "ABB_CommonUX_style__icon-abb_prevent-turning-fault_24",
    iconAbbTargetValueRange24: "ABB_CommonUX_style__icon-abb_target-value-range_24",
    iconAbbThumbnailView24: "ABB_CommonUX_style__icon-abb_thumbnail-view_24",
    iconAbbTrain24: "ABB_CommonUX_style__icon-abb_train_24",
    iconAbbTurnCounterClockwise24: "ABB_CommonUX_style__icon-abb_turn-counter-clockwise_24",
    iconAbbWheel24: "ABB_CommonUX_style__icon-abb_wheel_24",
    iconAbbWifiNetworkDisconnected24: "ABB_CommonUX_style__icon-abb_wifi-network-disconnected_24",
    iconAbbWriteToDefault24: "ABB_CommonUX_style__icon-abb_write-to-default_24",
    iconAbbWriteToDefaultDisabled24: "ABB_CommonUX_style__icon-abb_write-to-default-disabled_24",
    iconAbbCaretDown24: "ABB_CommonUX_style__icon-abb_caret-down_24",
    iconAbbCaretLeft24: "ABB_CommonUX_style__icon-abb_caret-left_24",
    iconAbbCaretRight24: "ABB_CommonUX_style__icon-abb_caret-right_24",
    iconAbbCaretUp24: "ABB_CommonUX_style__icon-abb_caret-up_24",
    iconAbbCloseLight24: "ABB_CommonUX_style__icon-abb_close-light_24",
    iconAbbTriangleDown24: "ABB_CommonUX_style__icon-abb-triangle-down_24",
    iconAbbTriangleLeft24: "ABB_CommonUX_style__icon-abb-triangle-left_24",
    iconAbbTriangleRight24: "ABB_CommonUX_style__icon-abb-triangle-right_24",
    iconAbbTriangleUp24: "ABB_CommonUX_style__icon-abb-triangle-up_24",
    iconAbbCheckMarkLight24: "ABB_CommonUX_style__icon-abb_check-mark-light_24",
    iconAbbNumberedList24: "ABB_CommonUX_style__icon-abb_numbered-list_24",
    iconAbbTextBold24: "ABB_CommonUX_style__icon-abb_text-bold_24",
    iconAbbTextItalic24: "ABB_CommonUX_style__icon-abb_text-italic_24",
    iconAbbTextUnderline24: "ABB_CommonUX_style__icon-abb_text-underline_24"
  };
}, function (e, o, n) {
  e.exports = {
    iconAbb32: "ABB_CommonUX_style__icon_abb_32",
    iconAbbAddUser32: "ABB_CommonUX_style__icon-abb_add-user_32",
    iconAbbAlarmBell32: "ABB_CommonUX_style__icon-abb_alarm-bell_32",
    iconAbbAlignBottom32: "ABB_CommonUX_style__icon-abb_align-bottom_32",
    iconAbbAlignHorizontalCenter32: "ABB_CommonUX_style__icon-abb_align-horizontal-center_32",
    iconAbbAlignLeft32: "ABB_CommonUX_style__icon-abb_align-left_32",
    iconAbbAlignRight32: "ABB_CommonUX_style__icon-abb_align-right_32",
    iconAbbAlignTop32: "ABB_CommonUX_style__icon-abb_align-top_32",
    iconAbbAlignVerticalCenter32: "ABB_CommonUX_style__icon-abb_align-vertical-center_32",
    iconAbbAnalyzeDocument32: "ABB_CommonUX_style__icon-abb_analyze-document_32",
    iconAbbAnchor32: "ABB_CommonUX_style__icon-abb_anchor_32",
    iconAbbAudioOff32: "ABB_CommonUX_style__icon-abb_audio-off_32",
    iconAbbAudioOn32: "ABB_CommonUX_style__icon-abb_audio-on_32",
    iconAbbBackground32: "ABB_CommonUX_style__icon-abb_background_32",
    iconAbbBarChart32: "ABB_CommonUX_style__icon-abb_bar-chart_32",
    iconAbbBatteryCharging32: "ABB_CommonUX_style__icon-abb_battery-charging_32",
    iconAbbBatteryEmpty32: "ABB_CommonUX_style__icon-abb_battery-empty_32",
    iconAbbBatteryFull32: "ABB_CommonUX_style__icon-abb_battery-full_32",
    iconAbbBatteryHalf32: "ABB_CommonUX_style__icon-abb_battery-half_32",
    iconAbbBatteryHigh32: "ABB_CommonUX_style__icon-abb_battery-high_32",
    iconAbbBatteryLow32: "ABB_CommonUX_style__icon-abb_battery-low_32",
    iconAbbBinaryData32: "ABB_CommonUX_style__icon-abb_binary-data_32",
    iconAbbBluetooth32: "ABB_CommonUX_style__icon-abb_bluetooth_32",
    iconAbbBoolean32: "ABB_CommonUX_style__icon-abb_boolean_32",
    iconAbbBriefcase32: "ABB_CommonUX_style__icon-abb_briefcase_32",
    iconAbbBringToFront32: "ABB_CommonUX_style__icon-abb_bring-to-front_32",
    iconAbbBroadcast32: "ABB_CommonUX_style__icon-abb_broadcast_32",
    iconAbbCalculator32: "ABB_CommonUX_style__icon-abb_calculator_32",
    iconAbbCalendar32: "ABB_CommonUX_style__icon-abb_calendar_32",
    iconAbbCall32: "ABB_CommonUX_style__icon-abb_call_32",
    iconAbbCamera32: "ABB_CommonUX_style__icon-abb_camera_32",
    iconAbbCart32: "ABB_CommonUX_style__icon-abb_cart_32",
    iconAbbCertificateDocument132: "ABB_CommonUX_style__icon-abb_certificate-document-1_32",
    iconAbbCertificateDocument232: "ABB_CommonUX_style__icon-abb_certificate-document-2_32",
    iconAbbChat32: "ABB_CommonUX_style__icon-abb_chat_32",
    iconAbbCheckMark32: "ABB_CommonUX_style__icon-abb_check-mark_32",
    iconAbbCheckMarkCircle132: "ABB_CommonUX_style__icon-abb_check-mark-circle-1_32",
    iconAbbCheckMarkCircle232: "ABB_CommonUX_style__icon-abb_check-mark-circle-2_32",
    iconAbbClose32: "ABB_CommonUX_style__icon-abb_close_32",
    iconAbbComment32: "ABB_CommonUX_style__icon-abb_comment_32",
    iconAbbComputer32: "ABB_CommonUX_style__icon-abb_computer_32",
    iconAbbConnect32: "ABB_CommonUX_style__icon-abb_connect_32",
    iconAbbControllerCabinet32: "ABB_CommonUX_style__icon-abb_controller-cabinet_32",
    iconAbbControlsAndSettings32: "ABB_CommonUX_style__icon-abb_controls-and-settings_32",
    iconAbbCopy32: "ABB_CommonUX_style__icon-abb_copy_32",
    iconAbbCut32: "ABB_CommonUX_style__icon-abb_cut_32",
    iconAbbDashboard32: "ABB_CommonUX_style__icon-abb_dashboard_32",
    iconAbbDatabase32: "ABB_CommonUX_style__icon-abb_database_32",
    iconAbbDatabaseNew32: "ABB_CommonUX_style__icon-abb_database-new_32",
    iconAbbDecimal32: "ABB_CommonUX_style__icon-abb_decimal_32",
    iconAbbDevices32: "ABB_CommonUX_style__icon-abb_devices_32",
    iconAbbDisconnect32: "ABB_CommonUX_style__icon-abb_disconnect_32",
    iconAbbDistribution32: "ABB_CommonUX_style__icon-abb_distribution_32",
    iconAbbDocument32: "ABB_CommonUX_style__icon-abb_document_32",
    iconAbbDollar32: "ABB_CommonUX_style__icon-abb_dollar_32",
    iconAbbDoubleDown32: "ABB_CommonUX_style__icon-abb_double-down_32",
    iconAbbDoubleLeft32: "ABB_CommonUX_style__icon-abb_double-left_32",
    iconAbbDoubleRight32: "ABB_CommonUX_style__icon-abb_double-right_32",
    iconAbbDoubleUp32: "ABB_CommonUX_style__icon-abb_double-up_32",
    iconAbbDown32: "ABB_CommonUX_style__icon-abb_down_32",
    iconAbbDownArrow32: "ABB_CommonUX_style__icon-abb_down-arrow_32",
    iconAbbDownload32: "ABB_CommonUX_style__icon-abb_download_32",
    iconAbbDrive32: "ABB_CommonUX_style__icon-abb_drive_32",
    iconAbbEdit32: "ABB_CommonUX_style__icon-abb_edit_32",
    iconAbbEndCall32: "ABB_CommonUX_style__icon-abb_end-call_32",
    iconAbbEnvelope32: "ABB_CommonUX_style__icon-abb_envelope_32",
    iconAbbErrorCircle132: "ABB_CommonUX_style__icon-abb_error-circle-1_32",
    iconAbbErrorCircle232: "ABB_CommonUX_style__icon-abb_error-circle-2_32",
    iconAbbEuro32: "ABB_CommonUX_style__icon-abb_euro_32",
    iconAbbEvent32: "ABB_CommonUX_style__icon-abb_event_32",
    iconAbbExport32: "ABB_CommonUX_style__icon-abb_export_32",
    iconAbbFactory32: "ABB_CommonUX_style__icon-abb_factory_32",
    iconAbbFilter32: "ABB_CommonUX_style__icon-abb_filter_32",
    iconAbbFolder32: "ABB_CommonUX_style__icon-abb_folder_32",
    iconAbbFolderNew32: "ABB_CommonUX_style__icon-abb_folder-new_32",
    iconAbbFolderOpen32: "ABB_CommonUX_style__icon-abb_folder-open_32",
    iconAbbForward32: "ABB_CommonUX_style__icon-abb_forward_32",
    iconAbbFullscreen32: "ABB_CommonUX_style__icon-abb_fullscreen_32",
    iconAbbGauge32: "ABB_CommonUX_style__icon-abb_gauge_32",
    iconAbbGbp32: "ABB_CommonUX_style__icon-abb_gbp_32",
    iconAbbGlobe32: "ABB_CommonUX_style__icon-abb_globe_32",
    iconAbbGroup32: "ABB_CommonUX_style__icon-abb_group_32",
    iconAbbHelpCircle132: "ABB_CommonUX_style__icon-abb_help-circle-1_32",
    iconAbbHelpCircle232: "ABB_CommonUX_style__icon-abb_help-circle-2_32",
    iconAbbHide32: "ABB_CommonUX_style__icon-abb_hide_32",
    iconAbbHistory32: "ABB_CommonUX_style__icon-abb_history_32",
    iconAbbHome32: "ABB_CommonUX_style__icon-abb_home_32",
    iconAbbHourGlass32: "ABB_CommonUX_style__icon-abb_hour-glass_32",
    iconAbbImage32: "ABB_CommonUX_style__icon-abb_image_32",
    iconAbbImport32: "ABB_CommonUX_style__icon-abb_import_32",
    iconAbbInformationCircle132: "ABB_CommonUX_style__icon-abb_information-circle-1_32",
    iconAbbInformationCircle232: "ABB_CommonUX_style__icon-abb_information-circle-2_32",
    iconAbbKey32: "ABB_CommonUX_style__icon-abb_key_32",
    iconAbbLabel32: "ABB_CommonUX_style__icon-abb_label_32",
    iconAbbLeft32: "ABB_CommonUX_style__icon-abb_left_32",
    iconAbbLeftArrow32: "ABB_CommonUX_style__icon-abb_left-arrow_32",
    iconAbbLevel32: "ABB_CommonUX_style__icon-abb_level_32",
    iconAbbLightBulb32: "ABB_CommonUX_style__icon-abb_light-bulb_32",
    iconAbbLink32: "ABB_CommonUX_style__icon-abb_link_32",
    iconAbbList32: "ABB_CommonUX_style__icon-abb_list_32",
    iconAbbLocation32: "ABB_CommonUX_style__icon-abb_location_32",
    iconAbbLockClosed32: "ABB_CommonUX_style__icon-abb_lock-closed_32",
    iconAbbLockOpen32: "ABB_CommonUX_style__icon-abb_lock-open_32",
    iconAbbLogIn32: "ABB_CommonUX_style__icon-abb_log-in_32",
    iconAbbLogOut32: "ABB_CommonUX_style__icon-abb_log-out_32",
    iconAbbMagnet32: "ABB_CommonUX_style__icon-abb_magnet_32",
    iconAbbMakeSameHeight32: "ABB_CommonUX_style__icon-abb_make-same-height_32",
    iconAbbMakeSameSize32: "ABB_CommonUX_style__icon-abb_make-same-size_32",
    iconAbbMakeSameWidth32: "ABB_CommonUX_style__icon-abb_make-same-width_32",
    iconAbbMap32: "ABB_CommonUX_style__icon-abb_map_32",
    iconAbbMatrix32: "ABB_CommonUX_style__icon-abb_matrix_32",
    iconAbbMaximize32: "ABB_CommonUX_style__icon-abb_maximize_32",
    iconAbbMenu32: "ABB_CommonUX_style__icon-abb_menu_32",
    iconAbbMenuNarrow32: "ABB_CommonUX_style__icon-abb_menu-narrow_32",
    iconAbbMicrophone32: "ABB_CommonUX_style__icon-abb_microphone_32",
    iconAbbMicrophoneOff32: "ABB_CommonUX_style__icon-abb_microphone-off_32",
    iconAbbMinimize32: "ABB_CommonUX_style__icon-abb_minimize_32",
    iconAbbMinus32: "ABB_CommonUX_style__icon-abb_minus_32",
    iconAbbMinusInCircle32: "ABB_CommonUX_style__icon-abb_minus-in-circle_32",
    iconAbbMissedCall32: "ABB_CommonUX_style__icon-abb_missed-call_32",
    iconAbbMoon32: "ABB_CommonUX_style__icon-abb_moon_32",
    iconAbbMore32: "ABB_CommonUX_style__icon-abb_more_32",
    iconAbbMotor32: "ABB_CommonUX_style__icon-abb_motor_32",
    iconAbbNetwork32: "ABB_CommonUX_style__icon-abb_network_32",
    iconAbbNewDocument32: "ABB_CommonUX_style__icon-abb_new-document_32",
    iconAbbNumericals32: "ABB_CommonUX_style__icon-abb_numericals_32",
    iconAbbObject32: "ABB_CommonUX_style__icon-abb_object_32",
    iconAbbObjectContainer132: "ABB_CommonUX_style__icon-abb_object-container-1_32",
    iconAbbObjectContainer232: "ABB_CommonUX_style__icon-abb_object-container-2_32",
    iconAbbOpenInNewWindow32: "ABB_CommonUX_style__icon-abb_open-in-new-window_32",
    iconAbbPanel32: "ABB_CommonUX_style__icon-abb_panel_32",
    iconAbbPaperClip32: "ABB_CommonUX_style__icon-abb_paper-clip_32",
    iconAbbPaste32: "ABB_CommonUX_style__icon-abb_paste_32",
    iconAbbPause32: "ABB_CommonUX_style__icon-abb_pause_32",
    iconAbbPieChart32: "ABB_CommonUX_style__icon-abb_pie-chart_32",
    iconAbbPin32: "ABB_CommonUX_style__icon-abb_pin_32",
    iconAbbPlay32: "ABB_CommonUX_style__icon-abb_play_32",
    iconAbbPlugin32: "ABB_CommonUX_style__icon-abb_plugin_32",
    iconAbbPlus32: "ABB_CommonUX_style__icon-abb_plus_32",
    iconAbbPlusInCircle32: "ABB_CommonUX_style__icon-abb_plus-in-circle_32",
    iconAbbPopOutWindow32: "ABB_CommonUX_style__icon-abb_pop-out-window_32",
    iconAbbPowerOnOff32: "ABB_CommonUX_style__icon-abb_power-on-off_32",
    iconAbbPressure32: "ABB_CommonUX_style__icon-abb_pressure_32",
    iconAbbPrint32: "ABB_CommonUX_style__icon-abb_print_32",
    iconAbbPump32: "ABB_CommonUX_style__icon-abb_pump_32",
    iconAbbQrCode32: "ABB_CommonUX_style__icon-abb_qr-code_32",
    iconAbbRearrange32: "ABB_CommonUX_style__icon-abb_rearrange_32",
    iconAbbRedo32: "ABB_CommonUX_style__icon-abb_redo_32",
    iconAbbRefresh32: "ABB_CommonUX_style__icon-abb_refresh_32",
    iconAbbReports32: "ABB_CommonUX_style__icon-abb_reports_32",
    iconAbbResistor32: "ABB_CommonUX_style__icon-abb_resistor_32",
    iconAbbRewind32: "ABB_CommonUX_style__icon-abb_rewind_32",
    iconAbbRight32: "ABB_CommonUX_style__icon-abb_right_32",
    iconAbbRightArrow32: "ABB_CommonUX_style__icon-abb_right-arrow_32",
    iconAbbRobot32: "ABB_CommonUX_style__icon-abb_robot_32",
    iconAbbRobotCabinet32: "ABB_CommonUX_style__icon-abb_robot-cabinet_32",
    iconAbbRobotTool32: "ABB_CommonUX_style__icon-abb_robot-tool_32",
    iconAbbRotateLeft9032: "ABB_CommonUX_style__icon-abb_rotate-left-90_32",
    iconAbbRotateLeft18032: "ABB_CommonUX_style__icon-abb_rotate-left-180_32",
    iconAbbRotateRight27032: "ABB_CommonUX_style__icon-abb_rotate-right-270_32",
    iconAbbRotateLeft270321: "ABB_CommonUX_style__icon-abb_rotate-left-270_321",
    iconAbbRotateRight9032: "ABB_CommonUX_style__icon-abb_rotate-right-90_32",
    iconAbbRotateRight18032: "ABB_CommonUX_style__icon-abb_rotate-right-180_32",
    iconAbbSave32: "ABB_CommonUX_style__icon-abb_save_32",
    iconAbbSaveAs32: "ABB_CommonUX_style__icon-abb_save-as_32",
    iconAbbScreen32: "ABB_CommonUX_style__icon-abb_screen_32",
    iconAbbSearch32: "ABB_CommonUX_style__icon-abb_search_32",
    iconAbbSendToBack32: "ABB_CommonUX_style__icon-abb_send-to-back_32",
    iconAbbServer32: "ABB_CommonUX_style__icon-abb_server_32",
    iconAbbSettings32: "ABB_CommonUX_style__icon-abb_settings_32",
    iconAbbShare32: "ABB_CommonUX_style__icon-abb_share_32",
    iconAbbShortcut32: "ABB_CommonUX_style__icon-abb_shortcut_32",
    iconAbbShuffle32: "ABB_CommonUX_style__icon-abb_shuffle_32",
    iconAbbSkipToEnd32: "ABB_CommonUX_style__icon-abb_skip-to-end_32",
    iconAbbSkipToStart32: "ABB_CommonUX_style__icon-abb_skip-to-start_32",
    iconAbbSld132: "ABB_CommonUX_style__icon-abb_sld-1_32",
    iconAbbSld232: "ABB_CommonUX_style__icon-abb_sld-2_32",
    iconAbbSmartphone32: "ABB_CommonUX_style__icon-abb_smartphone_32",
    iconAbbSortAlphabetDown32: "ABB_CommonUX_style__icon-abb_sort-alphabet-down_32",
    iconAbbSortAlphabetUp32: "ABB_CommonUX_style__icon-abb_sort-alphabet-up_32",
    iconAbbSortDateDown132: "ABB_CommonUX_style__icon-abb_sort-date-down-1_32",
    iconAbbSortDateDown232: "ABB_CommonUX_style__icon-abb_sort-date-down-2_32",
    iconAbbSortDateUp132: "ABB_CommonUX_style__icon-abb_sort-date-up-1_32",
    iconAbbSortDateUp232: "ABB_CommonUX_style__icon-abb_sort-date-up-2_32",
    iconAbbSpecification32: "ABB_CommonUX_style__icon-abb_specification_32",
    iconAbbStairs32: "ABB_CommonUX_style__icon-abb_stairs_32",
    iconAbbStar32: "ABB_CommonUX_style__icon-abb_star_32",
    iconAbbStop32: "ABB_CommonUX_style__icon-abb_stop_32",
    iconAbbSun32: "ABB_CommonUX_style__icon-abb_sun_32",
    iconAbbSun232: "ABB_CommonUX_style__icon-abb_sun-2_32",
    iconAbbSynchronize32: "ABB_CommonUX_style__icon-abb_synchronize_32",
    iconAbbSystem32: "ABB_CommonUX_style__icon-abb_system_32",
    iconAbbTable32: "ABB_CommonUX_style__icon-abb_table_32",
    iconAbbTemperature32: "ABB_CommonUX_style__icon-abb_temperature_32",
    iconAbbTemperatureCelsius132: "ABB_CommonUX_style__icon-abb_temperature-celsius-1_32",
    iconAbbTemperatureCelsius232: "ABB_CommonUX_style__icon-abb_temperature-celsius-2_32",
    iconAbbTemperatureFahrenheit132: "ABB_CommonUX_style__icon-abb_temperature-fahrenheit-1_32",
    iconAbbTemperatureFahrenheit232: "ABB_CommonUX_style__icon-abb_temperature-fahrenheit-2_32",
    iconAbbTemplate32: "ABB_CommonUX_style__icon-abb_template_32",
    iconAbbTemplateNew32: "ABB_CommonUX_style__icon-abb_template-new_32",
    iconAbbTest32: "ABB_CommonUX_style__icon-abb_test_32",
    iconAbbText32: "ABB_CommonUX_style__icon-abb_text_32",
    iconAbbTime32: "ABB_CommonUX_style__icon-abb_time_32",
    iconAbbTimeAndDate32: "ABB_CommonUX_style__icon-abb_time-and-date_32",
    iconAbbTrack132: "ABB_CommonUX_style__icon-abb_track-1_32",
    iconAbbTrack232: "ABB_CommonUX_style__icon-abb_track-2_32",
    iconAbbTransformer32: "ABB_CommonUX_style__icon-abb_transformer_32",
    iconAbbTrash32: "ABB_CommonUX_style__icon-abb_trash_32",
    iconAbbTreeView32: "ABB_CommonUX_style__icon-abb_tree-view_32",
    iconAbbTrend132: "ABB_CommonUX_style__icon-abb_trend-1_32",
    iconAbbTrend232: "ABB_CommonUX_style__icon-abb_trend-2_32",
    iconAbbTurbocharger32: "ABB_CommonUX_style__icon-abb_turbocharger_32",
    iconAbbUndo32: "ABB_CommonUX_style__icon-abb_undo_32",
    iconAbbUnpin32: "ABB_CommonUX_style__icon-abb_unpin_32",
    iconAbbUp32: "ABB_CommonUX_style__icon-abb_up_32",
    iconAbbUpArrow32: "ABB_CommonUX_style__icon-abb_up-arrow_32",
    iconAbbUpload32: "ABB_CommonUX_style__icon-abb_upload_32",
    iconAbbUsb32: "ABB_CommonUX_style__icon-abb_usb_32",
    iconAbbUser32: "ABB_CommonUX_style__icon-abb_user_32",
    iconAbbUserInCircle32: "ABB_CommonUX_style__icon-abb_user-in-circle_32",
    iconAbbVideoCameraOff32: "ABB_CommonUX_style__icon-abb_video-camera-off_32",
    iconAbbVideoCameraOn32: "ABB_CommonUX_style__icon-abb_video-camera-on_32",
    iconAbbVideoChat32: "ABB_CommonUX_style__icon-abb_video-chat_32",
    iconAbbView32: "ABB_CommonUX_style__icon-abb_view_32",
    iconAbbVoltage32: "ABB_CommonUX_style__icon-abb_voltage_32",
    iconAbbWarningCircle132: "ABB_CommonUX_style__icon-abb_warning-circle-1_32",
    iconAbbWarningCircle232: "ABB_CommonUX_style__icon-abb_warning-circle-2_32",
    iconAbbWarningTriangle32: "ABB_CommonUX_style__icon-abb_warning-triangle_32",
    iconAbbWrench32: "ABB_CommonUX_style__icon-abb_wrench_32",
    iconAbbZoomIn32: "ABB_CommonUX_style__icon-abb_zoom-in_32",
    iconAbbZoomOut32: "ABB_CommonUX_style__icon-abb_zoom-out_32",
    iconAbbTrend332: "ABB_CommonUX_style__icon-abb_trend-3_32",
    iconAbbTrendScatter32: "ABB_CommonUX_style__icon-abb_trend-scatter_32",
    iconAbbSortAscending32: "ABB_CommonUX_style__icon-abb_sort-ascending_32",
    iconAbbSortDescending32: "ABB_CommonUX_style__icon-abb_sort-descending_32",
    iconAbbAdvancedSettings32: "ABB_CommonUX_style__icon-abb_advanced-settings_32",
    iconAbbAlign32: "ABB_CommonUX_style__icon-abb_align_32",
    iconAbbRobotAxis32: "ABB_CommonUX_style__icon-abb_robot-axis_32",
    iconAbbCalibration32: "ABB_CommonUX_style__icon-abb_calibration_32",
    iconAbbConnection32: "ABB_CommonUX_style__icon-abb_connection_32",
    iconAbbNetworkStatus32: "ABB_CommonUX_style__icon-abb_network-status_32",
    iconAbbCreateBackup32: "ABB_CommonUX_style__icon-abb_create-backup_32",
    iconAbbDataEditor32: "ABB_CommonUX_style__icon-abb_data-editor_32",
    iconAbbExecution32: "ABB_CommonUX_style__icon-abb_execution-32",
    iconAbbHardwareDevices32: "ABB_CommonUX_style__icon-abb_hardware-devices_32",
    iconAbbIoDevices32: "ABB_CommonUX_style__icon-abb_io-devices_32",
    iconAbbJoystick32: "ABB_CommonUX_style__icon-abb_joystick_32",
    iconAbbLeadThrough32: "ABB_CommonUX_style__icon-abb_lead-through_32",
    iconAbbJogLinear32: "ABB_CommonUX_style__icon-abb_jog-linear_32",
    iconAbbDocumentExcel32: "ABB_CommonUX_style__icon-abb_document-excel_32",
    iconAbbDocumentPdf32: "ABB_CommonUX_style__icon-abb_document-pdf_32",
    iconAbbDocumentWord32: "ABB_CommonUX_style__icon-abb_document-word_32",
    iconAbbModifyRapidPosition32: "ABB_CommonUX_style__icon-abb_modify-rapid-position_32",
    iconAbbSoftwareModule32: "ABB_CommonUX_style__icon-abb_software-module_32",
    iconAbbNetworkStatus132: "ABB_CommonUX_style__icon-abb_network-status-1_32",
    iconAbbNetworkStatus232: "ABB_CommonUX_style__icon-abb_network-status-2_32",
    iconAbbPayload32: "ABB_CommonUX_style__icon-abb_payload_32",
    iconAbbJogPlanar32: "ABB_CommonUX_style__icon-abb_jog-planar_32",
    iconAbbSoftwareProgramAndModules32: "ABB_CommonUX_style__icon-abb_software-program-and-modules_32",
    iconAbbSoftwareProgramEditor32: "ABB_CommonUX_style__icon-abb_software-program-editor_32",
    iconAbbSoftwareProgram32: "ABB_CommonUX_style__icon-abb_software-program_32",
    iconAbbProgramPointer32: "ABB_CommonUX_style__icon-abb_program-pointer_32",
    iconAbbRapidTasks32: "ABB_CommonUX_style__icon-abb_rapid-tasks_32",
    iconAbbJogReorient32: "ABB_CommonUX_style__icon-abb_jog-reorient_32",
    iconAbbResetUserData32: "ABB_CommonUX_style__icon-abb_reset-user-data_32",
    iconAbbRestoreBackup32: "ABB_CommonUX_style__icon-abb_restore-backup_32",
    iconAbbSelect32: "ABB_CommonUX_style__icon-abb_select_32",
    iconAbbSoftwareRoutins32: "ABB_CommonUX_style__icon-abb_software-routins_32",
    iconAbbNetworkSignalStrengthLevel132: "ABB_CommonUX_style__icon-abb_network-signal-strength-level-1_32",
    iconAbbNetworkSignalStrengthLevel232: "ABB_CommonUX_style__icon-abb_network-signal-strength-level-2_32",
    iconAbbNetworkSignalStrengthLevel332: "ABB_CommonUX_style__icon-abb_network-signal-strength-level-3_32",
    iconAbbIoSignals32: "ABB_CommonUX_style__icon-abb_io-signals_32",
    iconAbbSoftwareResources32: "ABB_CommonUX_style__icon-abb_software-resources_32",
    iconAbbStartInstaller32: "ABB_CommonUX_style__icon-abb_start-installer_32",
    iconAbbStepIn32: "ABB_CommonUX_style__icon-abb_step-in_32",
    iconAbbStepOut32: "ABB_CommonUX_style__icon-abb_step-out_32",
    iconAbbStepOver32: "ABB_CommonUX_style__icon-abb_step-over_32",
    iconAbbTouch32: "ABB_CommonUX_style__icon-abb_touch_32",
    iconAbbVideo32: "ABB_CommonUX_style__icon-abb_video_32",
    iconAbbTurnClockwise32: "ABB_CommonUX_style__icon-abb_turn-clockwise_32",
    iconAbbTurnClockwiseOffTargetSpeed32: "ABB_CommonUX_style__icon-abb_turn-clockwise-off-target-speed_32",
    iconAbbTurnCounterClockwiseOffTargetSpeed32: "ABB_CommonUX_style__icon-abb_turn-counter-clockwise-off-target-speed_32",
    iconAbbAddDrives32: "ABB_CommonUX_style__icon-abb_add-drives_32",
    iconAbbBearing32: "ABB_CommonUX_style__icon-abb_bearing_32",
    iconAbbCloud32: "ABB_CommonUX_style__icon-abb_cloud_32",
    iconAbbDeleteDrives32: "ABB_CommonUX_style__icon-abb_delete-drives_32",
    iconAbbDownloadFromCloud32: "ABB_CommonUX_style__icon-abb_download-from-cloud_32",
    iconAbbDriveConnected32: "ABB_CommonUX_style__icon-abb_drive-connected_32",
    iconAbbDrivesError32: "ABB_CommonUX_style__icon-abb_drives-error_32",
    iconAbbFieldbus32: "ABB_CommonUX_style__icon-abb_fieldbus_32",
    iconAbbGenerator32: "ABB_CommonUX_style__icon-abb_generator_32",
    iconAbbMaximumValue32: "ABB_CommonUX_style__icon-abb_maximum-value_32",
    iconAbbMinimumValue32: "ABB_CommonUX_style__icon-abb_minimum-value_32",
    iconAbbNotAllowed32: "ABB_CommonUX_style__icon-abb_not-allowed_32",
    iconAbbPowertrain32: "ABB_CommonUX_style__icon-abb_powertrain_32",
    iconAbbPreventTurningFault32: "ABB_CommonUX_style__icon-abb_prevent-turning-fault_32",
    iconAbbTargetValueRange32: "ABB_CommonUX_style__icon-abb_target-value-range_32",
    iconAbbThumbnailView32: "ABB_CommonUX_style__icon-abb_thumbnail-view_32",
    iconAbbTrain32: "ABB_CommonUX_style__icon-abb_train_32",
    iconAbbTurnCounterClockwise32: "ABB_CommonUX_style__icon-abb_turn-counter-clockwise_32",
    iconAbbWheel32: "ABB_CommonUX_style__icon-abb_wheel_32",
    iconAbbWifiNetworkDisconnected32: "ABB_CommonUX_style__icon-abb_wifi-network-disconnected_32",
    iconAbbWriteToDefault32: "ABB_CommonUX_style__icon-abb_write-to-default_32",
    iconAbbWriteToDefaultDisabled32: "ABB_CommonUX_style__icon-abb_write-to-default-disabled_32",
    iconAbbCaretDown32: "ABB_CommonUX_style__icon-abb_caret-down_32",
    iconAbbCaretLeft32: "ABB_CommonUX_style__icon-abb_caret-left_32",
    iconAbbCaretRight32: "ABB_CommonUX_style__icon-abb_caret-right_32",
    iconAbbCaretUp32: "ABB_CommonUX_style__icon-abb_caret-up_32",
    iconAbbCloseLight32: "ABB_CommonUX_style__icon-abb_close-light_32",
    iconAbbTriangleDown32: "ABB_CommonUX_style__icon-abb-triangle-down_32",
    iconAbbTriangleLeft32: "ABB_CommonUX_style__icon-abb-triangle-left_32",
    iconAbbTriangleRight32: "ABB_CommonUX_style__icon-abb-triangle-right_32",
    iconAbbTriangleUp32: "ABB_CommonUX_style__icon-abb-triangle-up_32",
    iconAbbCheckMarkLight32: "ABB_CommonUX_style__icon-abb_check-mark-light_32",
    iconAbbNumberedList32: "ABB_CommonUX_style__icon-abb_numbered-list_32",
    iconAbbTextBold32: "ABB_CommonUX_style__icon-abb_text-bold_32",
    iconAbbTextItalic32: "ABB_CommonUX_style__icon-abb_text-italic_32",
    iconAbbTextUnderline32: "ABB_CommonUX_style__icon-abb_text-underline_32"
  };
}, function (e, o, n) {
  e.exports = {
    root: "ABB_CommonUX_Icon__root"
  };
}, function (e, n, o) {
  "use strict";

  Object.defineProperty(n, "__esModule", {
    value: !0
  }), function (e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }(o(13));
}, function (e, o, n) {
  "use strict";

  var _t2,
    r = this && this.__extends || (_t2 = function t(e, o) {
      return (_t2 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t2(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    l = this && this.__assign || function () {
      return (l = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var s = n(0),
    c = n(1),
    b = n(3),
    m = n(2),
    p = n(4),
    u = n(14),
    d = {
      "extra-small": "abb/close-light",
      small: "abb/close-light",
      medium: "abb/close",
      large: "abb/close"
    },
    i = function (n) {
      function e(e) {
        var o = n.call(this, e) || this;
        return o._handleClick = o._handleClick.bind(o), o;
      }
      return r(e, n), e.prototype.render = function () {
        var o = this,
          e = this.props,
          n = e.className,
          t = e.sizeClass,
          r = [u.root, n],
          i = "large" === t ? "medium" : "small",
          a = d[t],
          _ = t.replace("-", "");
        return s.createElement(b.ThemeContext.Consumer, null, function (e) {
          return s.createElement("div", l({}, m.getHtmlAttributes(o.props), {
            className: c(r, u[e], u[_]),
            onClick: o._handleClick
          }), s.createElement(p.Icon, {
            name: a,
            sizeClass: i
          }));
        });
      }, e.prototype._handleClick = function (e) {
        e.preventDefault(), this.props.onClick && this.props.onClick(e);
      }, e.defaultProps = {
        sizeClass: "small"
      }, e;
    }(s.Component);
  o.CloseIcon = i, o.default = i;
}, function (e, o, n) {
  e.exports = {
    root: "ABB_CommonUX_CloseIcon__root",
    extrasmall: "ABB_CommonUX_CloseIcon__extrasmall",
    small: "ABB_CommonUX_CloseIcon__small",
    medium: "ABB_CommonUX_CloseIcon__medium",
    large: "ABB_CommonUX_CloseIcon__large",
    light: "ABB_CommonUX_CloseIcon__light",
    dark: "ABB_CommonUX_CloseIcon__dark"
  };
}, function (e, o, n) {
  "use strict";

  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var r = n(0);
  o.childrenAreTypeOf = function (e, o) {
    var n,
      t = !1;
    if (e && (r.Children.forEach(e, function (e) {
      !e || e.type && e.type.componentName === o || (t = !0, n = "string" == typeof e.type ? e.type : e.type.name);
    }), t)) throw new Error("Invalid children, expected: '" + o.name + "'. Got: '" + n + "'");
  }, o.injectProps = function (e, o) {
    if (!e) return e;
    var n = 0;
    return r.Children.map(e, function (e) {
      return e && e.props ? r.cloneElement(e, o(n++, e)) : e;
    });
  };
  var t = 0;
  function i() {
    return !!document.documentMode;
  }
  o.createUniqueId = function (e) {
    return void 0 === e && (e = "id"), "" + e + ++t;
  }, o.hexRgbaToRgba = function (e) {
    var o = e.replace("rgba(#", "").replace(")", "").replace(" ", "").split(","),
      n = 3 === o[0].length;
    return "rgba(" + parseInt(o[0].slice(0, n ? 1 : 2), 16) + ", " + parseInt(o[0].slice(n ? 1 : 2, n ? 2 : 4), 16) + ", " + parseInt(o[0].slice(n ? 2 : 4, n ? 3 : 6), 16) + ", " + o[1] + ")";
  }, o.hexToRGB = function (e, o) {
    var n = parseInt(e.slice(1, 3), 16),
      t = parseInt(e.slice(3, 5), 16),
      r = parseInt(e.slice(5, 7), 16);
    return o ? "rgba(" + n + ", " + t + ", " + r + ", " + o + ")" : "rgb(" + n + ", " + t + ", " + r + ")";
  }, o.isIE = i, o.isFF = function () {
    return "undefined" != typeof InstallTrigger;
  }, o.isEdge = function () {
    return !i() && !!window.StyleMedia;
  };
}, function (e, n, o) {
  "use strict";

  Object.defineProperty(n, "__esModule", {
    value: !0
  }), function (e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }(o(23));
}, function (e, n, o) {
  "use strict";

  Object.defineProperty(n, "__esModule", {
    value: !0
  }), function (e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }(o(18));
}, function (e, o, n) {
  "use strict";

  var _t3,
    r = this && this.__extends || (_t3 = function t(e, o) {
      return (_t3 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t3(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var a = n(0),
    _ = n(1),
    l = n(3),
    s = n(2),
    c = n(19),
    b = function (o) {
      function e(e) {
        return o.call(this, e) || this;
      }
      return r(e, o), e.prototype.render = function () {
        var o = this,
          e = this.props,
          n = e.className,
          t = e.color,
          r = e.sizeClass;
        return a.createElement(l.ThemeContext.Consumer, null, function (e) {
          return a.createElement("div", i({}, s.getHtmlAttributes(o.props), {
            className: _(c.root, c[e], n, c[t.replace("-", "")], c[r])
          }), a.createElement("svg", {
            viewBox: "0 0 100 100"
          }, a.createElement("circle", {
            cx: "50",
            cy: "50",
            r: "45"
          })));
        });
      }, e.defaultProps = {
        color: "grey",
        sizeClass: "small"
      }, e;
    }(a.Component);
  o.Spinner = b, o.default = b;
}, function (e, o, n) {
  e.exports = {
    root: "ABB_CommonUX_Spinner__root",
    rotation: "ABB_CommonUX_Spinner__rotation",
    small: "ABB_CommonUX_Spinner__small",
    medium: "ABB_CommonUX_Spinner__medium",
    large: "ABB_CommonUX_Spinner__large",
    grey: "ABB_CommonUX_Spinner__grey",
    darkgrey: "ABB_CommonUX_Spinner__darkgrey",
    blue: "ABB_CommonUX_Spinner__blue",
    red: "ABB_CommonUX_Spinner__red",
    dark: "ABB_CommonUX_Spinner__dark"
  };
}, function (e, o, n) {
  e.exports = {
    root: "ABB_CommonUX_Dialog__root",
    header: "ABB_CommonUX_Dialog__header",
    title: "ABB_CommonUX_Dialog__title",
    closeButton: "ABB_CommonUX_Dialog__closeButton",
    content: "ABB_CommonUX_Dialog__content",
    withStandardButtonsOnTop: "ABB_CommonUX_Dialog__withStandardButtonsOnTop",
    standardButtonsOnTop: "ABB_CommonUX_Dialog__standardButtonsOnTop",
    standardButtonsOnBottom: "ABB_CommonUX_Dialog__standardButtonsOnBottom",
    light: "ABB_CommonUX_Dialog__light",
    dark: "ABB_CommonUX_Dialog__dark",
    dialog: "ABB_CommonUX_Dialog__dialog",
    overlay: "ABB_CommonUX_Dialog__overlay",
    transparentBackdrop: "ABB_CommonUX_Dialog__transparentBackdrop",
    fullOpacityBackdrop: "ABB_CommonUX_Dialog__fullOpacityBackdrop",
    halfOpacityBackdrop: "ABB_CommonUX_Dialog__halfOpacityBackdrop",
    modalBackdrop: "ABB_CommonUX_Dialog__modal-backdrop",
    show: "ABB_CommonUX_Dialog__show",
    modal: "ABB_CommonUX_Dialog__modal"
  };
}, function (e, o) {
  e.exports = require("react-resize-detector");
}, function (e, o, n) {
  e.exports = {
    root: "ABB_CommonUX_AppTopNavi__root",
    fontFix: "ABB_CommonUX_AppTopNavi__fontFix",
    item: "ABB_CommonUX_AppTopNavi__item",
    header: "ABB_CommonUX_AppTopNavi__header",
    iconOnly: "ABB_CommonUX_AppTopNavi__iconOnly",
    icon: "ABB_CommonUX_AppTopNavi__icon",
    textOnly: "ABB_CommonUX_AppTopNavi__textOnly",
    text: "ABB_CommonUX_AppTopNavi__text",
    iconAndText: "ABB_CommonUX_AppTopNavi__iconAndText",
    caret: "ABB_CommonUX_AppTopNavi__caret",
    active: "ABB_CommonUX_AppTopNavi__active",
    disabled: "ABB_CommonUX_AppTopNavi__disabled",
    light: "ABB_CommonUX_AppTopNavi__light",
    dark: "ABB_CommonUX_AppTopNavi__dark",
    divider: "ABB_CommonUX_AppTopNavi__divider"
  };
}, function (e, o, n) {
  "use strict";

  var _t4,
    r = this && this.__extends || (_t4 = function t(e, o) {
      return (_t4 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t4(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    f = this && this.__assign || function () {
      return (f = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var y = n(0),
    g = n(1),
    v = n(3),
    U = n(17),
    X = n(2),
    w = n(4),
    O = n(24),
    i = function (n) {
      function e(e) {
        var o = n.call(this, e) || this;
        return o._handleClick = o._handleClick.bind(o), o;
      }
      return r(e, n), e.prototype.render = function () {
        var e,
          o,
          n,
          t,
          r,
          i = this,
          a = this.props,
          _ = a.text,
          l = a.icon,
          s = a.href,
          c = a.download,
          b = a.disabled,
          m = a.className,
          p = a.shape,
          u = a.type,
          d = a.sizeClass,
          h = a.isLoading,
          B = [O.root, m, O[u.replace("-", "")], O[d + "Size"], (e = {}, e[O.disabled] = b || h, e), (o = {}, o[O.empty] = !l && !h && !_, o), (n = {}, n[O.iconOnly] = (l || h) && !_, n), (t = {}, t[O.textOnly] = !l && !h && _, t), (r = {}, r[O.iconAndText] = (l || h) && _, r)],
          A = {};
        s && (c && (A.download = !0), ["href", "referrerPolicy", "target", "rel"].forEach(function (e) {
          i.props[e] && (A[e] = i.props[e]);
        }));
        var C = y.createElement(y.Fragment, null, h && y.createElement("span", {
          className: O.icon,
          style: {
            width: "large" === d ? "24px" : "16px",
            paddingTop: "large" === d ? "3px" : "0"
          }
        }, y.createElement(U.Spinner, {
          sizeClass: "small",
          color: "dark-grey"
        })), !h && l && y.createElement("span", {
          className: O.icon
        }, y.createElement(w.Icon, {
          name: l,
          sizeClass: "large" === d ? "medium" : "small"
        })), _ && y.createElement("span", {
          className: O.text
        }, _));
        return y.createElement(v.ThemeContext.Consumer, null, function (e) {
          return s ? y.createElement("a", f({}, X.getHtmlAttributes(i.props), {
            className: g(B, O[e], O[p]),
            onClick: i._handleClick
          }, A), C) : y.createElement("button", f({}, X.getHtmlAttributes(i.props), {
            className: g(B, O[e], O[p]),
            onClick: i._handleClick,
            disabled: b || h
          }), C);
        });
      }, e.prototype._handleClick = function (e) {
        this.props.href && !this.props.disabled || e.preventDefault(), this.props.onClick && !this.props.disabled && this.props.onClick(e, this.props.data);
      }, e.defaultProps = {
        text: void 0,
        icon: void 0,
        sizeClass: "medium",
        type: "normal",
        shape: "rounded",
        isLoading: !1,
        download: !1
      }, e;
    }(y.Component);
  o.Button = i, o.default = i;
}, function (e, o, n) {
  e.exports = {
    root: "ABB_CommonUX_Button__root",
    smallSize: "ABB_CommonUX_Button__smallSize",
    empty: "ABB_CommonUX_Button__empty",
    iconOnly: "ABB_CommonUX_Button__iconOnly",
    textOnly: "ABB_CommonUX_Button__textOnly",
    iconAndText: "ABB_CommonUX_Button__iconAndText",
    icon: "ABB_CommonUX_Button__icon",
    text: "ABB_CommonUX_Button__text",
    mediumSize: "ABB_CommonUX_Button__mediumSize",
    largeSize: "ABB_CommonUX_Button__largeSize",
    rounded: "ABB_CommonUX_Button__rounded",
    rectangle: "ABB_CommonUX_Button__rectangle",
    pill: "ABB_CommonUX_Button__pill",
    light: "ABB_CommonUX_Button__light",
    normal: "ABB_CommonUX_Button__normal",
    disabled: "ABB_CommonUX_Button__disabled",
    primaryblue: "ABB_CommonUX_Button__primaryblue",
    primaryblack: "ABB_CommonUX_Button__primaryblack",
    primaryred: "ABB_CommonUX_Button__primaryred",
    ghost: "ABB_CommonUX_Button__ghost",
    discreetblue: "ABB_CommonUX_Button__discreetblue",
    discreetblack: "ABB_CommonUX_Button__discreetblack",
    dark: "ABB_CommonUX_Button__dark"
  };
}, function (e, o) {
  e.exports = require("react-modal");
}, function (e, n, o) {
  "use strict";

  Object.defineProperty(n, "__esModule", {
    value: !0
  }), function (e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }(o(31));
}, function (e, n, o) {
  "use strict";

  Object.defineProperty(n, "__esModule", {
    value: !0
  }), function (e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }(o(36));
}, function (e, n, o) {
  "use strict";

  Object.defineProperty(n, "__esModule", {
    value: !0
  }), function (e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }(o(40));
}, function (e, o, n) {
  "use strict";

  var _t5,
    r = this && this.__extends || (_t5 = function t(e, o) {
      return (_t5 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t5(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    });
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var a = n(0),
    _ = n(1),
    l = n(3),
    s = n(12),
    c = n(68),
    i = function (n) {
      function e(e) {
        var o = n.call(this, e) || this;
        return o.state = {}, o.close = o.close.bind(o), o.handleKeyDown = o.handleKeyDown.bind(o), o;
      }
      return r(e, n), e.prototype.handleKeyDown = function (e) {
        "Escape" === e.key && this.props.closeOnEscape && (e.preventDefault(), this.close());
      }, e.prototype.render = function () {
        var n = this,
          e = this.props,
          t = e.className,
          r = e.showCloseButton,
          i = a.createElement("div", {
            className: _(c.header)
          }, r ? a.createElement(s.CloseIcon, {
            sizeClass: "medium",
            onClick: this.close
          }) : null);
        return a.createElement(l.ThemeContext.Consumer, null, function (e) {
          var o;
          return a.createElement("div", {
            className: _(c.root, c[e], (o = {}, o[c.hasCloseButton] = r, o), t),
            onKeyDown: n.handleKeyDown,
            tabIndex: 0
          }, i, a.createElement("div", {
            className: _(c.content)
          }, n.props.render ? n.props.render(n) : n.props.children));
        });
      }, e.prototype.close = function () {
        this.props.closeAction();
      }, e.defaultProps = {
        trigger: "click",
        defaultOpen: !1,
        showCloseButton: !1,
        closeOnEscape: !0,
        closeOnLostFocus: !0,
        disableDefaultStyle: !1,
        position: ["bottom center", "top center"],
        onOpen: null,
        onClose: null,
        closeAfter: -1,
        render: null,
        show: void 0
      }, e.componentName = "Popup", e;
    }(a.Component);
  o.Popup = i, o.default = i;
}, function (e, o, n) {
  "use strict";

  var _t6,
    r = this && this.__extends || (_t6 = function t(e, o) {
      return (_t6 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t6(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    c = this && this.__assign || function () {
      return (c = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var b = n(0),
    m = n(1),
    p = n(3),
    u = n(2),
    d = n(39),
    h = n(16),
    B = n(12),
    A = n(20),
    i = function (n) {
      function e(e) {
        var o = n.call(this, e) || this;
        return o.close = o.close.bind(o), o._handleClick = o._handleClick.bind(o), o;
      }
      return r(e, n), e.prototype.render = function () {
        var n = this,
          e = this.props,
          t = e.className,
          r = e.contentClassName,
          i = e.showCloseButton,
          a = e.title,
          _ = e.disableDefaultStyle,
          l = e.standardButtonsOnTop,
          s = e.standardButtonsOnBottom,
          o = b.createElement(p.ThemeContext.Consumer, null, function (e) {
            var o;
            return b.createElement("div", c({}, u.getHtmlAttributes(n.props), {
              className: m((o = {}, o[A.root] = !_, o[A[e]] = !_, o[A.withStandardButtonsOnTop] = l, o), t),
              onClick: n._handleClick
            }), b.createElement("div", {
              className: m(A.header)
            }, a && b.createElement("span", {
              className: m(A.title)
            }, a), i && !l && b.createElement(B.CloseIcon, {
              sizeClass: "large",
              className: m(A.closeButton),
              onClick: n.close
            }), l && b.createElement("div", {
              className: A.standardButtonsOnTop
            }, l.map(function (o) {
              return b.createElement(h.Button, {
                key: o.type + "-" + o.text,
                type: o.type,
                text: o.text,
                icon: o.icon,
                sizeClass: "small",
                onClick: function onClick(e) {
                  return o.handler(n);
                }
              });
            }))), b.createElement("div", {
              className: m(A.content, r)
            }, n.props.render ? n.props.render(n) : n.props.children), s && b.createElement("div", {
              className: A.standardButtonsOnBottom
            }, s.map(function (o) {
              return b.createElement(h.Button, {
                key: o.type + "-" + o.text,
                type: o.type,
                text: o.text,
                icon: o.icon,
                sizeClass: "small",
                onClick: function onClick(e) {
                  return o.handler(n);
                }
              });
            })));
          });
        return void 0 !== this.props.isOpen ? b.createElement(d.DialogWrapper, c({
          dialog: this,
          closeHandler: this.close
        }, this.props), o) : o;
      }, e.prototype.close = function () {
        this.props.closeAction && this.props.closeAction(), this.resourceCleaner && this.resourceCleaner(), this.props.onClose && this.props.onClose();
      }, e.prototype.registerResourceCleaner = function (e) {
        this.resourceCleaner = e;
      }, e.prototype._handleClick = function (e) {
        this.props.onClick && this.props.onClick(e);
      }, e.defaultProps = {
        contentClassName: "",
        containerClassName: "",
        trigger: "click",
        showCloseButton: !1,
        closeOnEscape: !0,
        closeOnLostFocus: !0,
        dimBackground: !1,
        hideBackground: !1,
        disableDefaultStyle: !1,
        title: null,
        onOpen: null,
        onClose: null,
        closeAfter: -1,
        render: null,
        isOpen: void 0
      }, e.componentName = "Dialog", e;
    }(b.Component);
  o.Dialog = i, o.default = i;
}, function (e, o, n) {
  "use strict";

  var _t7,
    r = this && this.__extends || (_t7 = function t(e, o) {
      return (_t7 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t7(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    P = this && this.__assign || function () {
      return (P = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var S = n(0),
    N = n(1),
    T = n(4),
    M = n(12),
    D = n(3),
    L = n(2),
    j = n(32),
    i = n(5).getVariables(),
    I = i["abb-alarm-green"],
    R = i["color-state-error"],
    a = function (n) {
      function e(e) {
        var o = n.call(this, e) || this;
        return o.state = {
          focused: !1
        }, o.inputRef = S.createRef(), o._handleValueChange = o._handleValueChange.bind(o), o._handleFocus = o._handleFocus.bind(o), o._handleBlur = o._handleBlur.bind(o), o._handleKeyPress = o._handleKeyPress.bind(o), o._handleIconClick = o._handleIconClick.bind(o), o._handleClearIconClick = o._handleClearIconClick.bind(o), o;
      }
      return r(e, n), e.prototype.render = function () {
        var i = this,
          e = this.props,
          a = e.className,
          o = e.type,
          _ = e.value,
          l = e.label,
          s = e.description,
          c = e.icon,
          b = e.disabled,
          m = e.required,
          p = e.placeholder,
          u = e.dataType,
          n = e.showValidationBarWhenValid,
          t = e.showValidationIconWhenValid,
          r = e.showValidationBarWhenInvalid,
          d = e.showValidationIconWhenInvalid,
          h = e.inputAttributes,
          B = e.resizable,
          A = e.maxLength,
          C = e.showClearIcon,
          f = e.indicateChanged,
          y = e.instantValidation,
          g = this.state.focused;
        if ("normal" !== o && "discreet" !== o) throw new Error("Invalid input type. Please use one of [normal, discreet]. You used: " + o);
        var v = j[o],
          U = this._validate(_, this.inputRef.current),
          X = U.valid ? "abb/check-mark-circle-1" : "abb/error-circle-1",
          w = (U.valid && n || !U.valid && r) && "textarea" !== u,
          O = U.valid && t || !U.valid && d,
          k = "textarea" !== u && f;
        (b || !y && g) && (k = O = w = !1);
        var x = C && !!_ && !b,
          E = {};
        return A && -1 < A && (E = {
          maxLength: A
        }), S.createElement(D.ThemeContext.Consumer, null, function (e) {
          var o, n, t, r;
          return S.createElement("span", P({}, L.getHtmlAttributes(i.props), {
            className: N(j.root, j[e], (o = {}, o[j.isTextarea] = "textarea" === u, o), v, a, (n = {}, n[j.disabled] = b, n[j.hasChanged] = k, n[j.isValid] = U.valid, n[j.isInvalid] = !U.valid, n[j.showValidationResult] = w, n[j.hasIcon] = !!c, n[j.hasClearIcon] = x, n))
          }), S.createElement("span", {
            className: N(j.label)
          }, m && S.createElement("span", {
            className: j.requiredAsterisk
          }, "*"), l), S.createElement("span", {
            className: N(j.inputWrapper, (t = {}, t[j.hasFixedSize] = "textarea" !== u, t))
          }, "textarea" !== u && S.createElement("input", P({}, E, {
            className: j.inputElement,
            value: null == _ ? "" : _,
            disabled: b,
            ref: i.inputRef,
            required: m,
            placeholder: p || "",
            type: u,
            onChange: i._handleValueChange,
            onKeyUp: i._handleKeyPress,
            onFocus: i._handleFocus,
            onBlur: i._handleBlur
          }, h)), "textarea" === u && S.createElement("textarea", P({}, E, {
            className: N(j.inputElement, (r = {}, r[j.resizable] = B, r)),
            value: null == _ ? "" : _,
            disabled: b,
            ref: i.inputRef,
            required: m,
            placeholder: p || "",
            onChange: i._handleValueChange,
            onKeyUp: i._handleKeyPress,
            onFocus: i._handleFocus,
            onBlur: i._handleBlur
          }, h)), "textarea" !== u && S.createElement("span", {
            className: N(j.iconContainer)
          }, x && S.createElement("span", {
            className: j.clearIcon,
            onClick: i._handleClearIconClick
          }, S.createElement(M.CloseIcon, {
            sizeClass: "small"
          })), x && c && S.createElement("span", {
            className: j.iconSeparator
          }), c && S.createElement("span", {
            className: j.iconWrapper,
            onClick: i._handleIconClick
          }, S.createElement(T.Icon, {
            name: c,
            sizeClass: "small"
          })))), O && S.createElement("div", {
            className: N(j.validationMessageContainer)
          }, S.createElement("span", {
            className: j.validationIconWrapper
          }, S.createElement(T.Icon, {
            name: X,
            sizeClass: "small",
            color: U.valid ? I : R
          })), S.createElement("span", {
            className: j.validationMessage
          }, U.text)), s && S.createElement("div", {
            className: j.description
          }, s));
        });
      }, e.prototype._validate = function (e, o) {
        if (this.props.required && !e) return {
          valid: !1
        };
        if (this.props.validator) {
          var n = this.props.validator(e);
          return "string" == typeof n ? {
            valid: !1,
            text: e
          } : "boolean" == typeof n ? {
            valid: e
          } : void 0 !== n.valid ? {
            valid: n.valid,
            text: n.text
          } : {
            valid: !1
          };
        }
        switch (this.props.dataType) {
          case "text":
          case "color":
          case "date":
          case "email":
          case "month":
          case "number":
          case "password":
          case "search":
          case "tel":
          case "time":
          case "url":
          case "week":
            return o && "string" == typeof e && 0 < e.length ? {
              valid: o.validity.valid
            } : {
              valid: !0
            };
          default:
            return {
              valid: !0
            };
        }
      }, e.prototype._handleValueChange = function (e) {
        e.preventDefault(), this.props.onValueChange && this.props.onValueChange(e.currentTarget.value);
      }, e.prototype._handleKeyPress = function (e) {
        this.props.onKeyUp && this.props.onKeyUp(e), 27 === e.keyCode && this.clearValue();
      }, e.prototype._handleClearIconClick = function () {
        this.clearValue();
      }, e.prototype.clearValue = function () {
        this.props.onValueChange && this.props.onValueChange("");
      }, e.prototype._handleIconClick = function () {
        this.props.onIconClick && this.props.onIconClick(this.props.value);
      }, e.prototype._handleFocus = function (e) {
        this.setState({
          focused: !0
        });
      }, e.prototype._handleBlur = function (e) {
        this.setState({
          focused: !1
        });
      }, e.defaultProps = {
        required: !1,
        type: "normal",
        disabled: !1,
        icon: "",
        placeholder: null,
        showValidationBarWhenValid: !1,
        showValidationIconWhenValid: !1,
        showValidationBarWhenInvalid: !0,
        showValidationIconWhenInvalid: !1,
        value: null,
        inputAttributes: {},
        clearOnEscape: !0,
        showClearIcon: !1,
        indicateChanged: !1,
        instantValidation: !1,
        resizable: !0
      }, e;
    }(S.Component);
  o.Input = a, o.default = a;
}, function (e, o, n) {
  e.exports = {
    root: "ABB_CommonUX_Input__root",
    label: "ABB_CommonUX_Input__label",
    requiredAsterisk: "ABB_CommonUX_Input__requiredAsterisk",
    inputWrapper: "ABB_CommonUX_Input__inputWrapper",
    hasFixedSize: "ABB_CommonUX_Input__hasFixedSize",
    inputElement: "ABB_CommonUX_Input__inputElement",
    resizable: "ABB_CommonUX_Input__resizable",
    iconContainer: "ABB_CommonUX_Input__iconContainer",
    clearIcon: "ABB_CommonUX_Input__clearIcon",
    iconSeparator: "ABB_CommonUX_Input__iconSeparator",
    iconWrapper: "ABB_CommonUX_Input__iconWrapper",
    disabled: "ABB_CommonUX_Input__disabled",
    hasIcon: "ABB_CommonUX_Input__hasIcon",
    hasClearIcon: "ABB_CommonUX_Input__hasClearIcon",
    validationIconWrapper: "ABB_CommonUX_Input__validationIconWrapper",
    validationMessageContainer: "ABB_CommonUX_Input__validationMessageContainer",
    hidden: "ABB_CommonUX_Input__hidden",
    validationCollapsed: "ABB_CommonUX_Input__validationCollapsed",
    validationMessage: "ABB_CommonUX_Input__validationMessage",
    isTextarea: "ABB_CommonUX_Input__isTextarea",
    isValid: "ABB_CommonUX_Input__isValid",
    showValidationResult: "ABB_CommonUX_Input__showValidationResult",
    hasChanged: "ABB_CommonUX_Input__hasChanged",
    isInvalid: "ABB_CommonUX_Input__isInvalid",
    description: "ABB_CommonUX_Input__description",
    normal: "ABB_CommonUX_Input__normal",
    discreet: "ABB_CommonUX_Input__discreet",
    light: "ABB_CommonUX_Input__light",
    dark: "ABB_CommonUX_Input__dark"
  };
}, function (e, o, n) {
  "use strict";

  var _t8,
    r = this && this.__extends || (_t8 = function t(e, o) {
      return (_t8 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t8(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    });
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var i = function (o) {
    function e(e) {
      return o.call(this, e) || this;
    }
    return r(e, o), e.prototype.render = function () {
      return null;
    }, e.componentName = "DropdownGroup", e;
  }(n(0).Component);
  o.DropdownGroup = i, o.default = i;
}, function (e, o, n) {
  "use strict";

  var _t9,
    r = this && this.__extends || (_t9 = function t(e, o) {
      return (_t9 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t9(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    });
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var i = function (o) {
    function e(e) {
      return o.call(this, e) || this;
    }
    return r(e, o), e.prototype.render = function () {
      return null;
    }, e.defaultProps = {
      disabled: !1
    }, e.componentName = "DropdownOption", e;
  }(n(0).Component);
  o.DropdownOption = i, o.default = i;
}, function (e, o, n) {
  e.exports = {
    container: "ABB_CommonUX_Card__container",
    containerColumn: "ABB_CommonUX_Card__containerColumn",
    card: "ABB_CommonUX_Card__card",
    light: "ABB_CommonUX_Card__light",
    dark: "ABB_CommonUX_Card__dark",
    content: "ABB_CommonUX_Card__content"
  };
}, function (e, o, n) {
  "use strict";

  var _t10,
    r = this && this.__extends || (_t10 = function t(e, o) {
      return (_t10 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t10(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    s = this && this.__assign || function () {
      return (s = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var c,
    i,
    b = n(0),
    m = n(1),
    p = n(3),
    u = n(2),
    d = n(37);
  (i = c = o.ThreeStateValue || (o.ThreeStateValue = {}))[i.Unchecked = 0] = "Unchecked", i[i.Indeterminate = 1] = "Indeterminate", i[i.Checked = 2] = "Checked";
  var a = function (n) {
    function e(e) {
      var o = n.call(this, e) || this;
      return o._handleChange = o._handleChange.bind(o), o._handleClick = o._handleClick.bind(o), o;
    }
    return r(e, n), e.prototype.render = function () {
      var n = this,
        e = this.props,
        t = e.className,
        r = e.label,
        i = e.sizeClass,
        a = e.disabled,
        o = e.value,
        _ = "boolean" != typeof o ? o === c.Checked : o,
        l = o === c.Indeterminate;
      return b.createElement(p.ThemeContext.Consumer, null, function (e) {
        var o;
        return b.createElement("div", s({}, u.getHtmlAttributes(n.props), {
          className: m(d.root, d[e], d[i + "Size"], t, (o = {}, o[d.checked] = _, o[d.indeterminate] = l, o[d.disabled] = a, o))
        }), b.createElement("label", {
          onClick: n._handleClick
        }, b.createElement("input", {
          type: "checkbox",
          checked: _,
          disabled: a,
          ref: function ref(e) {
            return e && (e.indeterminate = l);
          },
          onChange: n._handleChange
        }), b.createElement("span", null, r)));
      });
    }, e.prototype._handleChange = function (e) {
      this.props.onChange && this.props.onChange();
    }, e.prototype._handleClick = function (e) {
      e.stopPropagation();
    }, e.defaultProps = {
      value: void 0,
      allowIndeterminate: !1,
      label: "",
      sizeClass: "large",
      disabled: !1
    }, e;
  }(b.Component);
  o.Checkbox = a, o.default = a;
}, function (e, o, n) {
  e.exports = {
    root: "ABB_CommonUX_Checkbox__root",
    disabled: "ABB_CommonUX_Checkbox__disabled",
    checked: "ABB_CommonUX_Checkbox__checked",
    indeterminate: "ABB_CommonUX_Checkbox__indeterminate",
    largeSize: "ABB_CommonUX_Checkbox__largeSize",
    smallSize: "ABB_CommonUX_Checkbox__smallSize",
    light: "ABB_CommonUX_Checkbox__light",
    dark: "ABB_CommonUX_Checkbox__dark"
  };
}, function (e, o, n) {
  e.exports = {
    containerRoot: "ABB_CommonUX_Collapsible__containerRoot",
    root: "ABB_CommonUX_Collapsible__root",
    shouldOpenOnNextCycle: "ABB_CommonUX_Collapsible__shouldOpenOnNextCycle",
    hasChildren: "ABB_CommonUX_Collapsible__hasChildren",
    expanderOnRight: "ABB_CommonUX_Collapsible__expanderOnRight",
    isClosed: "ABB_CommonUX_Collapsible__isClosed",
    isOpen: "ABB_CommonUX_Collapsible__isOpen",
    warning: "ABB_CommonUX_Collapsible__warning",
    header: "ABB_CommonUX_Collapsible__header",
    alarm: "ABB_CommonUX_Collapsible__alarm",
    icon: "ABB_CommonUX_Collapsible__icon",
    checkbox: "ABB_CommonUX_Collapsible__checkbox",
    headerExpanded: "ABB_CommonUX_Collapsible__headerExpanded",
    filtered: "ABB_CommonUX_Collapsible__filtered",
    light: "ABB_CommonUX_Collapsible__light",
    isSelected: "ABB_CommonUX_Collapsible__isSelected",
    customContent: "ABB_CommonUX_Collapsible__customContent",
    dark: "ABB_CommonUX_Collapsible__dark",
    depth0: "ABB_CommonUX_Collapsible__depth0",
    depth1: "ABB_CommonUX_Collapsible__depth1",
    depth2: "ABB_CommonUX_Collapsible__depth2",
    depth3: "ABB_CommonUX_Collapsible__depth3",
    depth4: "ABB_CommonUX_Collapsible__depth4",
    depth5: "ABB_CommonUX_Collapsible__depth5",
    depth6: "ABB_CommonUX_Collapsible__depth6",
    depth7: "ABB_CommonUX_Collapsible__depth7",
    depth8: "ABB_CommonUX_Collapsible__depth8",
    depth9: "ABB_CommonUX_Collapsible__depth9"
  };
}, function (e, o, n) {
  "use strict";

  var _t11,
    r = this && this.__extends || (_t11 = function t(e, o) {
      return (_t11 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t11(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    c = this && this.__assign || function () {
      return (c = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var b = n(0),
    m = n(1),
    p = n(25),
    u = n(3),
    d = n(2),
    h = n(20),
    i = function (n) {
      function e(e) {
        var o = n.call(this, e) || this;
        return o.closeAction = null, o.autoCloseTimer = void 0, o._onOpen = o._onOpen.bind(o), o._onCloseClick = o._onCloseClick.bind(o), o._cleanOnClose = o._cleanOnClose.bind(o), o._handleCloseDialog = o._handleCloseDialog.bind(o), o.props.dialog.registerResourceCleaner(o._cleanOnClose), o;
      }
      return r(e, n), e.prototype.componentWillUnmount = function () {
        this._cleanOnClose();
      }, e.prototype.render = function () {
        var o = this,
          e = this.props,
          n = e.closeOnEscape,
          t = e.closeOnLostFocus,
          r = e.dimBackground,
          i = e.hideBackground,
          a = e.containerClassName,
          _ = e.className,
          l = e.isOpen;
        if (!l) return this._cleanOnClose(), null;
        var s = [h.overlay];
        return i ? s.push(h.fullOpacityBackdrop) : r ? s.push(h.halfOpacityBackdrop) : s.push(h.transparentBackdrop), b.createElement(u.ThemeContext.Consumer, null, function (e) {
          return b.createElement(p, c({}, d.getHtmlAttributes(o.props), {
            isOpen: l || !1,
            ariaHideApp: !1,
            className: m(a, h.dialog, h[e], _),
            overlayClassName: m(s, h[e]),
            onRequestClose: o._handleCloseDialog,
            shouldCloseOnOverlayClick: t,
            shouldCloseOnEsc: n,
            onAfterOpen: o._onOpen
          }), o.props.children);
        });
      }, e.prototype._handleCloseDialog = function () {
        this.props.closeHandler && this.props.closeHandler();
      }, e.prototype._cleanOnClose = function () {
        this.autoCloseTimer && (clearTimeout(this.autoCloseTimer), this.autoCloseTimer = void 0);
      }, e.prototype._onOpen = function () {
        var e = this;
        this.props.onOpen && this.props.onOpen(), this.props.closeAfter && 0 < this.props.closeAfter && (this.autoCloseTimer = setTimeout(function () {
          e._handleCloseDialog();
        }, this.props.closeAfter));
      }, e.prototype._onCloseClick = function (e) {
        this.closeAction && this.closeAction();
      }, e;
    }(b.Component);
  o.DialogWrapper = i, o.default = i;
}, function (e, o, n) {
  "use strict";

  var _t12,
    r = this && this.__extends || (_t12 = function t(e, o) {
      return (_t12 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t12(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    x = this && this.__assign || function () {
      return (x = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var E = n(0),
    P = n(1),
    S = n(21),
    N = n(3),
    T = n(2),
    M = n(15),
    D = n(41),
    i = n(6),
    L = {
      small: 32,
      medium: 64,
      large: 128
    },
    a = function (n) {
      function e(e) {
        var o = n.call(this, e) || this;
        return o.state = {
          numberOfSegments: 0,
          noDraw: !1
        }, i.showExperimentalWarning("LoadingIndicator"), o._handleClick = o._handleClick.bind(o), o._handleResize = o._handleResize.bind(o), o;
      }
      return r(e, n), e.prototype.componentDidUpdate = function (e, o) {
        var n = this;
        e.type === this.props.type && e.sizeClass === this.props.sizeClass && e.determinate === this.props.determinate || (this.setState({
          noDraw: !0
        }), setTimeout(function () {
          return n.setState({
            noDraw: !1
          });
        }, 1));
      }, e.prototype.render = function () {
        var e,
          o,
          n,
          t,
          r,
          i,
          a,
          _ = this;
        if (this.state.noDraw) return null;
        var l = this.props,
          s = l.className,
          c = l.sizeClass,
          b = l.value,
          m = l.text,
          p = l.textWhenReady,
          u = l.type,
          d = l.color,
          h = l.determinate,
          B = null,
          A = Math.max(0, Math.min(100, b || 0)),
          C = 100 <= A || A <= 2;
        if ("radial" === u) {
          var f = L[c],
            y = f / 2,
            g = f / 2 * .8,
            v = 2 * Math.PI * g,
            U = ((100 - A) / 100 * v).toFixed(1),
            X = v.toFixed(1),
            w = c.charAt(0).toUpperCase() + c.slice(1),
            O = M.isIE() || M.isEdge();
          B = E.createElement(E.Fragment, null, E.createElement("div", {
            className: P((e = {}, e[D.isInternetExplorer] = O, e))
          }, E.createElement("svg", {
            width: f,
            height: f,
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg"
          }, O && E.createElement("g", null, Array.apply(null, {
            length: 15
          }).map(function (e, o) {
            return E.createElement("circle", {
              key: o,
              className: P(D.back),
              r: g,
              cx: y,
              cy: y,
              strokeDasharray: X + "px",
              strokeDashoffset: v - 1.1 * v * o / 360 + "px",
              transform: "rotate(" + 24 * o + ", " + y + ", " + y + ")"
            });
          })), !O && Array.apply(null, {
            length: 2
          }).map(function (e, n) {
            return E.createElement("g", {
              key: n
            }, Array.apply(null, {
              length: 15
            }).map(function (e, o) {
              return E.createElement("circle", {
                key: o,
                style: {
                  animation: D["radial15" + w + (o + 1)] + " 5s infinite linear " + 2.5 * n + "s forwards"
                },
                transform: "rotate(" + 24 * o + ")",
                className: P(D.back),
                r: g,
                cx: y,
                cy: y,
                strokeDasharray: X + "px",
                strokeDashoffset: X + "px"
              });
            }));
          }))), E.createElement("div", null, E.createElement("svg", {
            width: f,
            height: f,
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg"
          }, h && E.createElement("circle", {
            className: P(D.front, (o = {}, o[D.noMotion] = C, o)),
            r: g,
            cx: y,
            cy: y,
            strokeDasharray: X + "px",
            strokeDashoffset: U + "px"
          }))), h && "small" !== c && E.createElement("div", {
            className: D.value
          }, E.createElement("span", {
            className: P(D.text, (n = {}, n[D.fadeOutToAbove] = h && p && 100 <= A, n))
          }, m), E.createElement("span", {
            className: P(D.textWhenReady, (t = {}, t[D.fadeInFromBelow] = h && 100 <= A, t))
          }, p)));
        } else {
          var k = M.isIE() || M.isEdge();
          B = E.createElement(E.Fragment, null, (m || p) && E.createElement("div", {
            className: D.texts
          }, m && E.createElement("span", {
            className: P(D.texts, (r = {}, r[D.fadeOutToAbove] = h && p && 100 <= A, r))
          }, m), p && E.createElement("span", {
            className: P(D.textWhenReady, (i = {}, i[D.fadeInFromBelow] = h && 100 <= A, i))
          }, p)), E.createElement("div", {
            className: D.container
          }, E.createElement("div", {
            className: D.back
          }, 0 < this.state.numberOfSegments && Array.apply(null, {
            length: this.state.numberOfSegments
          }).map(function (e, o) {
            var n;
            return E.createElement("div", {
              key: "segment" + o
            }, E.createElement("div", {
              className: P((n = {}, n[D.isInternetExplorer] = k, n))
            }));
          })), h && E.createElement("div", {
            className: P(D.front, (a = {}, a[D.noMotion] = C, a)),
            style: {
              width: A + "%"
            }
          })));
        }
        return E.createElement(N.ThemeContext.Consumer, null, function (e) {
          return E.createElement("div", x({}, T.getHtmlAttributes(_.props), {
            className: P(D.root, D[e], D[u], h ? D.determinate : D.indeterminate, D[c], D[d], s),
            onClick: _._handleClick
          }), B, E.createElement(S.default, {
            handleWidth: !0,
            handleHeight: !1,
            onResize: _._handleResize
          }));
        });
      }, e.prototype._handleResize = function (e, o) {
        var n = this,
          t = 3 * Math.floor(Math.log(e));
        this.state.numberOfSegments !== t && (this.setState({
          numberOfSegments: 0
        }), setTimeout(function () {
          return n.setState({
            numberOfSegments: t
          });
        }, 1));
      }, e.prototype._handleClick = function (e) {
        e.preventDefault(), this.props.onClick && this.props.onClick(e);
      }, e.defaultProps = {
        sizeClass: "medium",
        value: void 0,
        text: void 0,
        textWhenReady: void 0,
        color: "red"
      }, e;
    }(E.Component);
  o.LoadingIndicator = a, o.default = a;
}, function (e, o, n) {
  e.exports = {
    root: "ABB_CommonUX_LoadingIndicator__root",
    bar: "ABB_CommonUX_LoadingIndicator__bar",
    texts: "ABB_CommonUX_LoadingIndicator__texts",
    text: "ABB_CommonUX_LoadingIndicator__text",
    textWhenReady: "ABB_CommonUX_LoadingIndicator__textWhenReady",
    fadeOutToAbove: "ABB_CommonUX_LoadingIndicator__fadeOutToAbove",
    fadeInFromBelow: "ABB_CommonUX_LoadingIndicator__fadeInFromBelow",
    container: "ABB_CommonUX_LoadingIndicator__container",
    back: "ABB_CommonUX_LoadingIndicator__back",
    barSlide: "ABB_CommonUX_LoadingIndicator__barSlide",
    isInternetExplorer: "ABB_CommonUX_LoadingIndicator__isInternetExplorer",
    front: "ABB_CommonUX_LoadingIndicator__front",
    noMotion: "ABB_CommonUX_LoadingIndicator__noMotion",
    small: "ABB_CommonUX_LoadingIndicator__small",
    medium: "ABB_CommonUX_LoadingIndicator__medium",
    large: "ABB_CommonUX_LoadingIndicator__large",
    determinate: "ABB_CommonUX_LoadingIndicator__determinate",
    red: "ABB_CommonUX_LoadingIndicator__red",
    blue: "ABB_CommonUX_LoadingIndicator__blue",
    grey: "ABB_CommonUX_LoadingIndicator__grey",
    indeterminate: "ABB_CommonUX_LoadingIndicator__indeterminate",
    light: "ABB_CommonUX_LoadingIndicator__light",
    dark: "ABB_CommonUX_LoadingIndicator__dark",
    radial: "ABB_CommonUX_LoadingIndicator__radial",
    rotation: "ABB_CommonUX_LoadingIndicator__rotation",
    value: "ABB_CommonUX_LoadingIndicator__value",
    radial15Small1: "ABB_CommonUX_LoadingIndicator__radial15Small1",
    radial15Small2: "ABB_CommonUX_LoadingIndicator__radial15Small2",
    radial15Small3: "ABB_CommonUX_LoadingIndicator__radial15Small3",
    radial15Small4: "ABB_CommonUX_LoadingIndicator__radial15Small4",
    radial15Small5: "ABB_CommonUX_LoadingIndicator__radial15Small5",
    radial15Small6: "ABB_CommonUX_LoadingIndicator__radial15Small6",
    radial15Small7: "ABB_CommonUX_LoadingIndicator__radial15Small7",
    radial15Small8: "ABB_CommonUX_LoadingIndicator__radial15Small8",
    radial15Small9: "ABB_CommonUX_LoadingIndicator__radial15Small9",
    radial15Small10: "ABB_CommonUX_LoadingIndicator__radial15Small10",
    radial15Small11: "ABB_CommonUX_LoadingIndicator__radial15Small11",
    radial15Small12: "ABB_CommonUX_LoadingIndicator__radial15Small12",
    radial15Small13: "ABB_CommonUX_LoadingIndicator__radial15Small13",
    radial15Small14: "ABB_CommonUX_LoadingIndicator__radial15Small14",
    radial15Small15: "ABB_CommonUX_LoadingIndicator__radial15Small15",
    radial15Medium1: "ABB_CommonUX_LoadingIndicator__radial15Medium1",
    radial15Medium2: "ABB_CommonUX_LoadingIndicator__radial15Medium2",
    radial15Medium3: "ABB_CommonUX_LoadingIndicator__radial15Medium3",
    radial15Medium4: "ABB_CommonUX_LoadingIndicator__radial15Medium4",
    radial15Medium5: "ABB_CommonUX_LoadingIndicator__radial15Medium5",
    radial15Medium6: "ABB_CommonUX_LoadingIndicator__radial15Medium6",
    radial15Medium7: "ABB_CommonUX_LoadingIndicator__radial15Medium7",
    radial15Medium8: "ABB_CommonUX_LoadingIndicator__radial15Medium8",
    radial15Medium9: "ABB_CommonUX_LoadingIndicator__radial15Medium9",
    radial15Medium10: "ABB_CommonUX_LoadingIndicator__radial15Medium10",
    radial15Medium11: "ABB_CommonUX_LoadingIndicator__radial15Medium11",
    radial15Medium12: "ABB_CommonUX_LoadingIndicator__radial15Medium12",
    radial15Medium13: "ABB_CommonUX_LoadingIndicator__radial15Medium13",
    radial15Medium14: "ABB_CommonUX_LoadingIndicator__radial15Medium14",
    radial15Medium15: "ABB_CommonUX_LoadingIndicator__radial15Medium15",
    radial15Large1: "ABB_CommonUX_LoadingIndicator__radial15Large1",
    radial15Large2: "ABB_CommonUX_LoadingIndicator__radial15Large2",
    radial15Large3: "ABB_CommonUX_LoadingIndicator__radial15Large3",
    radial15Large4: "ABB_CommonUX_LoadingIndicator__radial15Large4",
    radial15Large5: "ABB_CommonUX_LoadingIndicator__radial15Large5",
    radial15Large6: "ABB_CommonUX_LoadingIndicator__radial15Large6",
    radial15Large7: "ABB_CommonUX_LoadingIndicator__radial15Large7",
    radial15Large8: "ABB_CommonUX_LoadingIndicator__radial15Large8",
    radial15Large9: "ABB_CommonUX_LoadingIndicator__radial15Large9",
    radial15Large10: "ABB_CommonUX_LoadingIndicator__radial15Large10",
    radial15Large11: "ABB_CommonUX_LoadingIndicator__radial15Large11",
    radial15Large12: "ABB_CommonUX_LoadingIndicator__radial15Large12",
    radial15Large13: "ABB_CommonUX_LoadingIndicator__radial15Large13",
    radial15Large14: "ABB_CommonUX_LoadingIndicator__radial15Large14",
    radial15Large15: "ABB_CommonUX_LoadingIndicator__radial15Large15"
  };
}, function (e, n, o) {
  "use strict";

  function t(e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), t(o(50)), t(o(53));
}, function (e, o, n) {
  e.exports = {
    root: "ABB_CommonUX_AppHeader__root",
    light: "ABB_CommonUX_AppHeader__light",
    dark: "ABB_CommonUX_AppHeader__dark",
    spacer: "ABB_CommonUX_AppHeader__spacer"
  };
}, function (e, o, n) {
  "use strict";

  var _t13,
    r = this && this.__extends || (_t13 = function t(e, o) {
      return (_t13 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t13(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    B = this && this.__assign || function () {
      return (B = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    },
    i = this && this.__rest || function (e, o) {
      var n = {};
      for (var t in e) Object.prototype.hasOwnProperty.call(e, t) && o.indexOf(t) < 0 && (n[t] = e[t]);
      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var r = 0;
        for (t = Object.getOwnPropertySymbols(e); r < t.length; r++) o.indexOf(t[r]) < 0 && (n[t[r]] = e[t[r]]);
      }
      return n;
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var A = n(0),
    C = n(1),
    f = n(3),
    y = n(2),
    a = n(4),
    _ = n(12),
    g = n(54),
    v = n(55),
    l = n(33),
    s = n(34),
    U = n(56),
    c = n(5),
    b = n(15),
    m = c.getVariables(),
    X = function X(e) {
      return A.createElement(g.components.DropdownIndicator, B({}, e), A.createElement(a.Icon, {
        name: "abb/caret-down",
        sizeClass: "small"
      }));
    },
    w = function w(e) {
      return A.createElement(g.components.MultiValueRemove, B({}, e), A.createElement(_.CloseIcon, {
        sizeClass: "extra-small"
      }));
    },
    O = function O(e) {
      var o = e.getStyles,
        n = e.innerProps,
        t = n.ref,
        r = i(n, ["ref"]);
      return A.createElement("div", B({}, r, {
        ref: t,
        style: o("clearIndicator", e)
      }), A.createElement(_.CloseIcon, {
        sizeClass: "extra-small"
      }));
    },
    p = function (n) {
      function a(t) {
        var e = n.call(this, t) || this;
        e.groupName = "dropdown-" + a.DROPDOWN_COUNTER++, e.options = [], e.styles = {
          light: e.getStyles("light", e.props.sizeClass),
          dark: e.getStyles("dark", e.props.sizeClass)
        }, e._handleChange = e._handleChange.bind(e);
        var o = [],
          r = function r(e, o) {
            if (!e || !e.value) throw new Error("value not provided");
            if (!e.value || "string" != typeof e.value) throw new Error("invalid value type (or not provided)");
            var n = {
              label: e.label,
              value: e.value,
              isDisabled: void 0 !== t.disabled && t.disabled
            };
            o.push(n);
          },
          i = !1;
        if (A.Children.forEach(e.props.children, function (n, e) {
          if (n.type.componentName !== s.DropdownOption.componentName && n.type.componentName !== l.DropdownGroup.componentName) throw new Error("invalid child component, expected one of [DropdownOption, DropdownGroup], got: " + n.type);
          if (!n.props || !n.props.label || "string" != typeof n.props.label) throw new Error("invalid label type");
          if (n.type.componentName === s.DropdownOption.componentName) r(n.props, o);else {
            i = !0;
            var t = {
              label: n.props.label,
              options: new Array()
            };
            A.Children.forEach(n.props.children, function (e, o) {
              if (e.type.componentName !== s.DropdownOption.componentName) throw new Error("invalid child: " + n.type);
              r(e.props, t.options);
            }), o.push(t);
          }
        }), i && e.props.allowAdd) throw new Error("Adding free form values to a dropdown with grouped options is not allowed!");
        return e.options = o, e;
      }
      return r(a, n), a.prototype.render = function () {
        var n = this,
          e = this.props,
          t = e.className,
          o = e.multiselect,
          r = e.searchable,
          i = e.placeholder,
          a = e.label,
          _ = e.description,
          l = e.clearable,
          s = e.disabled,
          c = e.allowAdd,
          b = e.sizeClass,
          m = e.required,
          p = e.clearOnEscape,
          u = e.edited,
          d = [];
        this.props.value.forEach(function (o) {
          o.isNew ? d.push(o) : n.options.forEach(function (e) {
            e.hasOwnProperty("value") ? o.value === e.value && d.push(e) : e.hasOwnProperty("options") && e.options.forEach(function (e) {
              o.value === e.value && d.push(e);
            });
          });
        });
        var h = {
          options: this.options,
          isSearchable: r,
          isMulti: o,
          placeholder: i,
          isDisabled: s,
          isClearable: l,
          onChange: this._handleChange,
          value: d,
          escapeClearsValue: p,
          hideSelectedOptions: o,
          captureMenuScroll: !1,
          inputId: this.groupName
        };
        return A.createElement(f.ThemeContext.Consumer, null, function (e) {
          var o;
          return A.createElement("div", B({}, y.getHtmlAttributes(n.props), {
            className: C(U.root, U[e], U[b], (o = {}, o[U.invalid] = m && 0 === d.length, o[U.hasChanged] = u, o[U.dense] = !a && !_, o), t)
          }), a && A.createElement("div", {
            className: C(U.label)
          }, m && A.createElement("span", {
            className: U.requiredAsterisk
          }, "*"), a), A.createElement("div", {
            className: U.comp
          }, c ? A.createElement(v.default, B({}, h, {
            components: {
              DropdownIndicator: X,
              MultiValueRemove: w,
              ClearIndicator: O
            },
            styles: n.styles[e]
          })) : A.createElement(g.default, B({}, h, {
            components: {
              DropdownIndicator: X,
              MultiValueRemove: w,
              ClearIndicator: O
            },
            styles: n.styles[e]
          }))), _ && A.createElement("div", null, _));
        });
      }, a.prototype._handleChange = function (e) {
        this.props.onChange && (e ? e instanceof Array ? this.props.onChange(e.map(function (e) {
          return {
            value: e.value,
            label: e.label,
            isNew: e.__isNew__ || e.isNew || !1
          };
        })) : this.props.onChange([{
          value: e.value,
          label: e.label,
          isNew: e.__isNew__ || e.isNew || !1
        }]) : this.props.onChange([]));
      }, a.prototype.getStyles = function (e, o) {
        var n = this,
          t = ["small", "medium", "large"].indexOf(o);
        return "light" === e ? {
          clearIndicator: function clearIndicator(e, o) {
            return {
              color: m["color-grey-60"],
              padding: "0",
              margin: "6px",
              borderRadius: "10px",
              width: "16px",
              height: "16px"
            };
          },
          container: function container(e, o) {
            return B({}, e);
          },
          control: function control(e, o) {
            return B({}, e, {
              borderColor: n.props.noBorders ? "transparent" : o.isFocused ? m["color-accent-light"] : m["color-grey-30"],
              borderRadius: 0,
              boxShadow: "none",
              background: b.hexToRGB(m["color-grey-0"], .8),
              height: "unset",
              minHeight: ["32", "40", "48"][t] + "px",
              cursor: "pointer",
              ":hover": {
                background: m["color-grey-10"],
                borderColor: n.props.noBorders ? "transparent" : m["color-grey-40"]
              }
            });
          },
          dropdownIndicator: function dropdownIndicator(e, o) {
            return {
              margin: "1px " + ["4", "8", "12"][t] + "px 0 0",
              lineHeight: 1
            };
          },
          group: function group(e, o) {
            return {};
          },
          groupHeading: function groupHeading(e, o) {
            return {
              padding: "8px",
              color: m["color-grey-60"],
              backgroundColor: "transparent",
              fontFamily: "ABBVoice-light"
            };
          },
          indicatorsContainer: function indicatorsContainer(e, o) {
            return B({}, e);
          },
          indicatorSeparator: function indicatorSeparator(e, o) {
            return {
              height: "24px",
              background: n.props.clearable && o.hasValue && !n.props.disabled ? m["color-grey-30"] : "transparent",
              marginRight: "6px",
              width: "1px"
            };
          },
          input: function input(e, o) {
            return {
              height: "16px",
              lineHeight: "16px",
              marginBottom: ["4", "8", "12"][t] + "px",
              borderColor: n.props.noBorders ? "transparent" : m["color-accent-light"]
            };
          },
          loadingIndicator: function loadingIndicator(e, o) {
            return B({}, e);
          },
          loadingMessage: function loadingMessage(e, o) {
            return B({}, e);
          },
          menu: function menu(e, o) {
            return B({}, e, {
              marginTop: "1px",
              borderRadius: 0
            });
          },
          menuList: function menuList(e, o) {
            return B({}, e);
          },
          multiValue: function multiValue(e, o) {
            return B({}, e, {
              backgroundColor: m["color-grey-20"],
              borderRadius: "12px",
              margin: "3px 8px 0 0px",
              paddingLeft: "8px",
              height: "24px",
              fontSize: "12px",
              overflow: "hidden",
              alignItems: "center"
            });
          },
          multiValueLabel: function multiValueLabel(e, o) {
            return {
              borderRadius: "0",
              fontSize: "inherit",
              padding: "0",
              paddingLeft: "0",
              marginRight: "8px"
            };
          },
          multiValueRemove: function multiValueRemove(e, o) {
            return {
              marginRight: "4px"
            };
          },
          noOptionsMessage: function noOptionsMessage(e, o) {
            return B({}, e);
          },
          option: function option(e, o) {
            return B({}, e, {
              color: b.hexToRGB(m["color-grey-90"], o.isDisabled ? .5 : 1),
              backgroundColor: "transparent",
              cursor: "pointer",
              padding: "8px 16px",
              ":hover": {
                backgroundColor: m["color-grey-10"]
              }
            });
          },
          placeholder: function placeholder(e, o) {
            return {
              color: m["color-grey-40"],
              height: "16px",
              lineHeight: "16px",
              width: "0"
            };
          },
          singleValue: function singleValue(e, o) {
            return {
              maxWidth: "calc(100% - 8px)",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            };
          },
          valueContainer: function valueContainer(e, o) {
            return B({}, e, {
              padding: "0 0 0 8px",
              height: "unset",
              margin: "0 0 3px 0"
            });
          }
        } : "dark" === e ? {
          clearIndicator: function clearIndicator(e, o) {
            return {
              color: m["color-grey-70"],
              padding: "0",
              margin: "6px",
              borderRadius: "10px",
              width: "16px",
              height: "16px"
            };
          },
          container: function container(e, o) {
            return B({}, e);
          },
          control: function control(e, o) {
            return B({}, e, {
              borderColor: n.props.noBorders ? "transparent" : o.isFocused ? m["color-accent-dark"] : m["color-grey-30"],
              borderRadius: 0,
              boxShadow: "none",
              background: b.hexToRGB(m["color-grey-100"], 1),
              height: "unset",
              minHeight: ["32", "40", "48"][t] + "px",
              cursor: "pointer",
              ":hover": {
                background: m["color-grey-80"],
                borderColor: n.props.noBorders ? "transparent" : m["color-grey-50"]
              },
              ":active": {
                background: m["color-grey-70"],
                borderColor: n.props.noBorders ? "transparent" : m["color-grey-40"]
              }
            });
          },
          dropdownIndicator: function dropdownIndicator(e, o) {
            return {
              margin: "1px " + ["4", "8", "12"][t] + "px 0 0",
              lineHeight: 1,
              color: m["color-grey-20"]
            };
          },
          group: function group(e, o) {
            return {};
          },
          groupHeading: function groupHeading(e, o) {
            return {
              padding: "8px",
              color: m["color-grey-60"],
              backgroundColor: "transparent",
              fontFamily: "ABBVoice-light"
            };
          },
          indicatorsContainer: function indicatorsContainer(e, o) {
            return B({}, e);
          },
          indicatorSeparator: function indicatorSeparator(e, o) {
            return {
              height: "24px",
              background: n.props.clearable && o.hasValue ? m["color-grey-60"] : "transparent",
              marginRight: "6px",
              width: "1px"
            };
          },
          input: function input(e, o) {
            return {
              height: "16px",
              lineHeight: "16px",
              marginBottom: ["4", "8", "12"][t] + "px"
            };
          },
          loadingIndicator: function loadingIndicator(e, o) {
            return B({}, e);
          },
          loadingMessage: function loadingMessage(e, o) {
            return B({}, e);
          },
          menu: function menu(e, o) {
            return B({}, e, {
              marginTop: "1px",
              borderRadius: 0,
              backgroundColor: m["color-grey-100"],
              color: m["color-grey-20"]
            });
          },
          menuList: function menuList(e, o) {
            return B({}, e, {
              color: m["color-grey-20"],
              backgroundColor: m["color-grey-100"]
            });
          },
          multiValue: function multiValue(e, o) {
            return B({}, e, {
              color: m["color-grey-20"],
              backgroundColor: m["color-grey-70"],
              borderRadius: "12px",
              margin: "3px 8px 0 0px",
              paddingLeft: "8px",
              height: "24px",
              fontSize: "12px",
              overflow: "hidden",
              alignItems: "center"
            });
          },
          multiValueLabel: function multiValueLabel(e, o) {
            return {
              borderRadius: "0",
              fontSize: "inherit",
              padding: "0",
              paddingLeft: "0",
              marginRight: "8px"
            };
          },
          multiValueRemove: function multiValueRemove(e, o) {
            return {
              marginRight: "4px"
            };
          },
          noOptionsMessage: function noOptionsMessage(e, o) {
            return B({}, e);
          },
          option: function option(e, o) {
            return B({}, e, {
              color: b.hexToRGB(m["color-grey-20"], o.isDisabled ? .5 : 1),
              backgroundColor: "transparent",
              cursor: "pointer",
              padding: "8px 16px",
              ":hover": {
                backgroundColor: m["color-grey-80"]
              }
            });
          },
          placeholder: function placeholder(e, o) {
            return {
              color: m["color-grey-40"],
              height: "16px",
              lineHeight: "16px",
              width: "0"
            };
          },
          singleValue: function singleValue(e, o) {
            return {
              maxWidth: "calc(100% - 8px)",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              color: m["color-grey-20"]
            };
          },
          valueContainer: function valueContainer(e, o) {
            return B({}, e, {
              padding: "0 0 0 8px",
              height: "unset",
              margin: "0"
            });
          }
        } : {
          clearIndicator: function clearIndicator(e, o) {
            return B({}, e);
          },
          container: function container(e, o) {
            return B({}, e);
          },
          control: function control(e, o) {
            return B({}, e, {
              borderRadius: 0,
              background: b.hexToRGB(m["color-grey-100"], .6)
            });
          },
          dropdownIndicator: function dropdownIndicator(e, o) {
            return B({}, e);
          },
          group: function group(e, o) {
            return B({}, e);
          },
          groupHeading: function groupHeading(e, o) {
            return B({}, e);
          },
          indicatorsContainer: function indicatorsContainer(e, o) {
            return B({}, e);
          },
          indicatorSeparator: function indicatorSeparator(e, o) {
            return {
              display: "none"
            };
          },
          input: function input(e, o) {
            return B({}, e);
          },
          loadingIndicator: function loadingIndicator(e, o) {
            return B({}, e);
          },
          loadingMessage: function loadingMessage(e, o) {
            return B({}, e);
          },
          menu: function menu(e, o) {
            return B({}, e, {
              marginTop: "1px",
              borderRadius: 0
            });
          },
          menuList: function menuList(e, o) {
            return B({}, e);
          },
          multiValue: function multiValue(e, o) {
            return B({}, e);
          },
          multiValueLabel: function multiValueLabel(e, o) {
            return B({}, e);
          },
          multiValueRemove: function multiValueRemove(e, o) {
            return {};
          },
          noOptionsMessage: function noOptionsMessage(e, o) {
            return B({}, e);
          },
          option: function option(e, o) {
            return B({}, e);
          },
          placeholder: function placeholder(e, o) {
            return B({}, e);
          },
          singleValue: function singleValue(e, o) {
            return B({}, e);
          },
          valueContainer: function valueContainer(e, o) {
            return B({}, e);
          }
        };
      }, a.defaultProps = {
        multiselect: !1,
        searchable: !1,
        placeholder: "",
        label: "",
        value: [],
        description: "",
        clearable: !1,
        disabled: !1,
        allowAdd: !1,
        sizeClass: "small",
        required: !1,
        noBorders: !1,
        edited: !1,
        clearOnEscape: !0
      }, a.DROPDOWN_COUNTER = 1, a;
    }(A.Component);
  o.Dropdown = p, o.default = p;
}, function (e, n, o) {
  "use strict";

  Object.defineProperty(n, "__esModule", {
    value: !0
  }), function (e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }(o(57));
}, function (e, n, o) {
  "use strict";

  function t(e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), t(o(60)), t(o(30));
}, function (e, o) {
  e.exports = require("d3");
}, function (e, o, n) {
  e.exports = {
    root: "ABB_CommonUX_LoginScreen__root",
    loadingIndicator: "ABB_CommonUX_LoginScreen__loadingIndicator",
    header: "ABB_CommonUX_LoginScreen__header",
    logo: "ABB_CommonUX_LoginScreen__logo",
    contentWrapper: "ABB_CommonUX_LoginScreen__contentWrapper",
    content: "ABB_CommonUX_LoginScreen__content",
    productName: "ABB_CommonUX_LoginScreen__productName",
    productSubName: "ABB_CommonUX_LoginScreen__productSubName",
    formRow: "ABB_CommonUX_LoginScreen__formRow",
    password: "ABB_CommonUX_LoginScreen__password",
    customContent: "ABB_CommonUX_LoginScreen__customContent",
    bottom: "ABB_CommonUX_LoginScreen__bottom",
    buttons: "ABB_CommonUX_LoginScreen__buttons",
    button: "ABB_CommonUX_LoginScreen__button",
    flexSpring: "ABB_CommonUX_LoginScreen__flexSpring",
    copyright: "ABB_CommonUX_LoginScreen__copyright",
    loading: "ABB_CommonUX_LoginScreen__loading",
    noMaxHeight: "ABB_CommonUX_LoginScreen__noMaxHeight",
    footer: "ABB_CommonUX_LoginScreen__footer"
  };
}, function (e, o, n) {
  "use strict";

  var _t14,
    r = this && this.__extends || (_t14 = function t(e, o) {
      return (_t14 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t14(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    A = this && this.__assign || function () {
      return (A = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var C = n(0),
    f = n(67),
    y = n(3),
    g = n(29),
    v = n(5).getVariables(),
    i = function (n) {
      function e(e) {
        var o = n.call(this, e) || this;
        return o.closeAction = null, o.content = null, o._onOpen = o._onOpen.bind(o), o._onClose = o._onClose.bind(o), o._onCloseClick = o._onCloseClick.bind(o), o._setCloseHandler = o._setCloseHandler.bind(o), o;
      }
      return r(e, n), e.prototype.render = function () {
        var n = this,
          e = C.Children.toArray(this.props.children);
        if (2 !== e.length || "function" != typeof e[e.length - 1].type || e[e.length - 1].type.componentName !== g.Popup.componentName) throw new Error("ERROR: Invalid popup construction: second element is not of type Popup.");
        var o = e[0];
        this.content = C.cloneElement(e[e.length - 1], {
          closeAction: this._onCloseClick
        });
        var t = this.content.props,
          r = t.trigger,
          i = t.defaultOpen,
          a = t.closeOnLostFocus,
          _ = t.show,
          l = t.position;
        if (void 0 !== _ && ("click" === r || "hover" === r)) throw new Error("ERROR: Invalid popup construction: controlled popup cannot have trigger rule.");
        var s = void 0 !== _,
          c = a ? {
            zIndex: v.popupOverlayZIndex
          } : {
            zIndex: v.popupOverlayZIndex,
            display: "none"
          },
          b = "rgba(0, 0, 0, 0.35)",
          m = "rgba(0, 0, 0, 0.5)",
          p = this.content.props.style || {};
        p.width = p.width || "unset", p.zIndex = p.zIndex || v.popupContainerZIndex, p.padding = p.padding || "0", p.border = p.border || "none";
        var u,
          d = {
            light: A({}, p, {
              border: "1px solid " + v["color-grey-10"],
              boxShadow: b + " 0px 6px 12px"
            }),
            dark: A({}, p, {
              border: "1px solid " + v["color-grey-80"],
              boxShadow: m + " 0px 6px 18px"
            })
          },
          h = {
            boxSizing: "border-box",
            height: "12px",
            width: "12px",
            margin: "-6px",
            boxShadow: "none"
          },
          B = {
            light: A({}, h, {
              border: "1px solid " + v["color-grey-10"],
              background: v["color-content-background-light"]
            }),
            dark: A({}, h, {
              border: "1px solid " + v["color-grey-80"],
              background: v["color-content-background-dark"]
            })
          };
        return u = s ? {
          on: "hover",
          mouseEnterDelay: 2147483647,
          mouseLeaveDelay: 2147483647,
          open: _
        } : {
          on: r
        }, C.createElement(y.ThemeContext.Consumer, null, function (e) {
          return C.createElement(f.default, A({}, u, {
            id: n.content.props.id,
            className: n.content.props.className,
            trigger: o,
            defaultOpen: i,
            closeOnDocumentClick: a,
            closeOnEscape: !1,
            overlayStyle: c,
            position: l,
            contentStyle: d[e],
            arrowStyle: B[e],
            onOpen: n._onOpen,
            onClose: n._onClose,
            modal: !1
          }), function (e, o) {
            return n._setCloseHandler(e), n.content;
          });
        });
      }, e.prototype._setCloseHandler = function (e) {
        this.closeAction = e.bind(this);
      }, e.prototype._onOpen = function () {
        var e = this;
        this.content && this.content.props && this.content.props.onOpen && this.content.props.onOpen(), this.content && this.content.props && this.content.props.closeAfter && 0 < this.content.props.closeAfter && setTimeout(function () {
          e.closeAction();
        }, this.content.props.closeAfter);
      }, e.prototype._onClose = function () {
        this.content && this.content.props.onClose && this.content.props.onClose();
      }, e.prototype._onCloseClick = function (e) {
        this.closeAction && this.closeAction();
      }, e.componentName = "WithPopup", e;
    }(C.Component);
  o.WithPopup = i, o.default = i;
}, function (e, o, n) {
  "use strict";

  var _t15,
    r = this && this.__extends || (_t15 = function t(e, o) {
      return (_t15 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t15(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    u = this && this.__assign || function () {
      return (u = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var d = n(0),
    h = n(51),
    B = n(1),
    A = n(3),
    C = n(2),
    f = n(4),
    y = n(12),
    g = n(52),
    i = function (n) {
      function e(e) {
        var o = n.call(this, e) || this;
        return o.containerEl = null, o._handleClick = o._handleClick.bind(o), o._addNewTab = o._addNewTab.bind(o), o._removeTab = o._removeTab.bind(o), o;
      }
      return r(e, n), e.prototype.componentDidMount = function () {
        var e = this.props.containerId;
        if (e) {
          if (this.containerEl = document.getElementById(e), !this.containerEl) throw new Error("Cannot find container node!");
          this.setState({});
        }
      }, e.prototype.render = function () {
        var e,
          a = this,
          o = this.props,
          n = o.className,
          t = o.type,
          _ = o.stretch,
          r = o.contentClassName,
          i = o.allowAdd,
          l = o.allowRemove,
          s = o.showContentBorderOnPanelTab,
          c = d.Children.map(this.props.children, function (e, o) {
            var n,
              t,
              r,
              i = B([(n = {}, n[g.active] = a.props.activeTab === o, n), (t = {}, t[g.disabled] = e.props.disabled, t), (r = {}, r[g.stretch] = _, r)]);
            return d.createElement("li", {
              key: "tab-" + o,
              className: i,
              onClick: function onClick(e) {
                return a._handleClick(o, e);
              }
            }, d.createElement("div", {
              className: l ? g.headerPaddingWithClose : g.headerPadding
            }, " "), d.createElement("a", {
              href: "#"
            }, e.props.title), d.createElement("div", {
              className: l ? g.headerPaddingWithClose : g.headerPadding
            }, " "), l && d.createElement("span", null, d.createElement(y.CloseIcon, {
              sizeClass: "small",
              onClick: function onClick(e) {
                return a._removeTab(o, e);
              }
            })));
          });
        c || (c = []), i && c.push(d.createElement("li", {
          key: "add-new-tab",
          className: g.tabAddControl,
          onClick: function onClick(e) {
            return a._addNewTab(e);
          }
        }, d.createElement("a", {
          href: "#"
        }, d.createElement(f.Icon, {
          name: "abb/plus",
          sizeClass: "small"
        }))));
        var b = d.Children.map(this.props.children, function (e, o) {
            var n;
            return d.createElement("div", u({}, C.getHtmlAttributes(e.props), {
              key: "tabcontent-" + o,
              className: B(g.tabItemRoot, e.props.className, (n = {}, n[g.activeContent] = a.props.activeTab === o, n))
            }), e.props.children);
          }),
          m = d.createElement("div", {
            className: B(g.content, (e = {}, e[g.borderOnContent] = "panel" === t && s, e), r)
          }, b),
          p = null;
        return this.containerEl && (p = h.createPortal(m, this.containerEl)), d.createElement(A.ThemeContext.Consumer, null, function (e) {
          var o;
          return d.createElement("div", u({}, C.getHtmlAttributes(a.props), {
            className: B(g.root, g[t], g[e], (o = {}, o[g.defaultPadLeft] = !0 === a.props.padLeft, o), n)
          }), d.createElement("ul", {
            style: {
              paddingLeft: a.props.padLeft && "string" == typeof a.props.padLeft ? a.props.padLeft : ""
            }
          }, c), p || m);
        });
      }, e.prototype._handleClick = function (e, o) {
        o.preventDefault(), d.Children.toArray(this.props.children)[e].props.disabled || this.props.onTabChange && this.props.onTabChange(this.props.activeTab, e);
      }, e.prototype._addNewTab = function (e) {
        e.preventDefault(), this.props.onAddNewTab && this.props.onAddNewTab(this, d.Children.count(this.props.children));
      }, e.prototype._removeTab = function (e, o) {
        o.stopPropagation(), this.props.onRemoveTab && this.props.onRemoveTab(this, e);
      }, e.defaultProps = {
        activeTab: 0,
        type: "primary",
        containerId: null,
        stretch: !1,
        allowAdd: !1,
        allowRemove: !1,
        showContentBorderOnPanelTab: !0,
        padLeft: !1
      }, e;
    }(d.Component);
  o.TabControl = i, o.default = i;
}, function (e, o) {
  e.exports = require("react-dom");
}, function (e, o, n) {
  e.exports = {
    root: "ABB_CommonUX_TabControl__root",
    headerPadding: "ABB_CommonUX_TabControl__headerPadding",
    headerPaddingWithClose: "ABB_CommonUX_TabControl__headerPaddingWithClose",
    tabAddControl: "ABB_CommonUX_TabControl__tabAddControl",
    disabled: "ABB_CommonUX_TabControl__disabled",
    stretch: "ABB_CommonUX_TabControl__stretch",
    content: "ABB_CommonUX_TabControl__content",
    defaultPadLeft: "ABB_CommonUX_TabControl__defaultPadLeft",
    primary: "ABB_CommonUX_TabControl__primary",
    secondary: "ABB_CommonUX_TabControl__secondary",
    panel: "ABB_CommonUX_TabControl__panel",
    active: "ABB_CommonUX_TabControl__active",
    light: "ABB_CommonUX_TabControl__light",
    borderOnContent: "ABB_CommonUX_TabControl__borderOnContent",
    dark: "ABB_CommonUX_TabControl__dark",
    tabItemRoot: "ABB_CommonUX_TabControl__tabItemRoot",
    activeContent: "ABB_CommonUX_TabControl__activeContent"
  };
}, function (e, o, n) {
  "use strict";

  var _t16,
    r = this && this.__extends || (_t16 = function t(e, o) {
      return (_t16 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t16(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    });
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var i = function (o) {
    function e(e) {
      return o.call(this, e) || this;
    }
    return r(e, o), e.prototype.render = function () {
      return null;
    }, e.defaultProps = {
      disabled: !1
    }, e;
  }(n(0).Component);
  o.TabItem = i, o.default = i;
}, function (e, o) {
  e.exports = require("react-select");
}, function (e, o) {
  e.exports = require("react-select/lib/Creatable");
}, function (e, o, n) {
  e.exports = {
    root: "ABB_CommonUX_Dropdown__root",
    label: "ABB_CommonUX_Dropdown__label",
    requiredAsterisk: "ABB_CommonUX_Dropdown__requiredAsterisk",
    description: "ABB_CommonUX_Dropdown__description",
    comp: "ABB_CommonUX_Dropdown__comp",
    invalid: "ABB_CommonUX_Dropdown__invalid",
    dense: "ABB_CommonUX_Dropdown__dense",
    small: "ABB_CommonUX_Dropdown__small",
    medium: "ABB_CommonUX_Dropdown__medium",
    large: "ABB_CommonUX_Dropdown__large",
    light: "ABB_CommonUX_Dropdown__light",
    hasChanged: "ABB_CommonUX_Dropdown__hasChanged",
    dark: "ABB_CommonUX_Dropdown__dark"
  };
}, function (e, o, n) {
  "use strict";

  var _t17,
    r = this && this.__extends || (_t17 = function t(e, o) {
      return (_t17 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t17(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    a = this && this.__assign || function () {
      return (a = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var _ = n(0),
    l = n(1),
    s = n(3),
    c = n(2),
    b = n(58),
    i = function (n) {
      function e(e) {
        var o = n.call(this, e) || this;
        return o._handleClick = o._handleClick.bind(o), o;
      }
      return r(e, n), e.prototype.render = function () {
        var n = this,
          e = this.props,
          t = e.className,
          r = e.underline,
          o = e.download,
          i = {};
        return o && (i.download = !0), ["href", "referrerPolicy", "target", "rel"].forEach(function (e) {
          n.props[e] && (i[e] = n.props[e]);
        }), _.createElement(s.ThemeContext.Consumer, null, function (e) {
          var o;
          return _.createElement("a", a({}, i, c.getHtmlAttributes(n.props), {
            className: l(b.root, b[e], t, (o = {}, o[b.underline] = r, o)),
            onClick: n._handleClick
          }), n.props.children);
        });
      }, e.prototype._handleClick = function (e) {
        this.props.onClick && this.props.onClick(e);
      }, e.defaultProps = {
        underline: !1,
        download: !1
      }, e;
    }(_.Component);
  o.Link = i, o.default = i;
}, function (e, o, n) {
  e.exports = {
    root: "ABB_CommonUX_Link__root",
    light: "ABB_CommonUX_Link__light",
    dark: "ABB_CommonUX_Link__dark",
    underline: "ABB_CommonUX_Link__underline"
  };
}, function (e, o, n) {
  "use strict";

  var _t18,
    r = this && this.__extends || (_t18 = function t(e, o) {
      return (_t18 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t18(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    O = this && this.__assign || function () {
      return (O = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var k = n(0),
    x = n(1),
    E = n(3),
    P = n(2),
    S = n(118),
    N = n(4),
    T = n(38),
    i = function (n) {
      function w(e) {
        var o = n.call(this, e) || this;
        return o.handleClick = o.handleClick.bind(o), o.onChildComponentClick = o.onChildComponentClick.bind(o), o.onCheckboxClick = o.onCheckboxClick.bind(o), o;
      }
      return r(w, n), w.prototype.render = function () {
        var n = this,
          e = this.props,
          t = e.className,
          r = e.title,
          o = e.icon,
          i = e.alarmState,
          a = e.expandAll,
          _ = e.collapseAll,
          l = e._passedByParent_,
          s = l.filter,
          c = l.filterResults,
          b = l.hideFiltered,
          m = l.selected,
          p = l.depth,
          u = l.expanderOnRight,
          d = l.treeContainsIcon,
          h = l.treeContainsCheckbox,
          B = "";
        if (c && !c.recursiveMatch && !c.match) {
          if (b) return null;
          B = T.filtered;
        }
        var A = o || (d ? "empty" : void 0),
          C = "warning" === i,
          f = "alarm" === i ? T.alarm : C ? T.warning : "",
          y = A ? k.createElement(N.Icon, {
            name: A,
            className: T.icon,
            sizeClass: "small"
          }) : void 0,
          g = 0,
          v = this.props.children ? k.Children.map(this.props.children, function (e, o) {
            return e && e.props ? "object" == typeof e.type && e.type.componentName !== w.componentName ? k.createElement("div", {
              className: T.customContent
            }, e) : k.cloneElement(e, {
              _passedByParent_: {
                filter: s,
                filterResults: c && c.childResults && c.childResults[g++],
                hideFiltered: b,
                onComponentClick: n.onChildComponentClick,
                selected: m,
                depth: p + 1,
                expanderOnRight: u,
                treeContainsIcon: d,
                treeContainsCheckbox: h
              },
              expandAll: a,
              collapseAll: _
            }) : e;
          }) : this.props.children,
          U = Array.isArray(m) ? -1 !== m.indexOf(this) : this === m,
          X = T.header + " " + T.headerExpanded;
        return k.createElement(E.ThemeContext.Consumer, null, function (e) {
          var o;
          return k.createElement(S.default, O({}, P.getHtmlAttributes(n.props), {
            className: T.isClosed,
            extraClasses: x(f, t, T[e], B, T["depth" + p], (o = {}, o[T.expanderOnRight] = u, o)),
            openedClassName: T.isOpen,
            trigger: r,
            classParentString: x(T.root),
            triggerClassName: T.header,
            triggerOpenedClassName: X,
            hasChildrenClassName: T.hasChildren,
            handleTriggerClick: n.handleClick,
            triggerIcon: y,
            open: a || void 0,
            isSelected: U,
            selectedClassName: T.isSelected,
            triggerDisabled: a,
            checked: n.props.checked,
            leaveSpaceForCheckbox: h,
            handleCheckboxClick: n.onCheckboxClick
          }), v);
        });
      }, w.prototype.onChildComponentClick = function (e, o) {
        this.props._passedByParent_ && this.props._passedByParent_.onComponentClick && this.props._passedByParent_.onComponentClick(e, [this].concat(o));
      }, w.prototype.handleClick = function (e, o) {
        this.props.onClick && this.props.onClick("" + e, o), !o.isPropagationStopped() && this.props._passedByParent_ && this.props._passedByParent_.onComponentClick && this.props._passedByParent_.onComponentClick(this, []);
      }, w.prototype.onCheckboxClick = function () {
        this.props.onClickCheckbox && this.props.onClickCheckbox();
      }, w.defaultProps = {
        alarmState: "normal",
        expandAll: !1,
        collapseAll: !1
      }, w.componentName = "Collapsible", w;
    }(k.Component);
  o.Collapsible = i, o.default = i;
}, function (e, o, n) {
  "use strict";

  var _t19,
    r = this && this.__extends || (_t19 = function t(e, o) {
      return (_t19 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t19(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    });
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var m = n(0),
    p = n(1),
    u = n(25),
    d = n(3),
    h = n(30),
    B = n(20),
    i = function (n) {
      function e(e) {
        var o = n.call(this, e) || this;
        return o.state = {
          showDialog: !1
        }, o.closeAction = null, o.content = null, o.autoCloseTimer = void 0, o._onBeforeOpen = o._onBeforeOpen.bind(o), o._onOpen = o._onOpen.bind(o), o.closeDialog = o.closeDialog.bind(o), o._onCloseClick = o._onCloseClick.bind(o), o._handleOpenDialog = o._handleOpenDialog.bind(o), o._handleCloseDialog = o._handleCloseDialog.bind(o), o._cleanOnClose = o._cleanOnClose.bind(o), o;
      }
      return r(e, n), e.prototype.closeDialog = function () {
        this._handleCloseDialog();
      }, e.prototype.componentWillUnmount = function () {
        this._cleanOnClose();
      }, e.prototype.render = function () {
        var e,
          o = this,
          n = m.Children.toArray(this.props.children);
        if (2 !== n.length || !n[1].type || n[1].type.componentName !== h.Dialog.componentName) throw new Error("Invalid Dialog construction. Expected: <WithDialog><any-single-element/><Dialog /></WithDialog>");
        this.content = m.cloneElement(n[1], {
          closeAction: this.closeDialog
        });
        var t = this.content.props,
          r = t.trigger,
          i = t.closeOnEscape,
          a = t.closeOnLostFocus,
          _ = t.dimBackground,
          l = t.hideBackground,
          s = t.containerClassName,
          c = m.cloneElement(n[0], ((e = {})["hover" === r ? "onMouseEnter" : "onClick"] = this._handleOpenDialog, e)),
          b = [B.overlay];
        return l ? b.push(B.fullOpacityBackdrop) : _ ? b.push(B.halfOpacityBackdrop) : b.push(B.transparentBackdrop), m.createElement(d.ThemeContext.Consumer, null, function (e) {
          return m.createElement(m.Fragment, null, c, m.createElement(u, {
            isOpen: o.state.showDialog,
            ariaHideApp: !1,
            className: p(s, B.dialog, B[e]),
            overlayClassName: p(b, B[e]),
            onRequestClose: o._handleCloseDialog,
            shouldCloseOnOverlayClick: a,
            shouldCloseOnEsc: i,
            onAfterOpen: o._onOpen
          }, o.content));
        });
      }, e.prototype._onBeforeOpen = function (e) {
        !this.content.props.onBeforeOpen || this.content.props.onBeforeOpen();
      }, e.prototype._handleOpenDialog = function () {
        this.setState({
          showDialog: !0
        });
      }, e.prototype._handleCloseDialog = function () {
        this._cleanOnClose(), this.setState({
          showDialog: !1
        }), this.content.props.onClose && this.content.props.onClose();
      }, e.prototype._cleanOnClose = function () {
        this.autoCloseTimer && (clearTimeout(this.autoCloseTimer), this.autoCloseTimer = void 0);
      }, e.prototype._onOpen = function () {
        var e = this;
        this.content.props.onOpen && this.content.props.onOpen(), 0 < this.content.props.closeAfter && (this.autoCloseTimer = setTimeout(function () {
          e._handleCloseDialog();
        }, this.content.props.closeAfter));
      }, e.prototype._onCloseClick = function (e) {
        this.closeAction && this.closeAction();
      }, e;
    }(m.Component);
  o.WithDialog = i, o.default = i;
}, function (e, o, n) {
  "use strict";

  var _t20,
    r = this && this.__extends || (_t20 = function t(e, o) {
      return (_t20 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t20(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    s = this && this.__assign || function () {
      return (s = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var c = n(0),
    b = n(1),
    m = n(15),
    p = n(3),
    i = n(6),
    u = n(2),
    d = n(4),
    h = n(124),
    a = function (n) {
      function l(e) {
        var o = n.call(this, e) || this;
        return o.state = {
          open: !1
        }, i.showExperimentalWarning("Expander"), o._handleClick = o._handleClick.bind(o), o;
      }
      return r(l, n), l.prototype.render = function () {
        var n = this,
          e = this.props,
          t = e.className,
          r = e.title,
          i = void 0 !== this.props.open ? this.props.open : this.state.open,
          a = this.props.isNested,
          _ = m.injectProps(this.props.children, function (e, o) {
            return o && o.type && o.type.componentName === l.componentName ? {
              isNested: !0
            } : {};
          });
        return c.createElement(p.ThemeContext.Consumer, null, function (e) {
          var o;
          return c.createElement("div", s({}, u.getHtmlAttributes(n.props), {
            className: b(h.root, h[e], (o = {}, o[h.open] = i, o[h.isNested] = a, o), t)
          }), c.createElement("div", {
            className: h.header,
            onClick: n._handleClick
          }, c.createElement("span", null, c.createElement(d.Icon, {
            name: "abb/caret-right"
          })), c.createElement("span", null, r)), c.createElement("div", {
            className: h.content
          }, _));
        });
      }, l.prototype._handleClick = function (e) {
        this.props.onClick && this.props.onClick(e), void 0 === this.props.open && this.setState({
          open: !this.state.open
        });
      }, l.defaultProps = {
        open: void 0
      }, l.componentName = "Expander", l;
    }(c.Component);
  o.Expander = a, o.default = a;
}, function (e, o, n) {
  "use strict";

  var _t21,
    r = this && this.__extends || (_t21 = function t(e, o) {
      return (_t21 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t21(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    });
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var i = function (o) {
    function e(e) {
      return o.call(this, e) || this;
    }
    return r(e, o), e.prototype.render = function () {
      return null;
    }, e.defaultProps = {
      disabled: !1,
      selected: !1
    }, e.componentName = "MenuItem", e;
  }(n(0).Component);
  o.MenuItem = i, o.default = i;
}, function (e, o, n) {
  "use strict";

  var _t22,
    r = this && this.__extends || (_t22 = function t(e, o) {
      return (_t22 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t22(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    });
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var i = function (o) {
    function e(e) {
      return o.call(this, e) || this;
    }
    return r(e, o), e.prototype.render = function () {
      return null;
    }, e.componentName = "SuMenu", e;
  }(n(0).Component);
  o.SubMenu = i, o.default = i;
}, function (e, o, n) {
  "use strict";

  var _t23,
    r = this && this.__extends || (_t23 = function t(e, o) {
      return (_t23 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t23(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    });
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var i = function (o) {
    function e(e) {
      return o.call(this, e) || this;
    }
    return r(e, o), e.prototype.render = function () {
      return null;
    }, e.componentName = "MenuItemDivider", e;
  }(n(0).Component);
  o.MenuItemDivider = i, o.default = i;
}, function (e, o, n) {
  "use strict";

  var _t24,
    r = this && this.__extends || (_t24 = function t(e, o) {
      return (_t24 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t24(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    s = this && this.__assign || function () {
      return (s = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var c = n(0),
    b = n(1),
    m = n(2),
    p = n(46),
    u = n(16),
    d = n(15),
    h = n(39),
    B = n(146),
    A = "yes",
    C = "no",
    f = "ok",
    y = "cancel",
    g = "confirm",
    v = "close",
    i = function (n) {
      function e(e) {
        var o = n.call(this, e) || this;
        return o.close = o.close.bind(o), o.onYes = o.onYes.bind(o), o.onNo = o.onNo.bind(o), o.onOk = o.onOk.bind(o), o.onCancel = o.onCancel.bind(o), o.onConfirm = o.onConfirm.bind(o), o.onClose = o.onClose.bind(o), o.closeThroughCloseButton = o.closeThroughCloseButton.bind(o), o.props.cleaner && (o.resourceCleaner = o.props.cleaner), o.props.parent && o.props.parent.registerCloseHandler(o.closeThroughCloseButton), o;
      }
      return r(e, n), e.prototype.render = function () {
        var e = this.props,
          o = e.message,
          n = e.title,
          t = e.buttons,
          r = e.className,
          i = -1 < ["yesno"].indexOf(this.props.buttons.toLowerCase()),
          a = new Array();
        switch (t.toLowerCase()) {
          case "yesno":
            a = [c.createElement(u.Button, {
              sizeClass: "small",
              type: "discreet-black",
              key: C,
              onClick: this.onNo,
              text: "No"
            }), c.createElement(u.Button, {
              sizeClass: "small",
              type: "primary-blue",
              key: A,
              onClick: this.onYes,
              text: "Yes"
            })];
            break;
          case "yesnocancel":
            a = [c.createElement(u.Button, {
              sizeClass: "small",
              type: "discreet-black",
              key: y,
              onClick: this.onCancel,
              text: "Cancel"
            }), c.createElement(u.Button, {
              sizeClass: "small",
              type: "discreet-black",
              key: C,
              onClick: this.onNo,
              text: "No"
            }), c.createElement(u.Button, {
              sizeClass: "small",
              type: "primary-blue",
              key: A,
              onClick: this.onYes,
              text: "Yes"
            })];
            break;
          case "ok":
            a = [c.createElement(u.Button, {
              sizeClass: "small",
              type: "primary-blue",
              key: f,
              onClick: this.onOk,
              text: "OK"
            })];
            break;
          case "okcancel":
            a = [c.createElement(u.Button, {
              sizeClass: "small",
              type: "discreet-black",
              key: y,
              onClick: this.onCancel,
              text: "Cancel"
            }), c.createElement(u.Button, {
              sizeClass: "small",
              type: "primary-blue",
              key: f,
              onClick: this.onOk,
              text: "OK"
            })];
            break;
          case "confirmcancel":
            a = [c.createElement(u.Button, {
              sizeClass: "small",
              type: "discreet-black",
              key: y,
              onClick: this.onCancel,
              text: "Cancel"
            }), c.createElement(u.Button, {
              sizeClass: "small",
              type: "primary-blue",
              key: g,
              onClick: this.onConfirm,
              text: "Confirm"
            })];
            break;
          case "close":
            a = [c.createElement(u.Button, {
              sizeClass: "small",
              type: "primary-blue",
              key: v,
              onClick: this.onClose,
              text: "Close"
            })];
            break;
          default:
            throw new Error("Invalid button definition: " + t);
        }
        a = d.injectProps(a, function (e, o) {
          return {
            className: B.messageDialogButton
          };
        });
        var _ = {
            closeAction: this.closeThroughCloseButton
          },
          l = c.createElement(p.Dialog, s({}, m.getHtmlAttributes(this.props), _, {
            showCloseButton: !i,
            title: n,
            className: b(B.messageDialogDimensions, r),
            contentClassName: b(B.messageDialogRoot)
          }), c.createElement("div", {
            className: B.message
          }, o), c.createElement("div", {
            className: B.buttons
          }, a));
        return void 0 !== this.props.isOpen ? c.createElement(h.DialogWrapper, s({}, m.getHtmlAttributes(this.props), {
          dialog: this,
          closeHandler: this.close,
          dimBackground: !0,
          closeOnEscape: !i,
          closeOnLostFocus: !i
        }, this.props), l) : l;
      }, e.prototype.onYes = function () {
        this.close(A);
      }, e.prototype.onNo = function () {
        this.close(C);
      }, e.prototype.onOk = function () {
        this.close(f);
      }, e.prototype.onCancel = function () {
        this.close(y);
      }, e.prototype.onConfirm = function () {
        this.close(g);
      }, e.prototype.onClose = function () {
        this.close(v);
      }, e.prototype.closeThroughCloseButton = function () {
        this.close(null);
      }, e.prototype.close = function (e) {
        this.props.closeDialog && this.props.closeDialog(), this.resourceCleaner && this.resourceCleaner();
        var o = e || this._defaultResult();
        this.props["on" + o.charAt(0).toUpperCase() + o.slice(1)](), this.props.onExit && this.props.onExit(o);
      }, e.prototype.registerResourceCleaner = function (e) {
        this.resourceCleaner = e;
      }, e.prototype._defaultResult = function () {
        return {
          yesnocancel: "cancel",
          ok: "ok",
          okcancel: "cancel",
          confirmcancel: "cancel",
          close: "close"
        }[this.props.buttons];
      }, e.defaultProps = {
        trigger: "click",
        onYes: function onYes() {},
        onNo: function onNo() {},
        onOk: function onOk() {},
        onCancel: function onCancel() {},
        onConfirm: function onConfirm() {},
        onClose: function onClose() {},
        onExit: function onExit(e) {},
        isOpen: void 0
      }, e.componentName = "MessageDialog", e;
    }(c.Component);
  o.MessageDialog = i, o.default = i;
}, function (e, o, n) {
  "use strict";

  var _t25,
    r = this && this.__extends || (_t25 = function t(e, o) {
      return (_t25 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t25(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    });
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var b = n(0),
    m = n(1),
    p = n(3),
    u = n(4),
    d = n(16),
    h = n(12),
    B = n(149),
    A = {
      banner: {
        success: "abb/check-mark-circle-1",
        info: "abb/information-circle-1",
        warn: "abb/warning-circle-1",
        alarm: "abb/error-circle-1"
      },
      confirmation: {
        success: "abb/check-mark-circle-1",
        info: "abb/information-circle-1",
        warn: "abb/warning-circle-1",
        alarm: "abb/error-circle-1"
      }
    },
    i = function (n) {
      function e(e) {
        var o = n.call(this, e) || this;
        return o.state = {
          isClosing: !1
        }, o._onMouseEnter = o._onMouseEnter.bind(o), o._onMouseLeave = o._onMouseLeave.bind(o), o._handleClick = o._handleClick.bind(o), o._onClose = o._onClose.bind(o), o._customButtonClickHandler = o._customButtonClickHandler.bind(o), o;
      }
      return r(e, n), e.prototype.render = function () {
        var t = this,
          e = this.props,
          r = e.className,
          o = e.data,
          i = o.severity,
          a = o.type,
          _ = o.discreet,
          l = o.text,
          n = o.buttons,
          s = A[a][i],
          c = [];
        return n && (c = n.map(function (e) {
          return b.createElement(d.Button, {
            sizeClass: "small",
            key: (e.primary ? "primary" : "discreet") + e.text,
            text: e.text,
            data: {
              id: o.id,
              handler: e.handler
            },
            type: e.primary ? "primary-blue" : "discreet-blue",
            onClick: t._customButtonClickHandler
          });
        })), b.createElement(p.ThemeContext.Consumer, null, function (e) {
          var o, n;
          return b.createElement("div", {
            style: t.props.style,
            className: m(B.root, B[e], B[a], (o = {}, o[B.discreet] = _, o), B[i], r, (n = {}, n[B.closing] = t.props.data.isClosing || t.state.isClosing, n)),
            onClick: t._handleClick,
            onMouseEnter: t._onMouseEnter,
            onMouseLeave: t._onMouseLeave
          }, b.createElement("div", null, b.createElement("div", {
            className: B.iconContainer
          }, b.createElement(u.Icon, {
            name: s,
            sizeClass: "confirmation" === a ? "large" : "medium"
          })), b.createElement("div", {
            className: B.text
          }, l), "banner" === a && b.createElement(p.ThemeContext.Provider, {
            value: _ && "dark" !== e ? "light" : "dark"
          }, b.createElement(h.CloseIcon, {
            sizeClass: "medium",
            className: B.controls,
            onClick: t._onClose
          }))), "confirmation" === a && b.createElement("div", {
            className: B.buttons
          }, c));
        });
      }, e.prototype.componentDidMount = function () {
        this.initAutomaticHiding();
      }, e.prototype.remove = function () {
        this._onClose(null);
      }, e.prototype.initAutomaticHiding = function () {
        var e = this;
        this.timeout && clearInterval(this.timeout), this.props.data.timeout && (this.timeout = setTimeout(function () {
          e._onClose(null);
        }, this.props.data.timeout));
      }, e.prototype._customButtonClickHandler = function (e, o) {
        e.preventDefault(), e.stopPropagation(), o.handler && o.handler(o.id);
      }, e.prototype._onClose = function (e) {
        var o = this;
        e && (e.preventDefault(), e.stopPropagation()), this.setState({
          isClosing: !0
        }), (this.props.data.onClose || this.props.removalHandler) && setTimeout(function () {
          o.props.removalHandler && o.props.removalHandler.remove(o.props.data.id), o.props.data.onClose && o.props.data.onClose(o.props.data.id);
        }, 500);
      }, e.prototype._onMouseEnter = function (e) {
        this.timeout && clearInterval(this.timeout);
      }, e.prototype._onMouseLeave = function (e) {
        this.initAutomaticHiding();
      }, e.prototype._handleClick = function (e) {
        e.preventDefault(), this.props.data.onClick && this.props.data.onClick(this.props.data.id, e);
      }, e.defaultProps = {
        isClosing: !1
      }, e;
    }(b.Component);
  o.Notification = i, o.default = i;
}, function (e, o) {
  e.exports = require("reactjs-popup");
}, function (e, o, n) {
  e.exports = {
    root: "ABB_CommonUX_Popup__root",
    header: "ABB_CommonUX_Popup__header",
    hasCloseButton: "ABB_CommonUX_Popup__hasCloseButton",
    content: "ABB_CommonUX_Popup__content",
    light: "ABB_CommonUX_Popup__light",
    dark: "ABB_CommonUX_Popup__dark",
    customPopperClass: "ABB_CommonUX_Popup__customPopperClass",
    customPopperArrow: "ABB_CommonUX_Popup__customPopperArrow"
  };
}, function (e, o, n) {
  e.exports = {
    root: "ABB_CommonUX_RadioGroup__root",
    disabled: "ABB_CommonUX_RadioGroup__disabled",
    smallSize: "ABB_CommonUX_RadioGroup__smallSize",
    largeSize: "ABB_CommonUX_RadioGroup__largeSize",
    horizontal: "ABB_CommonUX_RadioGroup__horizontal",
    light: "ABB_CommonUX_RadioGroup__light",
    dark: "ABB_CommonUX_RadioGroup__dark"
  };
}, function (e, o) {
  e.exports = require("rc-slider");
}, function (e, o, n) {
  "use strict";

  var _t26,
    r = this && this.__extends || (_t26 = function t(e, o) {
      return (_t26 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t26(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    d = this && this.__assign || function () {
      return (d = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var h = n(0),
    B = n(1),
    A = n(3),
    C = n(2),
    f = n(4),
    y = n(72),
    i = function (n) {
      function e(e) {
        var o = n.call(this, e) || this;
        return o._handleChange = o._handleChange.bind(o), o._handleClick = o._handleClick.bind(o), o;
      }
      return r(e, n), e.prototype.render = function () {
        var n = this,
          e = this.props,
          t = e.className,
          r = e.text,
          i = e.icon,
          a = e.disabled,
          o = e._from_parent_,
          _ = o.multiselect,
          l = o.sizeClass,
          s = o.selected,
          c = o.nextIsSelected,
          b = o.isFirst,
          m = o.isLast,
          p = o.colorVariation,
          u = h.createElement("input", {
            type: _ ? "checkbox" : "radio",
            checked: s,
            disabled: a,
            onChange: this._handleChange
          });
        return h.createElement(A.ThemeContext.Consumer, null, function (e) {
          var o;
          return h.createElement("li", d({}, C.getHtmlAttributes(n.props), {
            onClick: n._handleClick,
            className: B(y.root, y[e], y[l + "Height"], (o = {}, o[y.selected] = s, o[y.nextIsSelected] = c, o[y.disabled] = a, o[y.black] = "black" === p, o[y.first] = b, o[y.last] = m, o[y.iconOnly] = i && !r, o[y.textOnly] = !i && r, o[y.iconAndText] = i && r, o), t)
          }), h.createElement("label", null, u, i && h.createElement("span", {
            className: y.icon
          }, h.createElement(f.Icon, {
            name: i,
            sizeClass: "large" === l ? "medium" : "small"
          })), r && h.createElement("span", {
            className: y.text
          }, r)));
        });
      }, e.prototype._handleChange = function (e) {
        !this.props.disabled && this.props._from_parent_.onClick && this.props._from_parent_.onClick(e.currentTarget);
      }, e.prototype._handleClick = function (e) {
        e.preventDefault(), !this.props.disabled && this.props._from_parent_.onClick && this.props._from_parent_.onClick(e.currentTarget), !this.props.disabled && this.props.onClick && this.props.onClick(e);
      }, e.defaultProps = {
        text: "",
        disabled: !1,
        _from_parent_: {}
      }, e.componentName = "ToggleButton", e;
    }(h.Component);
  o.ToggleButton = i, o.default = i;
}, function (e, o, n) {
  e.exports = {
    root: "ABB_CommonUX_ToggleButton__root",
    text: "ABB_CommonUX_ToggleButton__text",
    textOnly: "ABB_CommonUX_ToggleButton__textOnly",
    iconAndText: "ABB_CommonUX_ToggleButton__iconAndText",
    first: "ABB_CommonUX_ToggleButton__first",
    selected: "ABB_CommonUX_ToggleButton__selected",
    last: "ABB_CommonUX_ToggleButton__last",
    disabled: "ABB_CommonUX_ToggleButton__disabled",
    smallHeight: "ABB_CommonUX_ToggleButton__smallHeight",
    iconOnly: "ABB_CommonUX_ToggleButton__iconOnly",
    icon: "ABB_CommonUX_ToggleButton__icon",
    mediumHeight: "ABB_CommonUX_ToggleButton__mediumHeight",
    largeHeight: "ABB_CommonUX_ToggleButton__largeHeight",
    light: "ABB_CommonUX_ToggleButton__light",
    nextIsSelected: "ABB_CommonUX_ToggleButton__nextIsSelected",
    black: "ABB_CommonUX_ToggleButton__black",
    dark: "ABB_CommonUX_ToggleButton__dark"
  };
}, function (e, o, n) {
  "use strict";

  var _t27,
    r = this && this.__extends || (_t27 = function t(e, o) {
      return (_t27 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t27(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var a = n(0),
    _ = n(1),
    l = n(3),
    s = n(2),
    c = n(74),
    b = function (n) {
      function e(e) {
        var o = n.call(this, e) || this;
        return o._handleClick = o._handleClick.bind(o), o;
      }
      return r(e, n), e.prototype.render = function () {
        var n = this,
          t = this.props.className;
        return a.createElement(l.ThemeContext.Consumer, null, function (e) {
          var o;
          return a.createElement("div", i({}, s.getHtmlAttributes(n.props), {
            className: _(c.content, c[e], t, (o = {}, o[c.clickable] = !!n.props.onClick, o)),
            onClick: n._handleClick
          }), n.props.children);
        });
      }, e.prototype._handleClick = function (e) {
        e.preventDefault(), this.props.onClick && this.props.onClick(e);
      }, e.componentName = "Tooltip", e;
    }(a.Component);
  o.Tooltip = b, o.default = b;
}, function (e, o, n) {
  e.exports = {
    trigger: "ABB_CommonUX_Tooltip__trigger",
    container: "ABB_CommonUX_Tooltip__container",
    content: "ABB_CommonUX_Tooltip__content",
    clickable: "ABB_CommonUX_Tooltip__clickable",
    alignLeft: "ABB_CommonUX_Tooltip__alignLeft",
    arrow: "ABB_CommonUX_Tooltip__arrow",
    light: "ABB_CommonUX_Tooltip__light",
    dark: "ABB_CommonUX_Tooltip__dark",
    customTooltipContainer: "ABB_CommonUX_Tooltip__customTooltipContainer",
    ngxpInner: "ABB_CommonUX_Tooltip__ngxp__inner"
  };
}, function (e, n, o) {
  "use strict";

  Object.defineProperty(n, "__esModule", {
    value: !0
  }), function (e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }(o(76));
}, function (e, o, n) {
  "use strict";

  var _t28,
    r = this && this.__extends || (_t28 = function t(e, o) {
      return (_t28 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t28(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    a = this && this.__assign || function () {
      return (a = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var _ = n(0),
    l = n(1),
    s = n(3),
    c = n(2),
    b = n(77),
    i = function (n) {
      function e(e) {
        var o = n.call(this, e) || this;
        return o._handleLogoClick = o._handleLogoClick.bind(o), o;
      }
      return r(e, n), e.prototype.render = function () {
        var o = this,
          e = this.props,
          n = e.className,
          t = e.productName,
          r = e.customLogo,
          i = r ? b.customLogo : b.abbLogo;
        return _.createElement(s.ThemeContext.Consumer, null, function (e) {
          return _.createElement("div", a({}, c.getHtmlAttributes(o.props), {
            className: l(b.root, b[e], n, i),
            onClick: o._handleLogoClick
          }), _.createElement("span", {
            className: l(b.logo)
          }, _.createElement("span", null, r)), _.createElement("span", {
            className: b.productName
          }, t), _.createElement("span", {
            className: b.controls
          }, o.props.children));
        });
      }, e.prototype._handleLogoClick = function (e) {
        e.preventDefault(), this.props.onLogoClick && this.props.onLogoClick(e);
      }, e.defaultProps = {
        productName: ""
      }, e;
    }(_.Component);
  o.AbbBar = i, o.default = i;
}, function (e, o, n) {
  e.exports = {
    root: "ABB_CommonUX_AbbBar__root",
    logo: "ABB_CommonUX_AbbBar__logo",
    customLogo: "ABB_CommonUX_AbbBar__customLogo",
    abbLogo: "ABB_CommonUX_AbbBar__abbLogo",
    productName: "ABB_CommonUX_AbbBar__productName",
    controls: "ABB_CommonUX_AbbBar__controls",
    light: "ABB_CommonUX_AbbBar__light",
    dark: "ABB_CommonUX_AbbBar__dark"
  };
}, function (e, n, o) {
  "use strict";

  Object.defineProperty(n, "__esModule", {
    value: !0
  }), function (e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }(o(79));
}, function (e, o, n) {
  "use strict";

  var _t29,
    r = this && this.__extends || (_t29 = function t(e, o) {
      return (_t29 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t29(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    a = this && this.__assign || function () {
      return (a = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var _ = n(0),
    l = n(1),
    s = n(3),
    c = n(2),
    b = n(80),
    m = n(42),
    i = function (n) {
      function e(e) {
        var o = n.call(this, e) || this;
        return o.state = {
          activeTabIndex: 0
        }, o.onTabChange = o.onTabChange.bind(o), o;
      }
      return r(e, n), e.prototype.render = function () {
        var o = this,
          e = this.props,
          n = e.className,
          t = e.productName,
          r = e.copyrightText,
          i = e.tabs;
        return _.createElement(s.ThemeContext.Consumer, null, function (e) {
          return _.createElement("div", a({}, c.getHtmlAttributes(o.props), {
            className: l(b.root, b[e], n)
          }), _.createElement("div", {
            className: b.header
          }, _.createElement("div", {
            className: b.productName
          }, t)), _.createElement("div", {
            className: b.content
          }, _.createElement(m.TabControl, {
            type: "panel",
            activeTab: o.state.activeTabIndex,
            onTabChange: o.onTabChange,
            contentClassName: b.tabsContent
          }, i)), _.createElement("div", {
            className: b.footer
          }, _.createElement("div", null, r)));
        });
      }, e.prototype.onTabChange = function (e, o) {
        this.setState({
          activeTabIndex: o
        });
      }, e.defaultProps = {
        copyrightText: "All rights reserved " + new Date().getFullYear()
      }, e;
    }(_.Component);
  o.AboutBox = i, o.default = i;
}, function (e, o, n) {
  e.exports = {
    root: "ABB_CommonUX_AboutBox__root",
    header: "ABB_CommonUX_AboutBox__header",
    productName: "ABB_CommonUX_AboutBox__productName",
    productLogo: "ABB_CommonUX_AboutBox__productLogo",
    content: "ABB_CommonUX_AboutBox__content",
    tabsContent: "ABB_CommonUX_AboutBox__tabsContent",
    footer: "ABB_CommonUX_AboutBox__footer",
    light: "ABB_CommonUX_AboutBox__light",
    dark: "ABB_CommonUX_AboutBox__dark"
  };
}, function (e, n, o) {
  "use strict";

  Object.defineProperty(n, "__esModule", {
    value: !0
  }), function (e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }(o(82));
}, function (e, o, n) {
  "use strict";

  var _t30,
    r = this && this.__extends || (_t30 = function t(e, o) {
      return (_t30 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t30(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var a = n(0),
    _ = n(1),
    l = n(3),
    s = n(2);
  n(83);
  var c = n(84),
    b = function (o) {
      function e(e) {
        return o.call(this, e) || this;
      }
      return r(e, o), e.prototype.render = function () {
        var o = this,
          e = this.props,
          n = e.className,
          t = e.theme;
        return a.createElement(l.ThemeContext.Provider, {
          value: t
        }, a.createElement(l.ThemeContext.Consumer, null, function (e) {
          return a.createElement("div", i({}, s.getHtmlAttributes(o.props), {
            className: _(c.root, c[e], n)
          }), o.props.children);
        }));
      }, e.defaultProps = {
        theme: "light"
      }, e;
    }(a.Component);
  o.AppContainer = b, o.default = b;
}, function (e, o, n) {}, function (e, o, n) {
  e.exports = {
    root: "ABB_CommonUX_AppContainer__root",
    light: "ABB_CommonUX_AppContainer__light",
    dark: "ABB_CommonUX_AppContainer__dark"
  };
}, function (e, n, o) {
  "use strict";

  Object.defineProperty(n, "__esModule", {
    value: !0
  }), function (e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }(o(86));
}, function (e, o, n) {
  "use strict";

  var _t31,
    r = this && this.__extends || (_t31 = function t(e, o) {
      return (_t31 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t31(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var a = n(0),
    _ = n(1),
    l = n(3),
    s = n(2),
    c = n(87),
    b = function (o) {
      function e(e) {
        return o.call(this, e) || this;
      }
      return r(e, o), e.prototype.render = function () {
        var o = this,
          n = this.props.className;
        return a.createElement(l.ThemeContext.Consumer, null, function (e) {
          return a.createElement("div", i({}, s.getHtmlAttributes(o.props), {
            className: _(c.root, c[e], n)
          }), o.props.children);
        });
      }, e;
    }(a.Component);
  o.AppContent = b, o.default = b;
}, function (e, o, n) {
  e.exports = {
    root: "ABB_CommonUX_AppContent__root",
    light: "ABB_CommonUX_AppContent__light",
    dark: "ABB_CommonUX_AppContent__dark"
  };
}, function (e, n, o) {
  "use strict";

  Object.defineProperty(n, "__esModule", {
    value: !0
  }), function (e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }(o(89));
}, function (e, o, n) {
  "use strict";

  var _t32,
    r = this && this.__extends || (_t32 = function t(e, o) {
      return (_t32 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t32(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    a = this && this.__assign || function () {
      return (a = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var _ = n(0),
    l = n(1),
    s = n(3),
    c = n(2),
    b = n(90),
    i = function (o) {
      function e(e) {
        return o.call(this, e) || this;
      }
      return r(e, o), e.prototype.render = function () {
        var o = this,
          e = this.props,
          n = e.className,
          t = e.copyrightText,
          r = e.showCopyright,
          i = e.showLogo;
        return _.createElement(s.ThemeContext.Consumer, null, function (e) {
          return _.createElement("div", a({}, c.getHtmlAttributes(o.props), {
            className: l(b.root, b[e], n)
          }), _.createElement("div", {
            className: b.content
          }, o.props.children), _.createElement("div", {
            className: b.copyrightOrLogo
          }, r && t && _.createElement("div", {
            className: b.copyright
          }, t), i && _.createElement("div", {
            className: b.logo
          })));
        });
      }, e.defaultProps = {
        copyrightText: "All rights reserved " + new Date().getFullYear(),
        showCopyright: !1,
        showLogo: !0
      }, e;
    }(_.Component);
  o.AppFooter = i, o.default = i;
}, function (e, o, n) {
  e.exports = {
    root: "ABB_CommonUX_AppFooter__root",
    content: "ABB_CommonUX_AppFooter__content",
    copyrightOrLogo: "ABB_CommonUX_AppFooter__copyrightOrLogo",
    copyright: "ABB_CommonUX_AppFooter__copyright",
    logo: "ABB_CommonUX_AppFooter__logo",
    light: "ABB_CommonUX_AppFooter__light",
    dark: "ABB_CommonUX_AppFooter__dark"
  };
}, function (e, n, o) {
  "use strict";

  Object.defineProperty(n, "__esModule", {
    value: !0
  }), function (e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }(o(92));
}, function (e, o, n) {
  "use strict";

  var _t33,
    r = this && this.__extends || (_t33 = function t(e, o) {
      return (_t33 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t33(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var a = n(0),
    _ = n(1),
    l = n(3),
    s = n(2),
    c = n(43),
    b = function (o) {
      function e(e) {
        return o.call(this, e) || this;
      }
      return r(e, o), e.prototype.render = function () {
        var o = this,
          n = this.props.className;
        return a.createElement(l.ThemeContext.Consumer, null, function (e) {
          return a.createElement("div", i({}, s.getHtmlAttributes(o.props), {
            className: _(c.root, c[e], n)
          }), o.props.children);
        });
      }, e;
    }(a.Component);
  o.AppHeader = b, o.default = b;
}, function (e, n, o) {
  "use strict";

  Object.defineProperty(n, "__esModule", {
    value: !0
  }), function (e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }(o(94));
}, function (e, o, n) {
  "use strict";

  var _t34,
    r = this && this.__extends || (_t34 = function t(e, o) {
      return (_t34 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t34(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var a = n(0),
    _ = n(1),
    l = n(3),
    s = n(2),
    c = n(43),
    b = function (o) {
      function e(e) {
        return o.call(this, e) || this;
      }
      return r(e, o), e.prototype.render = function () {
        var o = this;
        return a.createElement(l.ThemeContext.Consumer, null, function (e) {
          return a.createElement("div", i({}, s.getHtmlAttributes(o.props), {
            className: _(c.spacer, c[e], o.props.className)
          }));
        });
      }, e;
    }(a.Component);
  o.AppHeaderSpacer = b, o.default = b;
}, function (e, n, o) {
  "use strict";

  Object.defineProperty(n, "__esModule", {
    value: !0
  }), function (e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }(o(96));
}, function (e, o, n) {
  "use strict";

  var _t35,
    r = this && this.__extends || (_t35 = function t(e, o) {
      return (_t35 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t35(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    d = this && this.__assign || function () {
      return (d = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var h = n(0),
    B = n(1),
    i = n(3),
    A = n(2),
    C = n(4),
    f = n(97),
    y = n(26),
    a = function (n) {
      function e(e) {
        var o = n.call(this, e) || this;
        return o._handleCollapserClick = o._handleCollapserClick.bind(o), o;
      }
      return r(e, n), e.prototype.render = function () {
        var c = this,
          e = this.props,
          b = e.className,
          m = e.visibility,
          p = e.showVisibilityToggle,
          u = e.showRightBorder;
        return h.createElement(i.ThemeContext.Consumer, null, function (e) {
          var o, n, t, r, i, a, _, l, s;
          return h.createElement("div", d({}, A.getHtmlAttributes(c.props), {
            className: B(f.root, f[e], (o = {}, o[f.hidden] = "hidden" === m, o), (n = {}, n[f.collapsed] = "thumbs" === m, n), (t = {}, t[f.expanded] = "full" === m, t), (r = {}, r[f.semi] = "compact" === m, r), (i = {}, i[f.showRightBorder] = u, i), (a = {}, a[f.showVisibilityToggle] = p, a), (_ = {}, _[f.title] = c.props.title && "full" === m, _), (l = {}, l[f.searchInline] = c.props.showSearchBarInFullMode && "full" === m && "inline" === c.props.searchBarPositionInFullMode, l), (s = {}, s[f.searchBelow] = c.props.showSearchBarInFullMode && "full" === m && "below" === c.props.searchBarPositionInFullMode, s), b)
          }), p && h.createElement("span", {
            className: f.collapserIcon,
            onClick: c._handleCollapserClick
          }, h.createElement("span", null, h.createElement(C.Icon, {
            name: c.props.icon,
            sizeClass: "medium"
          }))), c.props.title && "full" === m && h.createElement("div", {
            className: f.title
          }, c.props.title), c.props.showSearchBarInFullMode && "full" === m && h.createElement("div", {
            className: f.search
          }, h.createElement(y.Input, {
            type: "discreet",
            dataType: "text",
            placeholder: c.props.searchBarPlaceholder,
            icon: "abb/search",
            clearOnEscape: c.props.clearSearchOnEscape,
            showValidationIconWhenValid: !1,
            showValidationIconWhenInvalid: !1,
            showValidationBarWhenValid: !1,
            showValidationBarWhenInvalid: !1,
            value: c.props.searchValue,
            onValueChange: function onValueChange(e) {
              return c.props.onSearchValueChange && c.props.onSearchValueChange(e);
            }
          })), h.createElement("div", {
            className: f.leftPaneContent
          }, c.props.children));
        });
      }, e.prototype._handleCollapserClick = function (e) {
        e.preventDefault(), this.props.onClickToggleVisibility && this.props.onClickToggleVisibility(e);
      }, e.defaultProps = {
        showRightBorder: !1,
        showVisibilityToggle: !0,
        icon: "abb/caret-right",
        showSearchBarInFullMode: !1,
        searchBarPositionInFullMode: "inline",
        clearSearchOnEscape: !0
      }, e;
    }(h.Component);
  o.AppLeftPane = a, o.default = a;
}, function (e, o, n) {
  e.exports = {
    root: "ABB_CommonUX_AppLeftPane__root",
    hidden: "ABB_CommonUX_AppLeftPane__hidden",
    collapsed: "ABB_CommonUX_AppLeftPane__collapsed",
    semi: "ABB_CommonUX_AppLeftPane__semi",
    expanded: "ABB_CommonUX_AppLeftPane__expanded",
    showRightBorder: "ABB_CommonUX_AppLeftPane__showRightBorder",
    leftPaneContent: "ABB_CommonUX_AppLeftPane__leftPaneContent",
    search: "ABB_CommonUX_AppLeftPane__search",
    title: "ABB_CommonUX_AppLeftPane__title",
    showVisibilityToggle: "ABB_CommonUX_AppLeftPane__showVisibilityToggle",
    searchBelow: "ABB_CommonUX_AppLeftPane__searchBelow",
    searchInline: "ABB_CommonUX_AppLeftPane__searchInline",
    collapserIcon: "ABB_CommonUX_AppLeftPane__collapserIcon",
    semiOpacityAnimation: "ABB_CommonUX_AppLeftPane__semiOpacityAnimation",
    expandedOpacityAnimation: "ABB_CommonUX_AppLeftPane__expandedOpacityAnimation",
    collapsedOpacityAnimation: "ABB_CommonUX_AppLeftPane__collapsedOpacityAnimation",
    light: "ABB_CommonUX_AppLeftPane__light",
    dark: "ABB_CommonUX_AppLeftPane__dark"
  };
}, function (e, n, o) {
  "use strict";

  Object.defineProperty(n, "__esModule", {
    value: !0
  }), function (e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }(o(99));
}, function (e, o, n) {
  "use strict";

  var _t36,
    r = this && this.__extends || (_t36 = function t(e, o) {
      return (_t36 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t36(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var a = n(0),
    _ = n(1),
    l = n(3),
    s = n(2),
    c = n(100),
    b = function (o) {
      function e(e) {
        return o.call(this, e) || this;
      }
      return r(e, o), e.prototype.render = function () {
        var n = this,
          e = this.props,
          t = e.className,
          r = e.spaceOnTop;
        return a.createElement(l.ThemeContext.Consumer, null, function (e) {
          var o;
          return a.createElement("div", i({}, s.getHtmlAttributes(n.props), {
            className: _(c.root, c[e], (o = {}, o[c.spaceOnTop] = r, o), t)
          }), n.props.children);
        });
      }, e.defaultProps = {
        spaceOnTop: !1
      }, e;
    }(a.Component);
  o.AppMainContent = b, o.default = b;
}, function (e, o, n) {
  e.exports = {
    root: "ABB_CommonUX_AppMainContent__root",
    spaceOnTop: "ABB_CommonUX_AppMainContent__spaceOnTop",
    light: "ABB_CommonUX_AppMainContent__light",
    dark: "ABB_CommonUX_AppMainContent__dark"
  };
}, function (e, n, o) {
  "use strict";

  Object.defineProperty(n, "__esModule", {
    value: !0
  }), function (e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }(o(102));
}, function (e, o, n) {
  "use strict";

  var _t37,
    r = this && this.__extends || (_t37 = function t(e, o) {
      return (_t37 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t37(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var a = n(0),
    _ = n(1),
    l = n(2),
    s = n(3),
    c = n(22),
    b = function (o) {
      function e(e) {
        return o.call(this, e) || this;
      }
      return r(e, o), e.prototype.render = function () {
        var o = this,
          n = this.props.className;
        return a.createElement(s.ThemeContext.Consumer, null, function (e) {
          return a.createElement("div", i({}, l.getHtmlAttributes(o.props), {
            className: _(c.root, c[e], n)
          }), o.props.children);
        });
      }, e.defaultProps = {}, e;
    }(a.Component);
  o.AppTopNavi = b, o.default = b;
}, function (e, n, o) {
  "use strict";

  Object.defineProperty(n, "__esModule", {
    value: !0
  }), function (e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }(o(104));
}, function (e, o, n) {
  "use strict";

  var _t38,
    r = this && this.__extends || (_t38 = function t(e, o) {
      return (_t38 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t38(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var a = n(0),
    _ = n(1),
    l = n(3),
    s = n(2),
    c = n(22),
    b = function (o) {
      function e(e) {
        return o.call(this, e) || this;
      }
      return r(e, o), e.prototype.render = function () {
        var o = this;
        return a.createElement(l.ThemeContext.Consumer, null, function (e) {
          return a.createElement("div", i({}, s.getHtmlAttributes(o.props), {
            className: _(c.divider, c[e], o.props.className)
          }));
        });
      }, e;
    }(a.Component);
  o.AppTopNaviDivider = b, o.default = b;
}, function (e, n, o) {
  "use strict";

  Object.defineProperty(n, "__esModule", {
    value: !0
  }), function (e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }(o(106));
}, function (e, o, n) {
  "use strict";

  var _t39,
    r = this && this.__extends || (_t39 = function t(e, o) {
      return (_t39 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t39(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var a = n(0),
    _ = n(1),
    l = n(44),
    s = n(22),
    c = function (o) {
      function e(e) {
        return o.call(this, e) || this;
      }
      return r(e, o), e.prototype.render = function () {
        return a.createElement(l.Dropdown, i({}, this.props, {
          className: _(this.props.className, s.fontFix),
          sizeClass: "medium",
          noBorders: !0
        }), this.props.children);
      }, e.defaultProps = {
        searchable: !1,
        placeholder: "",
        value: [],
        clearable: !1,
        disabled: !1,
        clearOnEscape: !1
      }, e;
    }(a.Component);
  o.AppTopNaviDropdown = c, o.default = c;
}, function (e, n, o) {
  "use strict";

  Object.defineProperty(n, "__esModule", {
    value: !0
  }), function (e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }(o(108));
}, function (e, o, n) {
  "use strict";

  var _t40,
    r = this && this.__extends || (_t40 = function t(e, o) {
      return (_t40 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t40(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    m = this && this.__assign || function () {
      return (m = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var p = n(0),
    u = n(1),
    d = n(3),
    h = n(4),
    B = n(2),
    A = n(22),
    C = n(45),
    i = function (n) {
      function e(e) {
        var o = n.call(this, e) || this;
        return o._handleClick = o._handleClick.bind(o), o._handleLostFocus = o._handleLostFocus.bind(o), o;
      }
      return r(e, n), e.prototype.render = function () {
        var r = this,
          e = this.props,
          i = e.link,
          a = e.className,
          _ = e.text,
          l = e.active,
          s = e.disabled,
          c = e.icon,
          b = e.hasMenu;
        return p.createElement(d.ThemeContext.Consumer, null, function (e) {
          var o, n, t;
          return p.createElement("div", m({}, B.getHtmlAttributes(r.props), {
            className: u(A.item, A[e], (o = {}, o[A.active] = l, o), (n = {}, n[A.disabled] = s, n), a),
            onClick: r._handleClick,
            onBlur: r._handleLostFocus,
            tabIndex: 1
          }), p.createElement(C.Link, {
            href: i,
            style: {
              textDecoration: "inherit",
              color: "inherit"
            },
            className: u(A.header, (t = {}, t[A.iconOnly] = c && !_, t[A.textOnly] = !c && _, t[A.iconAndText] = c && _, t))
          }, c && p.createElement("div", {
            className: A.icon
          }, p.createElement(h.Icon, {
            name: c,
            sizeClass: "medium"
          })), _ && p.createElement("div", {
            className: A.text
          }, _), b && p.createElement("div", {
            className: A.caret
          }, p.createElement(h.Icon, {
            name: "abb/caret-down",
            sizeClass: "small"
          }))), r.props.children);
        });
      }, e.prototype._handleClick = function (e) {
        this.props.onClick && (e.preventDefault(), this.props.disabled || this.props.onClick(e));
      }, e.prototype._handleLostFocus = function (e) {
        e.preventDefault(), e.currentTarget.contains(e.relatedTarget) || !this.props.onLostFocus || this.props.disabled || this.props.onLostFocus(e);
      }, e.defaultProps = {
        icon: void 0,
        text: void 0,
        active: !1,
        hasMenu: !1
      }, e;
    }(p.Component);
  o.AppTopNaviItem = i, o.default = i;
}, function (e, n, o) {
  "use strict";

  Object.defineProperty(n, "__esModule", {
    value: !0
  }), function (e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }(o(110));
}, function (e, o, n) {
  "use strict";

  var _t41,
    r = this && this.__extends || (_t41 = function t(e, o) {
      return (_t41 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t41(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var a = n(0),
    _ = n(1),
    l = n(3),
    s = n(6),
    c = n(2),
    b = n(111),
    m = function (n) {
      function e(e) {
        var o = n.call(this, e) || this;
        return o.state = {
          some: 42
        }, s.showExperimentalWarning("BarChart"), o._handleClick = o._handleClick.bind(o), o;
      }
      return r(e, n), e.prototype.render = function () {
        var o = this,
          n = this.props.className;
        return a.createElement(l.ThemeContext.Consumer, null, function (e) {
          return a.createElement("div", i({}, c.getHtmlAttributes(o.props), {
            className: _(b.root, b[e], n),
            onClick: o._handleClick
          }), o.props.children);
        });
      }, e.prototype._handleClick = function (e) {
        e.preventDefault(), this.props.onClick && this.props.onClick(e), this.setState(function (e) {
          return {
            some: e.some + 1
          };
        });
      }, e.defaultProps = {}, e;
    }(a.Component);
  o.BarChart = m, o.default = m;
}, function (e, o, n) {
  e.exports = {
    root: "ABB_CommonUX_BarChart__root",
    light: "ABB_CommonUX_BarChart__light",
    dark: "ABB_CommonUX_BarChart__dark"
  };
}, function (e, n, o) {
  "use strict";

  function t(e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), t(o(113)), t(o(114)), t(o(115));
}, function (e, o, n) {
  "use strict";

  var _t42,
    r = this && this.__extends || (_t42 = function t(e, o) {
      return (_t42 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t42(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    a = this && this.__assign || function () {
      return (a = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var _ = n(0),
    l = n(1),
    s = n(3),
    c = n(2),
    i = n(6),
    b = n(35),
    m = function (n) {
      function e(e) {
        var o = n.call(this, e) || this;
        return i.showExperimentalWarning("Card"), o;
      }
      return r(e, n), e.prototype.render = function () {
        var o = this,
          e = this.props,
          n = e.className,
          t = e.contentClass,
          r = e.title,
          i = {
            style: this.props.contentStyle
          };
        return _.createElement(s.ThemeContext.Consumer, null, function (e) {
          return _.createElement("div", a({}, c.getHtmlAttributes(o.props), {
            className: l(b.card, b[e], n)
          }), _.createElement("h2", null, r), _.createElement("hr", null), _.createElement("div", a({
            className: l(b.content, t)
          }, i), o.props.children));
        });
      }, e;
    }(_.Component);
  o.Card = m, o.default = m;
}, function (e, o, n) {
  "use strict";

  var _t43,
    r = this && this.__extends || (_t43 = function t(e, o) {
      return (_t43 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t43(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var a = n(0),
    _ = n(1),
    l = n(3),
    s = n(2),
    c = n(6),
    b = n(35),
    m = function (n) {
      function e(e) {
        var o = n.call(this, e) || this;
        return c.showExperimentalWarning("CardContainer"), o;
      }
      return r(e, n), e.prototype.render = function () {
        var o = this,
          n = this.props.className;
        return a.createElement(l.ThemeContext.Consumer, null, function (e) {
          return a.createElement("div", i({}, s.getHtmlAttributes(o.props), {
            className: _(b.container, b[e], n)
          }), o.props.children);
        });
      }, e.defaultProps = {}, e;
    }(a.Component);
  o.CardContainer = m, o.default = m;
}, function (e, o, n) {
  "use strict";

  var _t44,
    r = this && this.__extends || (_t44 = function t(e, o) {
      return (_t44 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t44(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var a = n(0),
    _ = n(1),
    l = n(3),
    s = n(2),
    c = n(6),
    b = n(35),
    m = function (n) {
      function e(e) {
        var o = n.call(this, e) || this;
        return c.showExperimentalWarning("CardContainerColumn"), o;
      }
      return r(e, n), e.prototype.render = function () {
        var o = this,
          n = this.props.className;
        return a.createElement(l.ThemeContext.Consumer, null, function (e) {
          return a.createElement("div", i({}, s.getHtmlAttributes(o.props), {
            className: _(b.containerColumn, b[e], n)
          }), o.props.children);
        });
      }, e;
    }(a.Component);
  o.CardContainerColumn = m, o.default = m;
}, function (e, n, o) {
  "use strict";

  function t(e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), t(o(117)), t(o(59));
}, function (e, o, n) {
  "use strict";

  var _t45,
    r = this && this.__extends || (_t45 = function t(e, o) {
      return (_t45 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t45(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    m = this && this.__assign || function () {
      return (m = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var p = n(0),
    u = n(1),
    d = n(3),
    h = n(2),
    B = n(15),
    i = n(59),
    A = n(38),
    _C = function C(e, n, t) {
      return p.Children.forEach(e, function (e) {
        var o;
        "object" == typeof e.type && e.type.componentName === i.Collapsible.componentName && e.props.children && (o = [], _C(e.props.children, n, o)), t.push(m({}, n(e, t, o), {
          childResults: o
        }));
      }), t;
    },
    a = function (n) {
      function e(e) {
        var o = n.call(this, e) || this;
        return o.state = {
          filtered: !1
        }, o.rootRef = p.createRef(), o.onComponentClick = o.onComponentClick.bind(o), o;
      }
      return r(e, n), e.prototype.render = function () {
        var n,
          t = this,
          e = this.props,
          o = e.className,
          i = e.filter,
          r = e.hideFiltered,
          a = e.expandAll,
          _ = e.collapseAll,
          l = e.expanderOnRight,
          s = !1,
          c = !1;
        n = _C(this.props.children, function (e, o, n) {
          return s = s || void 0 !== e.props.icon, c = c || void 0 !== e.props.checked, {
            title: e.props.title,
            match: !i || (t = e.props.title, r = i, -1 < t.toLowerCase().indexOf(r.toLowerCase())),
            recursiveMatch: n && n.some(function (e) {
              return e.recursiveMatch || e.match;
            })
          };
          var t, r;
        }, []);
        var b = B.injectProps(this.props.children, function (e, o) {
          return {
            _passedByParent_: {
              filter: i,
              hideFiltered: r,
              filterResults: n && n[e],
              onComponentClick: t.onComponentClick,
              selected: t.props.selectedCollapsible,
              depth: 0,
              expanderOnRight: l,
              treeContainsIcon: s,
              treeContainsCheckbox: c
            },
            expandAll: a,
            collapseAll: _
          };
        });
        return p.createElement(d.ThemeContext.Consumer, null, function (e) {
          return p.createElement("div", m({}, h.getHtmlAttributes(t.props), {
            className: u(A.containerRoot, A[e], o),
            ref: t.rootRef
          }), b);
        });
      }, e.prototype.onComponentClick = function (e, o) {
        this.props.onItemClick && this.props.onItemClick(e, o);
      }, e.defaultProps = {
        filter: "",
        hideFiltered: !1,
        expandAll: !1,
        collapseAll: !1,
        selectedCollapsible: void 0
      }, e;
    }(p.Component);
  o.CollapsibleContainer = a, o.default = a;
}, function (e, o, n) {
  "use strict";

  var _t46,
    r = this && this.__extends || (_t46 = function t(e, o) {
      return (_t46 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t46(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    u = this && this.__assign || function () {
      return (u = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var d = n(0),
    h = n(1),
    B = n(2),
    A = n(27),
    C = n(38),
    i = function (n) {
      function e(e) {
        var o = n.call(this, e) || this;
        return o.state = {
          isClosed: !o.props.open,
          shouldSwitchAutoOnNextCycle: !1,
          height: o.props.open ? "auto" : 0,
          transition: o.props.open ? "none" : "height " + o.props.transitionTime + "ms " + o.props.easing,
          hasBeenOpened: void 0 !== o.props.open && o.props.open,
          overflow: o.props.open && o.props.overflowWhenOpen ? o.props.overflowWhenOpen : "hidden",
          inTransition: !1,
          shouldOpenOnNextCycle: !1
        }, o.elRefs = {
          inner: d.createRef(),
          outer: d.createRef()
        }, o.handleTriggerClick = o.handleTriggerClick.bind(o), o.handleCheckboxClick = o.handleCheckboxClick.bind(o), o.handleTransitionEnd = o.handleTransitionEnd.bind(o), o.continueOpenCollapsible = o.continueOpenCollapsible.bind(o), o;
      }
      return r(e, n), e.prototype.componentDidUpdate = function (e, o) {
        var n = this;
        this.state.shouldOpenOnNextCycle && this.continueOpenCollapsible(), 0 !== o.height && !0 === this.state.shouldSwitchAutoOnNextCycle && window.setTimeout(function () {
          n.setState({
            height: 0,
            overflow: "hidden",
            isClosed: !0,
            shouldSwitchAutoOnNextCycle: !1
          });
        }, 50), e.open !== this.props.open && (!0 === this.props.open ? (this.openCollapsible(), this.props.onOpening()) : (this.closeCollapsible(), this.props.onClosing()));
      }, e.prototype.closeCollapsible = function () {
        this.setState({
          shouldSwitchAutoOnNextCycle: !0,
          height: this.elRefs.inner.current.offsetHeight,
          transition: "height " + (this.props.transitionCloseTime ? this.props.transitionCloseTime : this.props.transitionTime) + "ms " + this.props.easing,
          inTransition: !0
        });
      }, e.prototype.openCollapsible = function () {
        this.setState({
          inTransition: !0,
          shouldOpenOnNextCycle: !0
        });
      }, e.prototype.continueOpenCollapsible = function () {
        this.setState({
          height: this.elRefs.inner.current.offsetHeight,
          transition: "height " + this.props.transitionTime + "ms " + this.props.easing,
          isClosed: !1,
          hasBeenOpened: !0,
          inTransition: !0,
          shouldOpenOnNextCycle: !1
        });
      }, e.prototype.handleTriggerClick = function (e) {
        e.preventDefault(), this.props.handleTriggerClick && this.props.handleTriggerClick(this.props.accordionPosition, e), this.props.triggerDisabled || 0 < d.Children.count(this.props.children) && (!0 === this.state.isClosed ? (this.openCollapsible(), this.props.onOpening()) : (this.closeCollapsible(), this.props.onClosing()));
      }, e.prototype.handleCheckboxClick = function () {
        this.props.triggerDisabled || this.props.handleCheckboxClick && this.props.handleCheckboxClick(this.props.id);
      }, e.prototype.renderTriggerIcon = function () {
        return this.props.triggerIcon ? "function" == typeof this.props.triggerIcon ? this.props.triggerIcon() : this.props.triggerIcon : null;
      }, e.prototype.renderNonClickableTriggerElement = function () {
        return this.props.triggerSibling && "string" == typeof this.props.triggerSibling ? d.createElement("span", {
          className: this.props.classParentString + "__trigger-sibling"
        }, this.props.triggerSibling) : this.props.triggerSibling ? this.props.triggerSibling : null;
      }, e.prototype.handleTransitionEnd = function () {
        this.state.isClosed ? (this.setState({
          inTransition: !1
        }), this.props.onClose()) : (this.setState({
          height: "auto",
          overflow: this.props.overflowWhenOpen || "hidden",
          inTransition: !1
        }), this.props.onOpen());
      }, e.prototype.filterMatchesRecursively = function (n) {
        var t = !1;
        return t || d.Children.forEach(this.props.children, function (e, o) {
          t = t || e.props.filterMatchesRecursively(n);
        }), t;
      }, e.prototype.render = function () {
        var n = this,
          e = {
            height: this.state.height,
            WebkitTransition: this.state.transition,
            msTransition: this.state.transition,
            transition: this.state.transition,
            overflow: this.state.overflow
          },
          o = this.state.isClosed ? "is-closed" : "is-open",
          t = this.props.triggerDisabled ? "is-disabled" : "",
          r = !1 === this.state.isClosed && void 0 !== this.props.triggerWhenOpen ? this.props.triggerWhenOpen : this.props.trigger,
          i = this.props.lazyRender && !this.state.hasBeenOpened && this.state.isClosed && !this.state.inTransition ? null : this.props.children,
          a = "" + (this.state.isClosed ? this.props.triggerClassName : this.props.triggerOpenedClassName),
          _ = "" + (this.props.isSelected ? this.props.selectedClassName : ""),
          l = (this.props.classParentString + "__trigger " + o + " " + t + " " + a + " " + _).trim(),
          s = (this.props.classParentString + " " + (this.state.isClosed ? this.props.className : this.props.openedClassName)).trim(),
          c = (this.props.classParentString + "__contentOuter " + this.props.contentOuterClassName).trim(),
          b = (this.props.classParentString + "__contentInner " + this.props.contentInnerClassName).trim(),
          m = 0 < d.Children.count(this.props.children) ? this.props.hasChildrenClassName : "",
          p = this.props.extraClasses.trim();
        return d.createElement("div", {
          className: h(s, p, m)
        }, d.createElement(function (e) {
          return d.createElement(n.props.triggerTagName, e);
        }, u({}, B.getHtmlAttributes(this.props), {
          className: l,
          onClick: this.handleTriggerClick,
          onKeyPress: function onKeyPress(e) {
            var o = e.key;
            " " !== o && "Enter" !== o || n.handleTriggerClick(e);
          },
          tabIndex: this.props.tabIndex && this.props.tabIndex
        }), void 0 === this.props.checked && this.props.leaveSpaceForCheckbox && d.createElement("span", {
          style: {
            display: "inline-block",
            width: "24px",
            height: "16px"
          }
        }), void 0 !== this.props.checked && d.createElement("span", {
          className: C.checkbox
        }, d.createElement(A.Checkbox, {
          sizeClass: "small",
          value: this.props.checked,
          onChange: this.handleCheckboxClick,
          style: {
            marginLeft: "0"
          }
        })), this.renderTriggerIcon(), d.createElement("span", null, r)), this.renderNonClickableTriggerElement(), d.createElement("div", {
          className: c,
          ref: this.elRefs.outer,
          style: e,
          onTransitionEnd: this.handleTransitionEnd
        }, d.createElement("div", {
          className: b,
          ref: this.elRefs.inner
        }, i)));
      }, e.defaultProps = {
        extraClasses: "",
        transitionTime: 100,
        transitionCloseTime: void 0,
        triggerTagName: "span",
        easing: "linear",
        open: !1,
        classParentString: "Collapsible",
        triggerDisabled: !1,
        lazyRender: !1,
        overflowWhenOpen: "hidden",
        openedClassName: "",
        selectedClassName: "",
        triggerClassName: "",
        triggerOpenedClassName: "",
        contentOuterClassName: "",
        contentInnerClassName: "",
        hasChildrenClassName: "",
        triggerSibling: void 0,
        triggerIcon: void 0,
        onOpen: function onOpen() {},
        onClose: function onClose() {},
        onOpening: function onOpening() {},
        onClosing: function onClosing() {},
        tabIndex: void 0
      }, e;
    }(d.Component);
  o.CollapsibleImpl = i, o.default = i;
}, function (e, n, o) {
  "use strict";

  Object.defineProperty(n, "__esModule", {
    value: !0
  }), function (e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }(o(120));
}, function (e, o, n) {
  "use strict";

  var _t47,
    r = this && this.__extends || (_t47 = function t(e, o) {
      return (_t47 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t47(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    a = this && this.__assign || function () {
      return (a = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var _ = n(0),
    l = n(1),
    s = n(3),
    c = n(21),
    d = n(47),
    i = n(6),
    b = n(2),
    m = n(121),
    p = function (n) {
      function e(e) {
        var o = n.call(this, e) || this;
        return o.state = {
          chartWidth: 0,
          chartHeight: 0,
          hiddenValueKeys: new Array(),
          hoverItem: void 0
        }, o.hoverDisabled = !1, o.reason = void 0, o.previousValues = {}, o.firstUpdate = !0, i.showExperimentalWarning("DonutChart"), o._handleClick = o._handleClick.bind(o), o._handleResize = o._handleResize.bind(o), o._handleLegendRowClick = o._handleLegendRowClick.bind(o), o._beginMouseOver = o._beginMouseOver.bind(o), o._endMouseOver = o._endMouseOver.bind(o), o.svgRef = _.createRef(), o;
      }
      return r(e, n), e.prototype.componentDidUpdate = function (e, o) {
        var n = this,
          t = this.props.data,
          r = this.state,
          i = r.chartWidth,
          a = r.chartHeight;
        if (0 < i && 0 < a) {
          var _ = Math.min(i, a) / 2 * .9,
            l = .75 * _,
            s = _ + 5,
            c = l - 5,
            b = d.pie().value(function (e, o) {
              return e.value;
            }),
            m = d.arc().innerRadius(l).outerRadius(_),
            p = d.arc().innerRadius(c).outerRadius(s),
            u = d.select(this.svgRef.current).selectAll("g").attr("transform", "translate(" + (_ + 5) + ", " + (_ + 5) + ")").selectAll("path").data(b(t.filter(function (e, o) {
              return -1 === n.state.hiddenValueKeys.indexOf(e.key);
            })), function (e) {
              return e.data.key;
            });
          u.enter().append("path").on("mouseover", function (e, o) {
            n.hoverDisabled || (n.reason = "hover", n.setState({
              hoverItem: e.data.key
            }));
          }).on("mouseout", function (e, o) {
            n.hoverDisabled || (n.reason = "hover", n.setState({
              hoverItem: void 0
            }));
          }).style("opacity", "0").transition().delay(function (e, o) {
            return n.firstUpdate ? 0 : 1e3;
          }).duration(1).style("opacity", "1").attr("fill", function (e, o) {
            return e.data.color;
          }).attr("d", function (e, o) {
            return m(e);
          }), u.exit().style("opacity", "0").transition().duration(300).remove(), this.firstUpdate && (u.enter().each(function (e) {
            return n.previousValues[e.data.label] = e;
          }), this.firstUpdate = !1), "hover" !== this.reason ? u.style("unknown", function (e, o) {
            return n.hoverDisabled = !0, "";
          }).transition().delay(300).duration(700).attr("d", function (e, o) {
            return n.state.hoverItem === e.data.key ? p(e) : m(e);
          }).attrTween("d", function (e, o) {
            return n.hoverDisabled = !0, n.arcTween(e, m, n.previousValues);
          }).on("end", function () {
            n.hoverDisabled = !1, u.each(function (e) {
              return n.previousValues[e.data.label] = e;
            });
          }) : (this.hoverDisabled = !1, u.transition().duration(100).attr("d", function (e, o) {
            return n.state.hoverItem === e.data.key ? p(e) : m(e);
          })), this.reason = void 0;
        }
      }, e.prototype.render = function () {
        var r = this,
          e = this.props,
          o = e.className,
          n = e.showLegend,
          i = e.allowValueHiding,
          t = e.data;
        return _.createElement(s.ThemeContext.Consumer, null, function (e) {
          return _.createElement("div", a({}, b.getHtmlAttributes(r.props), {
            className: l(m.root, m[e], o),
            onClick: r._handleClick
          }), _.createElement("div", {
            className: l(m.chart)
          }, _.createElement("svg", {
            width: "100%",
            height: "100%",
            ref: r.svgRef
          }, _.createElement("g", null)), _.createElement(c.default, {
            handleWidth: !0,
            handleHeight: !1,
            onResize: r._handleResize
          })), n && _.createElement("div", {
            className: l(m.legend)
          }, t.map(function (e, o) {
            var n, t;
            return _.createElement("div", {
              key: e.label,
              "data-key": e.key,
              className: l(m.legendRow, (n = {}, n[m.hiddenValue] = -1 < r.state.hiddenValueKeys.indexOf(e.key), n[m.legendHover] = r.state.hoverItem === e.key, n))
            }, _.createElement("span", {
              onMouseEnter: r._beginMouseOver,
              onMouseLeave: r._endMouseOver,
              onClick: r._handleLegendRowClick
            }, _.createElement("span", {
              style: {
                background: e.color
              }
            }), _.createElement("span", {
              className: l((t = {}, t[m.isClickable] = i, t))
            }, _.createElement("span", null, e.label), _.createElement("span", null, "(", e.value, ")"))));
          })));
        });
      }, e.prototype.arcTween = function (e, o, n) {
        var t = 0,
          r = 0;
        r = n[e.data.label] ? (t = n[e.data.label].startAngle, n[e.data.label].endAngle) : (t = e.startAngle, e.endAngle);
        var i = {
            data: e.data,
            value: e.value,
            startAngle: t,
            endAngle: r
          },
          a = d.interpolate(i, e);
        return i = a(0), function (e) {
          return o(a(e));
        };
      }, e.prototype._handleResize = function (e, o) {
        this.reason = "resize", this.setState({
          chartWidth: e,
          chartHeight: o
        });
      }, e.prototype._handleClick = function (e) {
        e.preventDefault(), this.props.onClick && this.props.onClick(e);
      }, e.prototype._handleLegendRowClick = function (e) {
        if (e.preventDefault(), !this.hoverDisabled && this.props.allowValueHiding) {
          var o = e.currentTarget.parentElement.dataset.key,
            n = this.state.hiddenValueKeys.indexOf(o),
            t = this.state.hiddenValueKeys.slice();
          -1 < n ? t.splice(this.state.hiddenValueKeys.indexOf(o), 1) : t.push(o), this.reason = "select", this.setState({
            hiddenValueKeys: t
          });
        }
      }, e.prototype._beginMouseOver = function (e) {
        var o = e.currentTarget.parentElement.dataset.key;
        this.hoverDisabled || -1 !== this.state.hiddenValueKeys.indexOf(o) || (this.reason = "hover", this.setState({
          hoverItem: o
        }));
      }, e.prototype._endMouseOver = function (e) {
        this.hoverDisabled || (this.reason = "hover", this.setState({
          hoverItem: void 0
        }));
      }, e.defaultProps = {}, e;
    }(_.Component);
  o.DonutChart = p, o.default = p;
}, function (e, o, n) {
  e.exports = {
    root: "ABB_CommonUX_DonutChart__root",
    chart: "ABB_CommonUX_DonutChart__chart",
    legend: "ABB_CommonUX_DonutChart__legend",
    legendRow: "ABB_CommonUX_DonutChart__legendRow",
    isClickable: "ABB_CommonUX_DonutChart__isClickable",
    legendHover: "ABB_CommonUX_DonutChart__legendHover",
    hiddenValue: "ABB_CommonUX_DonutChart__hiddenValue"
  };
}, function (e, n, o) {
  "use strict";

  function t(e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), t(o(44)), t(o(34)), t(o(33));
}, function (e, n, o) {
  "use strict";

  function t(e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), t(o(61)), t(o(125));
}, function (e, o, n) {
  e.exports = {
    root: "ABB_CommonUX_Expander__root",
    isNested: "ABB_CommonUX_Expander__isNested",
    header: "ABB_CommonUX_Expander__header",
    content: "ABB_CommonUX_Expander__content",
    open: "ABB_CommonUX_Expander__open",
    light: "ABB_CommonUX_Expander__light",
    dark: "ABB_CommonUX_Expander__dark"
  };
}, function (e, o, n) {
  "use strict";

  var _t48,
    r = this && this.__extends || (_t48 = function t(e, o) {
      return (_t48 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t48(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var a = n(0),
    _ = n(15),
    l = n(61),
    s = n(2),
    c = n(6),
    b = function (n) {
      function e(e) {
        var o = n.call(this, e) || this;
        return o.state = {
          openedChild: null
        }, c.showExperimentalWarning("ExpanderGroup"), o.onClickChild = o.onClickChild.bind(o), o;
      }
      return r(e, n), e.prototype.render = function () {
        var n = this,
          e = Array.isArray(this.props.children) ? this.props.children : [this.props.children];
        _.childrenAreTypeOf(e, l.default.componentName);
        var o = e;
        return this.props.singleMode && (o = _.injectProps(e, function (e, o) {
          return {
            open: n.state.openedChild === o,
            onClick: function onClick(e) {
              return n.onClickChild(e, o);
            }
          };
        })), a.createElement("div", i({}, s.getHtmlAttributes(this.props)), o);
      }, e.prototype.onClickChild = function (e, o) {
        e.preventDefault(), this.setState({
          openedChild: this.state.openedChild === o ? null : o
        }), o.props.onClick && o.props.onClick(e);
      }, e.defaultProps = {
        singleMode: !0
      }, e;
    }(a.Component);
  o.ExpanderGroup = b, o.default = b;
}, function (e, n, o) {
  "use strict";

  Object.defineProperty(n, "__esModule", {
    value: !0
  }), function (e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }(o(127));
}, function (e, o, n) {
  "use strict";

  var _t49,
    r = this && this.__extends || (_t49 = function t(e, o) {
      return (_t49 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t49(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    v = this && this.__assign || function () {
      return (v = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var U = n(0),
    X = n(1),
    w = n(47),
    i = n(21),
    O = n(3),
    k = n(2),
    a = n(6),
    x = n(128),
    _ = n(5).getVariables(),
    l = function (n) {
      function e(e) {
        var o = n.call(this, e) || this;
        return o.state = {
          chartWidth: 0,
          chartHeight: 0
        }, o.startAngle = Math.PI / 180 * -117.5, o.endAngle = Math.PI / 180 * 117.5, o.justOuterArc = /[Mm][\d\.\-e,\s]+A[\d\.\-e,\s]+/, o.updateReason = "first-draw", o.elements = {}, a.showExperimentalWarning("Gauge"), o._handleClick = o._handleClick.bind(o), o._handleResize = o._handleResize.bind(o), o._getForegroundColor = o._getForegroundColor.bind(o), o._getXYForAngle = o._getXYForAngle.bind(o), o.svgRef = U.createRef(), o;
      }
      return r(e, n), e.prototype.componentDidUpdate = function (e, o) {
        if ("radial" === this.props.type) {
          var n = this.props,
            t = n.value,
            r = n.min,
            i = n.max,
            a = n.limitStyle,
            _ = n.unit,
            l = n.label,
            s = this.state,
            c = s.chartWidth,
            b = s.chartHeight;
          if (0 < c && 0 < b) {
            var m = Math.min(c, b) / 2 * .7,
              p = 8 / 9 * m,
              u = this._getAngleForValue(t, r, i, this.startAngle, this.endAngle),
              d = w.select(this.svgRef.current).selectAll("g").attr("transform", "translate(" + c / 2 + ", " + 15 / 9 * m + ")");
            "resize" !== this.updateReason && "first-draw" !== this.updateReason && e.limitStyle === a && e.unit === _ && e.label === l || (this.reCreateAllElements(d, p, m, u), this.updateReason = void 0), this.updateAllElements(e, p, m, u);
          }
        }
      }, e.prototype.render = function () {
        return "radial" === this.props.type ? this.renderRadial() : this.renderBar();
      }, e.prototype.renderBar = function () {
        var n = this,
          e = this.props,
          t = e.className,
          r = e.value,
          i = e.min,
          a = e.minLabel,
          _ = e.max,
          l = e.maxLabel,
          s = e.limitStyle,
          c = e.unit,
          b = e.label,
          m = e.decimals,
          p = e.lowWarn,
          u = e.lowAlarm,
          d = e.highWarn,
          h = e.highAlarm,
          B = this._getForegroundColor(),
          A = this._getWidthForValue(r, i, _),
          C = this._getWidthForValue(p || i, i, _),
          f = this._getWidthForValue(u || i, i, _),
          y = this._getWidthForValue(d || _, i, _, !0),
          g = this._getWidthForValue(h || _, i, _, !0);
        return U.createElement(O.ThemeContext.Consumer, null, function (e) {
          var o;
          return U.createElement("div", v({}, k.getHtmlAttributes(n.props), {
            className: X(x.root, x.linear, x[e], t),
            onClick: n._handleClick
          }), U.createElement("div", {
            className: x.header
          }, U.createElement("span", null, b), U.createElement("span", null, U.createElement("span", {
            className: x.value
          }, r.toFixed(m)), U.createElement("span", {
            className: x.unit
          }, c))), U.createElement("div", {
            className: x.bar
          }, U.createElement("span", {
            className: x.bg
          }), U.createElement("span", {
            className: x.fg,
            style: {
              background: B,
              width: A
            }
          }), U.createElement("div", {
            className: X(x.limits, (o = {}, o[x.parallel] = "parallel" === s, o[x.orthogonal] = "orthogonal" === s, o))
          }, void 0 !== p && U.createElement("div", v({
            className: x.lowWarn
          }, "parallel" === s ? {
            style: {
              width: C
            }
          } : {
            style: {
              left: C
            }
          })), void 0 !== d && U.createElement("div", v({
            className: x.highWarn
          }, "parallel" === s ? {
            style: {
              width: y
            }
          } : {
            style: {
              right: y
            }
          })), void 0 !== u && U.createElement("div", v({
            className: x.lowAlarm
          }, "parallel" === s ? {
            style: {
              width: f
            }
          } : {
            style: {
              left: f
            }
          })), void 0 !== h && U.createElement("div", v({
            className: x.highAlarm
          }, "parallel" === s ? {
            style: {
              width: g
            }
          } : {
            style: {
              right: g
            }
          })))), U.createElement("div", {
            className: x.minMax
          }, U.createElement("span", null, a || i.toFixed(m)), U.createElement("span", null, l || _.toFixed(m))));
        });
      }, e.prototype.renderRadial = function () {
        var o = this,
          n = this.props.className;
        return U.createElement(O.ThemeContext.Consumer, null, function (e) {
          return U.createElement("div", v({}, k.getHtmlAttributes(o.props), {
            className: X(x.root, x.radial, x[e], n),
            onClick: o._handleClick
          }), U.createElement("svg", {
            ref: o.svgRef
          }, U.createElement("g", null)), U.createElement(i.default, {
            handleWidth: !0,
            handleHeight: !1,
            onResize: o._handleResize
          }));
        });
      }, e.prototype.reCreateAllElements = function (e, o, n, t) {
        var r = this.props,
          i = (r.value, r.min),
          a = r.minLabel,
          _ = r.max,
          l = r.maxLabel,
          s = r.limitStyle,
          c = r.unit,
          b = r.label,
          m = r.decimals;
        e.selectAll("*").remove();
        var p = w.arc().innerRadius(o).outerRadius(n).startAngle(this.startAngle).endAngle(this.endAngle);
        this.elements.bg = e.append("path").attr("class", x.background).attr("d", p);
        var u = this._getForegroundColor();
        if (this.elements.fg = e.append("path").datum({
          endAngle: t,
          color: u
        }).attr("class", x.foreground).attr("fill", this._getForegroundColor()), "parallel" === s) {
          var d = .86 * n - .84 * n + "px";
          this.elements.lowWarnParallel = e.append("path").attr("class", x.parallelLowWarningLimit).attr("stroke", this.props.warnColor).attr("stroke-width", d), this.elements.highWarnParallel = e.append("path").attr("class", x.parallelHighWarningLimit).attr("stroke", this.props.warnColor).attr("stroke-width", d), this.elements.lowAlarmParallel = e.append("path").attr("class", x.parallelLowAlarmLimit).attr("stroke", this.props.alarmColor).attr("stroke-width", d), this.elements.highAlarmParallel = e.append("path").attr("class", x.parallelHighAlarmLimit).attr("stroke", this.props.alarmColor).attr("stroke-width", d);
        } else "orthogonal" === s && (this.elements.lowWarnOrthogonal = e.append("path").attr("class", x.orthogonallLowWarningLimit), this.elements.lowAlarmOrthogonal = e.append("path").attr("class", x.orthogonallLowAlarmLimit), this.elements.highWarnOrthogonal = e.append("path").attr("class", x.orthogonallHighWarningLimit), this.elements.highAlarmOrthogonal = e.append("path").attr("class", x.orthogonallHighAlarmLimit));
        this.elements.label = e.append("text").text(b).attr("class", x.label).attr("font-size", this._getFontSize(n, 1)).attr("dx", "0").attr("dy", -(1 + 4 / 9) * n), this.elements.value = e.append("text").attr("class", x.value).attr("font-size", this._getFontSize(n, 6)), this.elements.unit = e.append("text").text(c).attr("class", x.unit).attr("font-size", this._getFontSize(n, 2)).attr("dy", 2.5 / 9 * n), this.elements.min = e.append("text").text(a || i.toFixed(m)).attr("class", x.min).attr("font-size", this._getFontSize(n, 2.5)).attr("dx", Math.cos(27.5) * n).attr("dy", Math.sin(27.5) * n + .05 * n), this.elements.max = e.append("text").text(l || _.toFixed(m)).attr("class", x.max).attr("font-size", this._getFontSize(n, 2.5)).attr("dx", -Math.cos(27.5) * n).attr("dy", Math.sin(27.5) * n + .05 * n);
      }, e.prototype.updateAllElements = function (n, l, s, e) {
        var c = this,
          o = this.props,
          t = o.value,
          r = o.min,
          i = o.max,
          a = o.limitStyle,
          _ = o.lowWarn,
          b = o.lowAlarm,
          m = o.highWarn,
          p = o.highAlarm,
          u = (o.setpoint, o.unit, o.label, o.decimals),
          d = this._getAngleForValue(_ || r, r, i, this.startAngle, this.endAngle),
          h = this._getAngleForValue(b || r, r, i, this.startAngle, this.endAngle),
          B = this._getAngleForValue(m || i, r, i, this.startAngle, this.endAngle),
          A = this._getAngleForValue(p || i, r, i, this.startAngle, this.endAngle),
          C = (.86 * s + .84 * s) / 2,
          f = w.arc().innerRadius(l).outerRadius(s).startAngle(this.startAngle);
        if (this.elements.value.transition().tween("text", function (e) {
          var o = w.interpolate(n.value, t);
          return function (e) {
            return c.elements.value.text(w.format(u ? "." + u + "f" : "d")(o(e)));
          };
        }), "parallel" === a) {
          if (this.elements.lowWarnParallel) {
            var y = this.justOuterArc.exec(w.arc().innerRadius(C).outerRadius(C).startAngle(this.startAngle).endAngle(d)().toString());
            this.elements.lowWarnParallel.attr("d", y && y[0]);
          }
          if (this.elements.highWarnParallel) {
            var g = this.justOuterArc.exec(w.arc().innerRadius(C).outerRadius(C).startAngle(this.endAngle).endAngle(B)().toString());
            this.elements.highWarnParallel.attr("d", g && g[0]);
          }
          if (this.elements.lowAlarmParallel) {
            var v = this.justOuterArc.exec(w.arc().innerRadius(C).outerRadius(C).startAngle(h).endAngle(this.startAngle)().toString());
            this.elements.lowAlarmParallel.attr("d", v && v[0]);
          }
          if (this.elements.highAlarmParallel) {
            var U = this.justOuterArc.exec(w.arc().innerRadius(C).outerRadius(C).startAngle(A).endAngle(this.endAngle)().toString());
            this.elements.highAlarmParallel.attr("d", U && U[0]);
          }
        } else "orthogonal" === a && [{
          el: this.elements.lowWarnOrthogonal,
          angle: d
        }, {
          el: this.elements.lowAlarmOrthogonal,
          angle: h
        }, {
          el: this.elements.highWarnOrthogonal,
          angle: B
        }, {
          el: this.elements.highAlarmOrthogonal,
          angle: A
        }].forEach(function (_) {
          _.el && _.el.attr("d", function (e, o, n) {
            var t = c._getXYForAngle(s + 8, _.angle - Math.PI / 2),
              r = t.x,
              i = t.y,
              a = c._getXYForAngle(l - 8, _.angle - Math.PI / 2);
            return "M" + a.x + "," + a.y + "L" + r + "," + i + "Z";
          });
        });
        this.elements.fg.transition().duration(900).ease(w.easeExpIn, 1).ease(w.easeExpOut, .05).attrTween("d", function (o) {
          var n = w.interpolate(o.endAngle, e);
          return function (e) {
            return o.endAngle = n(e), f(o);
          };
        }).styleTween("fill", function (e) {
          var o = e.color;
          return e.color = c._getForegroundColor(), w.interpolate(o, e.color);
        });
      }, e.prototype._getForegroundColor = function () {
        var e = this.props,
          o = e.value,
          n = e.lowWarn,
          t = e.lowAlarm,
          r = e.highWarn,
          i = e.highAlarm;
        return void 0 !== t && o < t ? this.props.alarmColor : void 0 !== i && i < o ? this.props.alarmColor : void 0 !== n && o < n ? this.props.warnColor : void 0 !== r && r < o ? this.props.warnColor : this.props.color;
      }, e.prototype._getXYForAngle = function (e, o) {
        return {
          x: e * Math.cos(o),
          y: e * Math.sin(o)
        };
      }, e.prototype._getAngleForValue = function (e, o, n, t, r) {
        return t + (r - t) * ((Math.max(o, Math.min(e, n)) - o) / (n - o));
      }, e.prototype._getWidthForValue = function (e, o, n, t) {
        void 0 === t && (t = !1);
        var r = (Math.max(o, Math.min(e, n)) - o) / (n - o);
        return t ? 100 - 100 * r + "%" : 100 * r + "%";
      }, e.prototype._getFontSize = function (e, o) {
        return 1 / 9 * e * o + "px";
      }, e.prototype._handleResize = function (e, o) {
        this.updateReason = "resize", this.setState({
          chartWidth: e,
          chartHeight: o
        });
      }, e.prototype._handleClick = function (e) {
        e.preventDefault(), this.props.onClick && this.props.onClick(e);
      }, e.defaultProps = {
        type: "radial",
        unit: "",
        label: "",
        decimals: 0,
        limitStyle: "parallel",
        color: "rebeccapurple",
        warnColor: _["abb-alarm-orange"],
        alarmColor: _["abb-alarm-red"]
      }, e;
    }(U.Component);
  o.Gauge = l, o.default = l;
}, function (e, o, n) {
  e.exports = {
    root: "ABB_CommonUX_Gauge__root",
    linear: "ABB_CommonUX_Gauge__linear",
    header: "ABB_CommonUX_Gauge__header",
    value: "ABB_CommonUX_Gauge__value",
    unit: "ABB_CommonUX_Gauge__unit",
    bar: "ABB_CommonUX_Gauge__bar",
    bg: "ABB_CommonUX_Gauge__bg",
    fg: "ABB_CommonUX_Gauge__fg",
    limits: "ABB_CommonUX_Gauge__limits",
    parallel: "ABB_CommonUX_Gauge__parallel",
    lowWarn: "ABB_CommonUX_Gauge__lowWarn",
    lowAlarm: "ABB_CommonUX_Gauge__lowAlarm",
    highWarn: "ABB_CommonUX_Gauge__highWarn",
    highAlarm: "ABB_CommonUX_Gauge__highAlarm",
    orthogonal: "ABB_CommonUX_Gauge__orthogonal",
    minMax: "ABB_CommonUX_Gauge__minMax",
    radial: "ABB_CommonUX_Gauge__radial",
    label: "ABB_CommonUX_Gauge__label",
    min: "ABB_CommonUX_Gauge__min",
    max: "ABB_CommonUX_Gauge__max",
    background: "ABB_CommonUX_Gauge__background",
    foreground: "ABB_CommonUX_Gauge__foreground",
    parallelLowAlarmLimit: "ABB_CommonUX_Gauge__parallelLowAlarmLimit",
    parallelHighAlarmLimit: "ABB_CommonUX_Gauge__parallelHighAlarmLimit",
    parallelLowWarningLimit: "ABB_CommonUX_Gauge__parallelLowWarningLimit",
    parallelHighWarningLimit: "ABB_CommonUX_Gauge__parallelHighWarningLimit",
    orthogonallLowAlarmLimit: "ABB_CommonUX_Gauge__orthogonallLowAlarmLimit",
    orthogonallHighAlarmLimit: "ABB_CommonUX_Gauge__orthogonallHighAlarmLimit",
    orthogonallLowWarningLimit: "ABB_CommonUX_Gauge__orthogonallLowWarningLimit",
    orthogonallHighWarningLimit: "ABB_CommonUX_Gauge__orthogonallHighWarningLimit"
  };
}, function (e, n, o) {
  "use strict";

  Object.defineProperty(n, "__esModule", {
    value: !0
  }), function (e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }(o(130));
}, function (e, o, n) {
  "use strict";

  var _t50,
    r = this && this.__extends || (_t50 = function t(e, o) {
      return (_t50 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t50(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    s = this && this.__assign || function () {
      return (s = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var c = n(0),
    b = n(1),
    m = n(3),
    i = n(6),
    p = n(2),
    u = n(131),
    a = function (n) {
      function e(e) {
        var o = n.call(this, e) || this;
        return i.showExperimentalWarning("Heading"), o._handleClick = o._handleClick.bind(o), o;
      }
      return r(e, n), e.prototype.render = function () {
        var t = this,
          e = this.props,
          r = e.className,
          i = e.text,
          o = e.level,
          a = e.showCursor,
          _ = e.blackAndWhite,
          l = "h" + o;
        return c.createElement(m.ThemeContext.Consumer, null, function (e) {
          var o, n;
          return c.createElement(l, s({}, p.getHtmlAttributes(t.props), {
            className: b(u.root, u[e], r, (o = {}, o[u.withCursor] = a, o), (n = {}, n[u.blackwhite] = _, n)),
            onClick: t._handleClick
          }), i);
        });
      }, e.prototype._handleClick = function (e) {
        e.preventDefault(), this.props.onClick && this.props.onClick(e);
      }, e.defaultProps = {
        showCursor: !0
      }, e;
    }(c.Component);
  o.Heading = a, o.default = a;
}, function (e, o, n) {
  e.exports = {
    root: "ABB_CommonUX_Heading__root",
    withCursor: "ABB_CommonUX_Heading__withCursor",
    light: "ABB_CommonUX_Heading__light",
    blackwhite: "ABB_CommonUX_Heading__blackwhite",
    dark: "ABB_CommonUX_Heading__dark"
  };
}, function (e, n, o) {
  "use strict";

  Object.defineProperty(n, "__esModule", {
    value: !0
  }), function (e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }(o(133));
}, function (e, o, n) {
  "use strict";

  var _t51,
    r = this && this.__extends || (_t51 = function t(e, o) {
      return (_t51 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t51(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var a = n(0),
    _ = n(1),
    l = n(3),
    s = n(6),
    c = n(2),
    b = n(134),
    m = function (n) {
      function e(e) {
        var o = n.call(this, e) || this;
        return o.state = {
          some: 42
        }, s.showExperimentalWarning("LineChart"), o._handleClick = o._handleClick.bind(o), o;
      }
      return r(e, n), e.prototype.render = function () {
        var o = this,
          n = this.props.className;
        return a.createElement(l.ThemeContext.Consumer, null, function (e) {
          return a.createElement("div", i({}, c.getHtmlAttributes(o.props), {
            className: _(b.root, b[e], n),
            onClick: o._handleClick
          }), o.props.children);
        });
      }, e.prototype._handleClick = function (e) {
        e.preventDefault(), this.props.onClick && this.props.onClick(e), this.setState(function (e) {
          return {
            some: e.some + 1
          };
        });
      }, e.defaultProps = {}, e;
    }(a.Component);
  o.LineChart = m, o.default = m;
}, function (e, o, n) {
  e.exports = {
    root: "ABB_CommonUX_LineChart__root",
    light: "ABB_CommonUX_LineChart__light",
    dark: "ABB_CommonUX_LineChart__dark"
  };
}, function (e, n, o) {
  "use strict";

  Object.defineProperty(n, "__esModule", {
    value: !0
  }), function (e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }(o(136));
}, function (e, o, n) {
  "use strict";

  var _t52,
    r = this && this.__extends || (_t52 = function t(e, o) {
      return (_t52 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t52(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    h = this && this.__assign || function () {
      return (h = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var B = n(0),
    A = n(1),
    C = n(3),
    f = n(2),
    y = n(26),
    g = n(16),
    v = n(27),
    U = n(28),
    X = n(48),
    i = function (n) {
      function e(e) {
        var o = n.call(this, e) || this;
        return o.state = {
          rememberMe: !1,
          username: "",
          password: ""
        }, o._handleLogin = o._handleLogin.bind(o), o._setUsername = o._setUsername.bind(o), o._setPassword = o._setPassword.bind(o), o._toggleRememberMe = o._toggleRememberMe.bind(o), o;
      }
      return r(e, n), e.prototype.render = function () {
        var n = this,
          e = this.props,
          t = e.className,
          r = e.productName,
          i = e.productSubName,
          a = e.productFullName,
          _ = e.loading,
          l = e.footerText,
          s = e.showDefaultFields,
          c = e.showLoginButton,
          b = e.usernameLabelText,
          m = e.passwordLabelText,
          p = e.loginButtonText,
          u = e.rememberMeText,
          d = e.copyrightText;
        return B.createElement(C.ThemeContext.Provider, {
          value: "light"
        }, B.createElement(C.ThemeContext.Consumer, null, function (e) {
          var o;
          return B.createElement("div", h({}, f.getHtmlAttributes(n.props), {
            className: A(X.root, X[e], t, (o = {}, o[X.loading] = _, o))
          }), _ && B.createElement("div", {
            className: X.loadingIndicator
          }, B.createElement(U.LoadingIndicator, {
            color: "red",
            sizeClass: "small",
            determinate: !1
          })), B.createElement("div", {
            className: X.header
          }, B.createElement("div", null, a), B.createElement("div", {
            className: X.logo
          })), B.createElement("div", {
            className: X.contentWrapper
          }, B.createElement("div", {
            className: A(X.content)
          }, B.createElement("h1", {
            className: X.productName
          }, r), B.createElement("h2", {
            className: X.productSubName
          }, i), B.createElement("form", null, B.createElement("div", {
            className: X.formRow
          }, n.props.customContent && B.createElement("div", {
            className: X.customContent
          }, n.props.customContent(n.props, n.state))), s && B.createElement(B.Fragment, null, B.createElement("div", {
            className: X.formRow
          }, B.createElement("div", null, B.createElement(y.Input, {
            dataType: "text",
            type: "normal",
            value: n.state.username,
            label: b,
            icon: "abb/user",
            showValidationBarWhenValid: !1,
            showValidationIconWhenValid: !1,
            inputAttributes: {
              autoComplete: "username"
            },
            onValueChange: n._setUsername
          })), B.createElement("div", {
            className: X.password
          }, B.createElement(y.Input, {
            dataType: "password",
            type: "normal",
            value: n.state.password,
            label: m,
            icon: "abb/lock-closed",
            showValidationBarWhenValid: !1,
            showValidationIconWhenValid: !1,
            inputAttributes: {
              autoComplete: "current-password"
            },
            onValueChange: n._setPassword
          }))), B.createElement("div", {
            className: X.formRow
          }, B.createElement(v.Checkbox, {
            label: u,
            value: n.state.rememberMe,
            onChange: n._toggleRememberMe
          })))), B.createElement("div", {
            className: X.bottom
          }, B.createElement("div", {
            className: A(X.buttons, X.flexSpring)
          }, c && B.createElement("div", {
            className: A(X.button)
          }, B.createElement(g.Button, {
            type: "primary-black",
            onClick: n._handleLogin,
            text: p
          })), n.props.customButtons && n.props.customButtons.map(function (e) {
            return B.createElement("div", {
              className: A(X.button)
            }, B.createElement(g.Button, {
              key: e.text,
              type: e.primary ? "primary-black" : "discreet-black",
              text: e.text,
              onClick: function onClick() {
                return e.handler({
                  username: n.state.username,
                  password: n.state.password,
                  rememberMe: n.state.rememberMe
                });
              }
            }));
          })), B.createElement("p", {
            className: X.copyright
          }, d)))), (l || n.props.children) && B.createElement("div", {
            className: X.footer
          }, B.createElement("div", null, l || n.props.children)));
        }));
      }, e.prototype._setUsername = function (e) {
        this.setState({
          username: e
        });
      }, e.prototype._setPassword = function (e) {
        this.setState({
          password: e
        });
      }, e.prototype._toggleRememberMe = function () {
        this.setState({
          rememberMe: !this.state.rememberMe
        });
      }, e.prototype._handleLogin = function (e) {
        e.preventDefault(), this.props.onLogin && this.props.onLogin(this.state.username, this.state.password, this.state.rememberMe);
      }, e.defaultProps = {
        loading: !1,
        customButtons: [],
        showDefaultFields: !0,
        showLoginButton: !0,
        usernameLabelText: "Username",
        passwordLabelText: "Password",
        loginButtonText: "Login",
        rememberMeText: "Remember me",
        copyrightText: "All rights reserved " + new Date().getFullYear()
      }, e;
    }(B.Component);
  o.LoginScreen = i, o.default = i;
}, function (e, n, o) {
  "use strict";

  Object.defineProperty(n, "__esModule", {
    value: !0
  }), function (e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }(o(138));
}, function (e, o, n) {
  "use strict";

  var _t53,
    r = this && this.__extends || (_t53 = function t(e, o) {
      return (_t53 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t53(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var a = n(0),
    _ = n(1),
    l = n(2),
    s = n(139),
    c = function (n) {
      function e(e) {
        var o = n.call(this, e) || this;
        return o._handleClick = o._handleClick.bind(o), o;
      }
      return r(e, n), e.prototype.render = function () {
        var e = this.props,
          o = e.className,
          n = e.color;
        return a.createElement("div", i({}, l.getHtmlAttributes(this.props), {
          className: _(s.root, s[n], o),
          onClick: this._handleClick
        }));
      }, e.prototype._handleClick = function (e) {
        e.preventDefault(), this.props.onClick && this.props.onClick(e);
      }, e.defaultProps = {}, e;
    }(a.Component);
  o.Logo = c, o.default = c;
}, function (e, o, n) {
  e.exports = {
    root: "ABB_CommonUX_Logo__root",
    red: "ABB_CommonUX_Logo__red",
    light: "ABB_CommonUX_Logo__light",
    dark: "ABB_CommonUX_Logo__dark"
  };
}, function (e, n, o) {
  "use strict";

  function t(e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), t(o(141)), t(o(62)), t(o(63)), t(o(64));
}, function (e, o, n) {
  "use strict";

  var _t54,
    r = this && this.__extends || (_t54 = function t(e, o) {
      return (_t54 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t54(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    c = this && this.__assign || function () {
      return (c = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var b = n(0),
    m = n(1),
    p = n(2),
    u = n(142),
    i = n(3),
    d = n(143),
    h = n(62),
    B = n(63),
    A = n(64),
    C = n(4),
    a = function (n) {
      function e(e) {
        var o = n.call(this, e) || this;
        return o._handleMenuClick = o._handleMenuClick.bind(o), o._handleMenuItemClick = o._handleMenuItemClick.bind(o), o._handleSelect = o._handleSelect.bind(o), o.onOpenChange = o.onOpenChange.bind(o), o.setWrapperRef = o.setWrapperRef.bind(o), o.handleClickOutside = o.handleClickOutside.bind(o), o;
      }
      return r(e, n), e.prototype.componentDidMount = function () {
        document.addEventListener("mousedown", this.handleClickOutside);
      }, e.prototype.componentWillUnmount = function () {
        document.removeEventListener("mousedown", this.handleClickOutside);
      }, e.prototype.handleClickOutside = function (e) {
        this.wrapperRef && !this.wrapperRef.contains(e.target) && this.props.onLostFocus && this.props.onLostFocus();
      }, e.prototype.render = function () {
        var o = this,
          e = this.props,
          n = e.className,
          t = e.trigger,
          r = "left" === e.alignToParent ? d.alignLeft : d.alignRight;
        return b.createElement(i.ThemeContext.Consumer, null, function (e) {
          return b.createElement("div", c({}, p.getHtmlAttributes(o.props), {
            ref: o.setWrapperRef,
            className: m(d.root, d[e], r, n),
            onClick: o._handleMenuClick
          }), b.createElement(u.default, {
            onSelect: o._handleSelect,
            onClick: o._handleMenuItemClick,
            triggerSubMenuAction: t,
            multiple: !0,
            mode: "vertical",
            onOpenChange: o.onOpenChange,
            getPopupContainer: function getPopupContainer() {
              return o.wrapperRef;
            },
            expandIcon: b.createElement("span", {
              className: d.expandIcon
            }, b.createElement(C.Icon, {
              name: "abb/caret-right"
            }))
          }, o.walkChildren(d[e], o.props.children, "", 0)));
        });
      }, e.prototype.setWrapperRef = function (e) {
        this.wrapperRef = e;
      }, e.prototype.walkChildren = function (a, e, _, l) {
        var s = this;
        return b.Children.map(e, function (e, o) {
          var n,
            t,
            r = _ + "-" + o;
          if (e && e.type) {
            if (e.type.componentName === B.SubMenu.componentName) return s.walkSubMenu(a, e.props, r, l);
            if (e.type.componentName === h.MenuItem.componentName) {
              var i = m(d.menuItem, e.props.className, ((n = {})[d.disabled] = e.props.disabled, n), ((t = {})[d.selected] = e.props.selected, t), a);
              return b.createElement(u.MenuItem, c({}, p.getHtmlAttributes(e.props), {
                key: r,
                disabled: e.props.disabled,
                className: i,
                menuitemtext: e.props.text,
                menuitemid: e.props.itemId
              }), e.props.icon && b.createElement("span", {
                className: d.menuItemIcon
              }, b.createElement(C.Icon, {
                name: e.props.icon,
                sizeClass: "small"
              })), b.createElement("span", {
                className: d.menuItemTitle
              }, e.props.text));
            }
            if (e.type.componentName === A.MenuItemDivider.componentName) return b.createElement(u.Divider, {
              className: d.divider
            });
            throw new Error("Invalid child type. Expected one of [MenuItem, MenuItemDivider, SubMenu].");
          }
          throw new Error("Invalid child type. Expected one of [MenuItem, MenuItemDivider, SubMenu].");
        });
      }, e.prototype.walkSubMenu = function (e, o, n, t) {
        var r,
          i,
          a = b.createElement(b.Fragment, null, o.icon && b.createElement("span", {
            className: d.subMenuHeaderIcon
          }, b.createElement(C.Icon, {
            name: o.icon,
            sizeClass: "small"
          })), b.createElement("span", {
            className: d.subMenuHeaderTitle
          }, o.text)),
          _ = m(d.subMenuHeader, ((r = {})[d.disabled] = o.disabled, r), ((i = {})[d.selected] = o.selected, i), e);
        return b.createElement(u.SubMenu, c({}, p.getHtmlAttributes(o), {
          popupOffset: [-1, 0],
          className: _,
          title: a,
          disabled: o.disabled,
          popupClassName: m(d.subMenuPopup, e)
        }), this.walkChildren(e, o.children, n, t + 1));
      }, e.prototype.onOpenChange = function (e) {}, e.prototype._handleMenuClick = function (e) {
        e.nativeEvent.preventDefault(), e.nativeEvent.stopPropagation(), e.preventDefault(), e.stopPropagation(), this.props.onClick && this.props.onClick(e);
      }, e.prototype._handleMenuItemClick = function (e) {}, e.prototype._handleSelect = function (e) {
        this.props.onSelect && this.props.onSelect({
          text: e.item.props.menuitemtext,
          id: e.item.props.menuitemid
        });
      }, e.defaultProps = {
        trigger: "click",
        alignToParent: "left"
      }, e;
    }(b.Component);
  o.Menu = a, o.default = a;
}, function (e, o) {
  e.exports = require("rc-menu");
}, function (e, o, n) {
  e.exports = {
    root: "ABB_CommonUX_Menu__root",
    alignLeft: "ABB_CommonUX_Menu__alignLeft",
    alignRight: "ABB_CommonUX_Menu__alignRight",
    light: "ABB_CommonUX_Menu__light",
    dark: "ABB_CommonUX_Menu__dark",
    subMenuPopup: "ABB_CommonUX_Menu__subMenuPopup",
    subMenuHeader: "ABB_CommonUX_Menu__subMenuHeader",
    disabled: "ABB_CommonUX_Menu__disabled",
    subMenuHeaderIcon: "ABB_CommonUX_Menu__subMenuHeaderIcon",
    subMenuHeaderTitle: "ABB_CommonUX_Menu__subMenuHeaderTitle",
    expandIcon: "ABB_CommonUX_Menu__expandIcon",
    menuItem: "ABB_CommonUX_Menu__menuItem",
    selected: "ABB_CommonUX_Menu__selected",
    menuItemIcon: "ABB_CommonUX_Menu__menuItemIcon",
    menuItemTitle: "ABB_CommonUX_Menu__menuItemTitle",
    divider: "ABB_CommonUX_Menu__divider"
  };
}, function (e, n, o) {
  "use strict";

  function t(e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), t(o(145)), t(o(65));
}, function (e, o, n) {
  "use strict";

  var _t55,
    r = this && this.__extends || (_t55 = function t(e, o) {
      return (_t55 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t55(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    });
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var s = n(0),
    c = n(1),
    b = n(25),
    m = n(3),
    p = n(65),
    u = n(20),
    i = function (n) {
      function e(e) {
        var o = n.call(this, e) || this;
        return o.state = {
          showDialog: !1
        }, o.content = null, o.dialogCloseHandler = null, o.autoCloseTimer = void 0, o._onBeforeOpen = o._onBeforeOpen.bind(o), o._onOpen = o._onOpen.bind(o), o.closeDialog = o.closeDialog.bind(o), o._handleOpenDialog = o._handleOpenDialog.bind(o), o._handleCloseDialog = o._handleCloseDialog.bind(o), o._onEscOrLostFocus = o._onEscOrLostFocus.bind(o), o._cleanResources = o._cleanResources.bind(o), o;
      }
      return r(e, n), e.prototype.registerCloseHandler = function (e) {
        this.dialogCloseHandler = e;
      }, e.prototype.closeDialog = function () {
        this.setState({
          showDialog: !1
        });
      }, e.prototype.componentWillUnmount = function () {
        this._cleanResources();
      }, e.prototype.render = function () {
        var e,
          o = this,
          n = s.Children.toArray(this.props.children);
        if (2 !== n.length || !n[1].type || n[1].type.componentName !== p.MessageDialog.componentName) throw new Error("Invalid MessageDialog construction. Expected: <WithMessageDialog><any-single-element/><MessageDialog /></WithMessageDialog>");
        this.content = s.cloneElement(n[1], {
          closeDialog: this.closeDialog,
          cleaner: this._cleanResources,
          parent: this
        });
        var t = -1 < ["yesno"].indexOf(this.content.props.buttons.toLowerCase()),
          r = !t,
          i = !t,
          a = this.content.props.trigger,
          _ = s.cloneElement(n[0], ((e = {})["hover" === a ? "onMouseEnter" : "onClick"] = this._handleOpenDialog, e)),
          l = [u.overlay];
        return l.push(u.halfOpacityBackdrop), s.createElement(m.ThemeContext.Consumer, null, function (e) {
          return s.createElement(s.Fragment, null, _, s.createElement(b, {
            isOpen: o.state.showDialog,
            ariaHideApp: !1,
            className: c(u.dialog, u[e]),
            overlayClassName: c(l, u[e]),
            onRequestClose: o._onEscOrLostFocus,
            shouldCloseOnOverlayClick: i,
            shouldCloseOnEsc: r,
            onAfterOpen: o._onOpen
          }, o.content));
        });
      }, e.prototype._onBeforeOpen = function (e) {
        !this.content.props.onBeforeOpen || this.content.props.onBeforeOpen();
      }, e.prototype._handleOpenDialog = function () {
        this.setState({
          showDialog: !0
        });
      }, e.prototype._onEscOrLostFocus = function () {
        this._handleCloseDialog();
      }, e.prototype._handleCloseDialog = function (e) {
        this.dialogCloseHandler && this.dialogCloseHandler();
      }, e.prototype._onOpen = function () {
        var e = this;
        this.content.props.onOpen && this.content.props.onOpen(), 0 < this.content.props.closeAfter && (this.autoCloseTimer = setTimeout(function () {
          e.autoCloseTimer = void 0, e._handleCloseDialog();
        }, this.content.props.closeAfter));
      }, e.prototype._cleanResources = function () {
        this.autoCloseTimer && (clearTimeout(this.autoCloseTimer), this.autoCloseTimer = void 0);
      }, e;
    }(s.Component);
  o.WithMessageDialog = i, o.default = i;
}, function (e, o, n) {
  e.exports = {
    messageDialogDimensions: "ABB_CommonUX_MessageDialog__messageDialogDimensions",
    messageDialogRoot: "ABB_CommonUX_MessageDialog__messageDialogRoot",
    icon: "ABB_CommonUX_MessageDialog__icon",
    message: "ABB_CommonUX_MessageDialog__message",
    buttons: "ABB_CommonUX_MessageDialog__buttons",
    messageDialogButton: "ABB_CommonUX_MessageDialog__messageDialogButton",
    light: "ABB_CommonUX_MessageDialog__light",
    dark: "ABB_CommonUX_MessageDialog__dark"
  };
}, function (e, n, o) {
  "use strict";

  function t(e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), t(o(148)), t(o(66));
}, function (e, o, n) {
  "use strict";

  var _t56,
    r = this && this.__extends || (_t56 = function t(e, o) {
      return (_t56 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t56(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    a = this && this.__assign || function () {
      return (a = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var _ = n(0),
    l = n(1),
    s = n(3),
    c = n(2),
    b = n(66),
    m = n(150),
    i = function (o) {
      function e(e) {
        return o.call(this, e) || this;
      }
      return r(e, o), e.prototype.render = function () {
        var o = this,
          e = this.props,
          n = e.className,
          t = e.notifications,
          r = e.actionHandler,
          i = t.map(function (e) {
            return _.createElement(b.Notification, {
              key: e.id,
              data: e,
              removalHandler: r,
              className: e.className,
              style: e.style
            });
          });
        return _.createElement(s.ThemeContext.Consumer, null, function (e) {
          return _.createElement("div", a({}, c.getHtmlAttributes(o.props), {
            className: l(m.root, m[e], n)
          }), i);
        });
      }, e.defaultProps = {
        notifications: []
      }, e;
    }(_.Component);
  o.NotificationContainer = i, o.default = i;
}, function (e, o, n) {
  e.exports = {
    root: "ABB_CommonUX_Notification__root",
    closing: "ABB_CommonUX_Notification__closing",
    banner: "ABB_CommonUX_Notification__banner",
    iconContainer: "ABB_CommonUX_Notification__iconContainer",
    text: "ABB_CommonUX_Notification__text",
    controls: "ABB_CommonUX_Notification__controls",
    success: "ABB_CommonUX_Notification__success",
    info: "ABB_CommonUX_Notification__info",
    warn: "ABB_CommonUX_Notification__warn",
    alarm: "ABB_CommonUX_Notification__alarm",
    discreet: "ABB_CommonUX_Notification__discreet",
    confirmation: "ABB_CommonUX_Notification__confirmation",
    buttons: "ABB_CommonUX_Notification__buttons",
    light: "ABB_CommonUX_Notification__light",
    dark: "ABB_CommonUX_Notification__dark"
  };
}, function (e, o, n) {
  e.exports = {
    root: "ABB_CommonUX_NotificationContainer__root",
    light: "ABB_CommonUX_NotificationContainer__light",
    dark: "ABB_CommonUX_NotificationContainer__dark"
  };
}, function (e, n, o) {
  "use strict";

  function t(e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), t(o(49)), t(o(29));
}, function (e, n, o) {
  "use strict";

  function t(e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), t(o(153)), t(o(154));
}, function (e, o, n) {
  "use strict";

  var _t57,
    r = this && this.__extends || (_t57 = function t(e, o) {
      return (_t57 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t57(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    l = this && this.__assign || function () {
      return (l = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var s = n(0),
    c = n(1),
    b = n(3),
    m = n(2),
    p = n(69),
    i = function (n) {
      function t(e) {
        var o = n.call(this, e) || this;
        return o.groupName = "radio-" + t.GROUP_COUNTER++, o.handleChange = o.handleChange.bind(o), o;
      }
      return r(t, n), t.prototype.render = function () {
        var t = this,
          e = this.props,
          n = e.className,
          r = e.value,
          i = e.sizeClass,
          a = e.orientation,
          _ = s.Children.map(this.props.children, function (e, o) {
            var n = {
              _from_parent_: {
                groupName: t.groupName,
                onChange: t.handleChange,
                checked: e && e.props && void 0 !== e.props.value && r === e.props.value
              }
            };
            return s.cloneElement(e, n);
          });
        return s.createElement(b.ThemeContext.Consumer, null, function (e) {
          var o;
          return s.createElement("div", l({}, m.getHtmlAttributes(t.props), {
            role: "radiogroup",
            className: c(p.root, p[e], p[i + "Size"], (o = {}, o[p.horizontal] = "horizontal" === a, o), n)
          }), _);
        });
      }, t.prototype.handleChange = function (e) {
        this.props.onChange && this.props.onChange(e);
      }, t.defaultProps = {
        sizeClass: "small",
        orientation: "vertical"
      }, t.GROUP_COUNTER = 1, t;
    }(s.Component);
  o.RadioGroup = i, o.default = i;
}, function (e, o, n) {
  "use strict";

  var _t58,
    r = this && this.__extends || (_t58 = function t(e, o) {
      return (_t58 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t58(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    });
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var l = n(0),
    s = n(1),
    c = n(69),
    i = function (n) {
      function e(e) {
        var o = n.call(this, e) || this;
        return o._handleClick = o._handleClick.bind(o), o._handleChange = o._handleChange.bind(o), o;
      }
      return r(e, n), e.prototype.render = function () {
        var e,
          o = this.props,
          n = o.text,
          t = o.value,
          r = o.disabled,
          i = this.props._from_parent_,
          a = i.groupName,
          _ = i.checked;
        return l.createElement("label", {
          onClick: this._handleClick,
          className: s((e = {}, e[c.disabled] = r, e))
        }, l.createElement("input", {
          role: "radio",
          "aria-checked": _,
          tabIndex: _ ? 0 : -1,
          type: "radio",
          value: t,
          checked: _,
          name: a,
          disabled: r,
          onChange: this._handleChange
        }), l.createElement("span", null), l.createElement("span", null, n));
      }, e.prototype._handleChange = function (e) {
        this.props._from_parent_.onChange && !this.props.disabled && this.props._from_parent_.onChange(this.props.value);
      }, e.prototype._handleClick = function (e) {
        e.stopPropagation();
      }, e.defaultProps = {
        _from_parent_: {},
        text: "",
        disabled: !1
      }, e;
    }(l.Component);
  o.RadioOption = i, o.default = i;
}, function (e, n, o) {
  "use strict";

  function t(e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), t(o(156)), t(o(158));
}, function (e, o, n) {
  "use strict";

  var _t59,
    r = this && this.__extends || (_t59 = function t(e, o) {
      return (_t59 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t59(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    i = this && this.__assign || function () {
      return (i = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var a = n(0),
    _ = n(1),
    l = n(3),
    s = n(2),
    c = n(157),
    b = n(6),
    m = function (n) {
      function e(e) {
        var o = n.call(this, e) || this;
        return b.showExperimentalWarning("SidebarNavi"), o;
      }
      return r(e, n), e.prototype.render = function () {
        var o = this,
          n = this.props.className;
        return a.createElement(l.ThemeContext.Consumer, null, function (e) {
          return a.createElement("div", i({}, s.getHtmlAttributes(o.props), {
            className: _(c.root, c[e], n)
          }), o.props.children);
        });
      }, e;
    }(a.Component);
  o.SidebarNavi = m, o.default = m;
}, function (e, o, n) {
  e.exports = {
    root: "ABB_CommonUX_SidebarNavi__root",
    light: "ABB_CommonUX_SidebarNavi__light",
    dark: "ABB_CommonUX_SidebarNavi__dark"
  };
}, function (e, o, n) {
  "use strict";

  var _t60,
    r = this && this.__extends || (_t60 = function t(e, o) {
      return (_t60 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t60(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    s = this && this.__assign || function () {
      return (s = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var c = n(0),
    b = n(1),
    m = n(3),
    p = n(2),
    u = n(159),
    i = n(6),
    a = function (n) {
      function e(e) {
        var o = n.call(this, e) || this;
        return i.showExperimentalWarning("SidebarNaviTile"), o._handleClick = o._handleClick.bind(o), o;
      }
      return r(e, n), e.prototype.render = function () {
        var t = this,
          e = this.props,
          r = e.className,
          i = e.title,
          a = e.mode,
          _ = e.active,
          l = e.secondary;
        return c.createElement(m.ThemeContext.Consumer, null, function (e) {
          var o, n;
          return c.createElement("div", s({}, p.getHtmlAttributes(t.props), {
            className: b(u.root, u[e], u[a], r, (o = {}, o[u.active] = _, o), (n = {}, n[u.secondary] = l, n)),
            onClick: t._handleClick
          }), c.createElement("div", null, t.props.children), i && "thumbs" !== a && c.createElement("p", null, i));
        });
      }, e.prototype._handleClick = function (e) {
        e.preventDefault(), this.props.onClick && this.props.onClick(e);
      }, e.defaultProps = {
        active: !1,
        mode: "pictograms",
        secondary: !1
      }, e;
    }(c.Component);
  o.SidebarNaviTile = a, o.default = a;
}, function (e, o, n) {
  e.exports = {
    root: "ABB_CommonUX_SidebarNaviTile__root",
    thumbs: "ABB_CommonUX_SidebarNaviTile__thumbs",
    pictograms: "ABB_CommonUX_SidebarNaviTile__pictograms",
    light: "ABB_CommonUX_SidebarNaviTile__light",
    secondary: "ABB_CommonUX_SidebarNaviTile__secondary",
    active: "ABB_CommonUX_SidebarNaviTile__active",
    dark: "ABB_CommonUX_SidebarNaviTile__dark"
  };
}, function (e, n, o) {
  "use strict";

  Object.defineProperty(n, "__esModule", {
    value: !0
  }), function (e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }(o(161));
}, function (e, o, n) {
  "use strict";

  var _t61,
    r = this && this.__extends || (_t61 = function t(e, o) {
      return (_t61 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t61(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    c = this && this.__assign || function () {
      return (c = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var b = n(0),
    m = n(1),
    p = n(3),
    u = n(2),
    d = n(162),
    i = function (o) {
      function e(e) {
        return o.call(this, e) || this;
      }
      return r(e, o), e.prototype.render = function () {
        var r = this,
          e = this.props,
          i = e.className,
          a = e.sizeClass,
          _ = e.zebra,
          l = e.showVerticalGridlines,
          s = e.showHorizontalGridlines;
        return b.createElement(p.ThemeContext.Consumer, null, function (e) {
          var o, n, t;
          return b.createElement("table", c({}, u.getHtmlAttributes(r.props), {
            className: m(d.root, d[e], d[a], (o = {}, o[d.zebra] = _, o), (n = {}, n[d.verticalGridlines] = l, n), (t = {}, t[d.horizontalGridlines] = s, t), i)
          }), r.props.children);
        });
      }, e.defaultProps = {
        sizeClass: "small",
        zebra: !1,
        showVerticalGridlines: !1,
        showHorizontalGridlines: !0
      }, e.classes = {
        activeHeader: d.activeHeader,
        selectedRow: d.selectedRow
      }, e;
    }(b.Component);
  o.SimpleTable = i, o.default = i;
}, function (e, o, n) {
  e.exports = {
    root: "ABB_CommonUX_SimpleTable__root",
    activeHeader: "ABB_CommonUX_SimpleTable__activeHeader",
    verticalGridlines: "ABB_CommonUX_SimpleTable__verticalGridlines",
    horizontalGridlines: "ABB_CommonUX_SimpleTable__horizontalGridlines",
    small: "ABB_CommonUX_SimpleTable__small",
    medium: "ABB_CommonUX_SimpleTable__medium",
    large: "ABB_CommonUX_SimpleTable__large",
    light: "ABB_CommonUX_SimpleTable__light",
    selectedRow: "ABB_CommonUX_SimpleTable__selectedRow",
    zebra: "ABB_CommonUX_SimpleTable__zebra",
    dark: "ABB_CommonUX_SimpleTable__dark"
  };
}, function (e, n, o) {
  "use strict";

  Object.defineProperty(n, "__esModule", {
    value: !0
  }), function (e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }(o(164));
}, function (e, o, n) {
  "use strict";

  var _t62,
    r = this && this.__extends || (_t62 = function t(e, o) {
      return (_t62 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t62(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    w = this && this.__assign || function () {
      return (w = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    },
    h = this && this.__rest || function (e, o) {
      var n = {};
      for (var t in e) Object.prototype.hasOwnProperty.call(e, t) && o.indexOf(t) < 0 && (n[t] = e[t]);
      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var r = 0;
        for (t = Object.getOwnPropertySymbols(e); r < t.length; r++) o.indexOf(t[r]) < 0 && (n[t[r]] = e[t[r]]);
      }
      return n;
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var O = n(0),
    k = n(1),
    x = n(3),
    E = n(2),
    P = n(70),
    S = n(70),
    B = n(165),
    i = n(5).getVariables(),
    A = P.default.Handle;
  n(166);
  var N = n(171),
    T = function T(e, o, n, t, r, i) {
      var a = e.value,
        _ = e.dragging,
        l = e.index,
        s = h(e, ["value", "dragging", "index"]),
        c = e.index,
        b = !1;
      i.ref.current && "double" !== i.props.type && (b = document.activeElement === i.ref.current.children[1].children[3 + c]);
      var m,
        p,
        u,
        d = !!i.ref.current && ("always" === i.props.showTooltip || "active" === i.props.showTooltip && (o[c] || b || _));
      return O.createElement(B.default, {
        prefixCls: "rc-slider-tooltip",
        overlay: (m = a, p = t, u = r, p instanceof Array ? p.map(function (e) {
          return e.toFixed(u);
        }).join(" — ") : m.toFixed(u)),
        placement: "top",
        key: l,
        visible: d,
        getTooltipContainer: function getTooltipContainer() {
          return i.ref.current;
        }
      }, O.createElement(A, w({
        value: a
      }, s, {
        onMouseEnter: function onMouseEnter(e) {
          return i.setHover(c, !0);
        },
        onMouseLeave: function onMouseLeave(e) {
          return i.setHover(c, !1);
        },
        className: k(N.rcSliderHandle, "rc-slider-handle", "rc-slider-handle-" + (l + 1))
      })));
    };
  var M = {
      light: {
        railBackground: i["color-grey-20"],
        highlightColor: i["color-accent-light"],
        highlightColorWhenDisabled: i["color-grey-40"],
        trackColor: i["color-grey-20"]
      },
      dark: {
        railBackground: i["color-grey-80"],
        highlightColor: i["color-accent-dark"],
        highlightColorWhenDisabled: i["color-grey-80"],
        trackColor: i["color-grey-70"]
      }
    },
    a = function (n) {
      function e(e) {
        var o = n.call(this, e) || this;
        return o.state = {
          hovering: [!1, !1],
          focused: [!1, !1]
        }, o.onChange = o.onChange.bind(o), o.onAfterChange = o.onAfterChange.bind(o), o.onBeforeChange = o.onBeforeChange.bind(o), o.handleKeyboard = o.handleKeyboard.bind(o), o.ref = O.createRef(), o;
      }
      return r(e, n), e.prototype.setHover = function (e, o) {
        var n = this.state.hovering.slice();
        n[e] = o, this.setState({
          hovering: n
        });
      }, e.prototype.setFocus = function (e, o, n) {
        var t = this.state.focused.slice();
        t[e] = o, this.setState({
          focused: t
        });
      }, e.prototype.componentDidMount = function () {
        this.setState({}), this.ref.current.addEventListener("keydown", this.handleKeyboard, !0);
      }, e.prototype.render = function () {
        var n = this,
          e = this.props,
          t = e.className,
          o = e.type,
          r = e.min,
          i = e.minLabel,
          a = e.max,
          _ = e.maxLabel,
          l = e.step,
          s = e.ticks,
          c = e.highlight,
          b = e.label,
          m = e.value,
          p = e.values,
          u = e.disabled,
          d = this.state.hovering,
          h = (this.state.focused, "double" === o);
        if (!h && void 0 !== p || h && void 0 !== m) throw new Error('Invalid value(s) props for Slider: use "value" and "values" for single and double, respectively');
        var B = function (e) {
            if (!isFinite(e)) return 0;
            for (var o = 1, n = 0; Math.round(e * o) / o !== e;) o *= 10, n++;
            return n;
          }(l),
          A = M[this.context].railBackground,
          C = M[this.context].highlightColor,
          f = {
            railStyle: {
              backgroundColor: M[this.context].railBackground
            },
            dotStyle: {
              position: "absolute",
              bottom: "-2px",
              marginLeft: "-4px",
              width: "8px",
              height: "8px",
              border: "2px solid #e9e9e9",
              backgroundColor: "high" !== c ? A : C,
              borderColor: "high" !== c ? A : C,
              cursor: "pointer",
              borderRadius: "50%",
              verticalAlign: "middle"
            },
            activeDotStyle: {
              position: "absolute",
              bottom: "-2px",
              marginLeft: "-4px",
              width: "8px",
              height: "8px",
              border: "2px solid #e9e9e9",
              backgroundColor: "none" === c || "high" === c ? A : C,
              borderColor: "none" === c || "high" === c ? A : C,
              cursor: "pointer",
              borderRadius: "50%",
              verticalAlign: "middle"
            }
          },
          y = u ? M[this.context].highlightColorWhenDisabled : M[this.context].highlightColor;
        "none" === c ? f.trackStyle = h ? [{
          background: "transparent",
          backgroundColor: "transparent"
        }, {
          background: "transparent",
          backgroundColor: "transparent"
        }] : {
          background: "transparent",
          backgroundColor: "transparent"
        } : h || "low" !== c ? h || "high" !== c ? h && "middle" === c && (f.trackStyle = [{
          background: y
        }, {
          background: "transparent",
          backgroundColor: "transparent"
        }]) : (f.trackStyle = {
          background: M[this.context].trackStyle
        }, f.railStyle = {
          backgroundColor: y
        }) : f.trackStyle = {
          background: y
        };
        var g = function g(e) {
            return T(e, d, 0, h ? p : m, B, n);
          },
          v = {};
        if ("number" == typeof s) for (var U = 0; U < s; U++) v[(a - r) / (s + 1) * (U + 1)] = "";else Array.isArray(s) && s.forEach(function (e) {
          return v[e.value] = e.text || "";
        });
        var X = {
          min: r,
          max: a,
          step: l,
          disabled: u,
          dots: !1,
          marks: v,
          onChange: this.onChange,
          onAfterChange: this.onAfterChange,
          onBeforeChange: this.onBeforeChange,
          className: N.rcSliderRoot,
          allowCross: !1
        };
        return O.createElement(x.ThemeContext.Consumer, null, function (e) {
          var o;
          return O.createElement("div", w({}, E.getHtmlAttributes(n.props), {
            className: k(N.root, t, N[e], (o = {}, o[N.disabled] = u, o[N.double] = h, o)),
            ref: n.ref
          }), O.createElement("div", null, O.createElement("span", null, b)), !h && O.createElement(P.default, w({}, f, X, {
            handle: g,
            value: m
          })), h && !m && O.createElement(S.Range, w({}, f, X, {
            handle: g,
            value: p
          })), O.createElement("div", {
            className: N.minMaxValues
          }, O.createElement("span", null, void 0 !== i ? i : r), O.createElement("span", null, void 0 !== _ ? _ : a)));
        });
      }, e.prototype.handleKeyboard = function (e) {
        "double" === this.props.type && (e.stopPropagation(), e.preventDefault());
      }, e.prototype.onAfterChange = function (e) {
        "double" === this.props.type && document.activeElement && document.activeElement.blur();
      }, e.prototype.onBeforeChange = function (e) {}, e.prototype.onChange = function (e) {
        this.props.onChange && this.props.onChange(e);
      }, e.defaultProps = {
        label: "",
        type: "single",
        showTooltip: "active",
        highlight: "none",
        step: 1
      }, e.contextType = x.ThemeContext, e;
    }(O.Component);
  o.Slider = a, o.default = a;
}, function (e, o) {
  e.exports = require("rc-tooltip");
}, function (e, o, n) {
  var t = n(167);
  "string" == typeof t && (t = [[e.i, t, ""]]);
  var r = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  n(169)(t, r);
  t.locals && (e.exports = t.locals);
}, function (e, o, n) {
  (e.exports = n(168)(!1)).push([e.i, ".rc-slider {\r\n  position: relative;\r\n  height: 14px;\r\n  padding: 5px 0;\r\n  width: 100%;\r\n  border-radius: 6px;\r\n  -ms-touch-action: none;\r\n      touch-action: none;\r\n  box-sizing: border-box;\r\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\r\n}\r\n.rc-slider * {\r\n  box-sizing: border-box;\r\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\r\n}\r\n.rc-slider-rail {\r\n  position: absolute;\r\n  width: 100%;\r\n  background-color: #e9e9e9;\r\n  height: 4px;\r\n  border-radius: 6px;\r\n}\r\n.rc-slider-track {\r\n  position: absolute;\r\n  left: 0;\r\n  height: 4px;\r\n  border-radius: 6px;\r\n  background-color: #abe2fb;\r\n}\r\n.rc-slider-handle {\r\n  position: absolute;\r\n  margin-left: -7px;\r\n  margin-top: -5px;\r\n  width: 14px;\r\n  height: 14px;\r\n  cursor: pointer;\r\n  cursor: -webkit-grab;\r\n  cursor: grab;\r\n  border-radius: 50%;\r\n  border: solid 2px #96dbfa;\r\n  background-color: #fff;\r\n  -ms-touch-action: pan-x;\r\n      touch-action: pan-x;\r\n}\r\n.rc-slider-handle:focus {\r\n  border-color: #57c5f7;\r\n  box-shadow: 0 0 0 5px #96dbfa;\r\n  outline: none;\r\n}\r\n.rc-slider-handle-click-focused:focus {\r\n  border-color: #96dbfa;\r\n  box-shadow: unset;\r\n}\r\n.rc-slider-handle:hover {\r\n  border-color: #57c5f7;\r\n}\r\n.rc-slider-handle:active {\r\n  border-color: #57c5f7;\r\n  box-shadow: 0 0 5px #57c5f7;\r\n  cursor: -webkit-grabbing;\r\n  cursor: grabbing;\r\n}\r\n.rc-slider-mark {\r\n  position: absolute;\r\n  top: 18px;\r\n  left: 0;\r\n  width: 100%;\r\n  font-size: 12px;\r\n}\r\n.rc-slider-mark-text {\r\n  position: absolute;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  text-align: center;\r\n  cursor: pointer;\r\n  color: #999;\r\n}\r\n.rc-slider-mark-text-active {\r\n  color: #666;\r\n}\r\n.rc-slider-step {\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 4px;\r\n  background: transparent;\r\n}\r\n.rc-slider-dot {\r\n  position: absolute;\r\n  bottom: -2px;\r\n  margin-left: -4px;\r\n  width: 8px;\r\n  height: 8px;\r\n  border: 2px solid #e9e9e9;\r\n  background-color: #fff;\r\n  cursor: pointer;\r\n  border-radius: 50%;\r\n  vertical-align: middle;\r\n}\r\n.rc-slider-dot-active {\r\n  border-color: #96dbfa;\r\n}\r\n.rc-slider-disabled {\r\n  background-color: #e9e9e9;\r\n}\r\n.rc-slider-disabled .rc-slider-track {\r\n  background-color: #ccc;\r\n}\r\n.rc-slider-disabled .rc-slider-handle,\r\n.rc-slider-disabled .rc-slider-dot {\r\n  border-color: #ccc;\r\n  box-shadow: none;\r\n  background-color: #fff;\r\n  cursor: not-allowed;\r\n}\r\n.rc-slider-disabled .rc-slider-mark-text,\r\n.rc-slider-disabled .rc-slider-dot {\r\n  cursor: not-allowed !important;\r\n}\r\n.rc-slider-vertical {\r\n  width: 14px;\r\n  height: 100%;\r\n  padding: 0 5px;\r\n}\r\n.rc-slider-vertical .rc-slider-rail {\r\n  height: 100%;\r\n  width: 4px;\r\n}\r\n.rc-slider-vertical .rc-slider-track {\r\n  left: 5px;\r\n  bottom: 0;\r\n  width: 4px;\r\n}\r\n.rc-slider-vertical .rc-slider-handle {\r\n  margin-left: -5px;\r\n  margin-bottom: -7px;\r\n  -ms-touch-action: pan-y;\r\n      touch-action: pan-y;\r\n}\r\n.rc-slider-vertical .rc-slider-mark {\r\n  top: 0;\r\n  left: 18px;\r\n  height: 100%;\r\n}\r\n.rc-slider-vertical .rc-slider-step {\r\n  height: 100%;\r\n  width: 4px;\r\n}\r\n.rc-slider-vertical .rc-slider-dot {\r\n  left: 2px;\r\n  margin-bottom: -4px;\r\n}\r\n.rc-slider-vertical .rc-slider-dot:first-child {\r\n  margin-bottom: -4px;\r\n}\r\n.rc-slider-vertical .rc-slider-dot:last-child {\r\n  margin-bottom: -4px;\r\n}\r\n.rc-slider-tooltip-zoom-down-enter,\r\n.rc-slider-tooltip-zoom-down-appear {\r\n  animation-duration: .3s;\r\n  animation-fill-mode: both;\r\n  display: block !important;\r\n  animation-play-state: paused;\r\n}\r\n.rc-slider-tooltip-zoom-down-leave {\r\n  animation-duration: .3s;\r\n  animation-fill-mode: both;\r\n  display: block !important;\r\n  animation-play-state: paused;\r\n}\r\n.rc-slider-tooltip-zoom-down-enter.rc-slider-tooltip-zoom-down-enter-active,\r\n.rc-slider-tooltip-zoom-down-appear.rc-slider-tooltip-zoom-down-appear-active {\r\n  animation-name: rcSliderTooltipZoomDownIn;\r\n  animation-play-state: running;\r\n}\r\n.rc-slider-tooltip-zoom-down-leave.rc-slider-tooltip-zoom-down-leave-active {\r\n  animation-name: rcSliderTooltipZoomDownOut;\r\n  animation-play-state: running;\r\n}\r\n.rc-slider-tooltip-zoom-down-enter,\r\n.rc-slider-tooltip-zoom-down-appear {\r\n  transform: scale(0, 0);\r\n  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\r\n}\r\n.rc-slider-tooltip-zoom-down-leave {\r\n  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\r\n}\r\n@keyframes rcSliderTooltipZoomDownIn {\r\n  0% {\r\n    opacity: 0;\r\n    transform-origin: 50% 100%;\r\n    transform: scale(0, 0);\r\n  }\r\n  100% {\r\n    transform-origin: 50% 100%;\r\n    transform: scale(1, 1);\r\n  }\r\n}\r\n@keyframes rcSliderTooltipZoomDownOut {\r\n  0% {\r\n    transform-origin: 50% 100%;\r\n    transform: scale(1, 1);\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n    transform-origin: 50% 100%;\r\n    transform: scale(0, 0);\r\n  }\r\n}\r\n.rc-slider-tooltip {\r\n  position: absolute;\r\n  left: -9999px;\r\n  top: -9999px;\r\n  visibility: visible;\r\n  box-sizing: border-box;\r\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\r\n}\r\n.rc-slider-tooltip * {\r\n  box-sizing: border-box;\r\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\r\n}\r\n.rc-slider-tooltip-hidden {\r\n  display: none;\r\n}\r\n.rc-slider-tooltip-placement-top {\r\n  padding: 4px 0 8px 0;\r\n}\r\n.rc-slider-tooltip-inner {\r\n  padding: 6px 2px;\r\n  min-width: 24px;\r\n  height: 24px;\r\n  font-size: 12px;\r\n  line-height: 1;\r\n  color: #fff;\r\n  text-align: center;\r\n  text-decoration: none;\r\n  background-color: #6c6c6c;\r\n  border-radius: 6px;\r\n  box-shadow: 0 0 4px #d9d9d9;\r\n}\r\n.rc-slider-tooltip-arrow {\r\n  position: absolute;\r\n  width: 0;\r\n  height: 0;\r\n  border-color: transparent;\r\n  border-style: solid;\r\n}\r\n.rc-slider-tooltip-placement-top .rc-slider-tooltip-arrow {\r\n  bottom: 4px;\r\n  left: 50%;\r\n  margin-left: -4px;\r\n  border-width: 4px 4px 0;\r\n  border-top-color: #6c6c6c;\r\n}\r\n", ""]);
}, function (e, o, n) {
  "use strict";

  e.exports = function (n) {
    var a = [];
    return a.toString = function () {
      return this.map(function (e) {
        var o = function (e, o) {
          var n = e[1] || "",
            t = e[3];
          if (!t) return n;
          if (o && "function" == typeof btoa) {
            var r = (a = t, "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(a)))) + " */"),
              i = t.sources.map(function (e) {
                return "/*# sourceURL=" + t.sourceRoot + e + " */";
              });
            return [n].concat(i).concat([r]).join("\n");
          }
          var a;
          return [n].join("\n");
        }(e, n);
        return e[2] ? "@media " + e[2] + "{" + o + "}" : o;
      }).join("");
    }, a.i = function (e, o) {
      "string" == typeof e && (e = [[null, e, ""]]);
      for (var n = {}, t = 0; t < this.length; t++) {
        var r = this[t][0];
        null != r && (n[r] = !0);
      }
      for (t = 0; t < e.length; t++) {
        var i = e[t];
        null != i[0] && n[i[0]] || (o && !i[2] ? i[2] = o : o && (i[2] = "(" + i[2] + ") and (" + o + ")"), a.push(i));
      }
    }, a;
  };
}, function (e, o, t) {
  var n,
    r,
    i,
    l = {},
    s = (n = function n() {
      return window && document && document.all && !window.atob;
    }, function () {
      return void 0 === r && (r = n.apply(this, arguments)), r;
    }),
    a = (i = {}, function (e, o) {
      if ("function" == typeof e) return e();
      if (void 0 === i[e]) {
        var n = function (e, o) {
          return o ? o.querySelector(e) : document.querySelector(e);
        }.call(this, e, o);
        if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
          n = n.contentDocument.head;
        } catch (e) {
          n = null;
        }
        i[e] = n;
      }
      return i[e];
    }),
    c = null,
    b = 0,
    _ = [],
    m = t(170);
  function p(e, o) {
    for (var n = 0; n < e.length; n++) {
      var t = e[n],
        r = l[t.id];
      if (r) {
        r.refs++;
        for (var i = 0; i < r.parts.length; i++) r.parts[i](t.parts[i]);
        for (; i < t.parts.length; i++) r.parts.push(C(t.parts[i], o));
      } else {
        var a = [];
        for (i = 0; i < t.parts.length; i++) a.push(C(t.parts[i], o));
        l[t.id] = {
          id: t.id,
          refs: 1,
          parts: a
        };
      }
    }
  }
  function u(e, o) {
    for (var n = [], t = {}, r = 0; r < e.length; r++) {
      var i = e[r],
        a = o.base ? i[0] + o.base : i[0],
        _ = {
          css: i[1],
          media: i[2],
          sourceMap: i[3]
        };
      t[a] ? t[a].parts.push(_) : n.push(t[a] = {
        id: a,
        parts: [_]
      });
    }
    return n;
  }
  function d(e, o) {
    var n = a(e.insertInto);
    if (!n) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
    var t = _[_.length - 1];
    if ("top" === e.insertAt) t ? t.nextSibling ? n.insertBefore(o, t.nextSibling) : n.appendChild(o) : n.insertBefore(o, n.firstChild), _.push(o);else if ("bottom" === e.insertAt) n.appendChild(o);else {
      if ("object" != typeof e.insertAt || !e.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
      var r = a(e.insertAt.before, n);
      n.insertBefore(o, r);
    }
  }
  function h(e) {
    if (null === e.parentNode) return !1;
    e.parentNode.removeChild(e);
    var o = _.indexOf(e);
    0 <= o && _.splice(o, 1);
  }
  function B(e) {
    var o = document.createElement("style");
    if (void 0 === e.attrs.type && (e.attrs.type = "text/css"), void 0 === e.attrs.nonce) {
      var n = function () {
        0;
        return t.nc;
      }();
      n && (e.attrs.nonce = n);
    }
    return A(o, e.attrs), d(e, o), o;
  }
  function A(o, n) {
    Object.keys(n).forEach(function (e) {
      o.setAttribute(e, n[e]);
    });
  }
  function C(o, e) {
    var n, t, r, i, a, _;
    if (e.transform && o.css) {
      if (!(i = "function" == typeof e.transform ? e.transform(o.css) : e.transform.default(o.css))) return function () {};
      o.css = i;
    }
    if (e.singleton) {
      var l = b++;
      n = c || (c = B(e)), t = g.bind(null, n, l, !1), r = g.bind(null, n, l, !0);
    } else r = o.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (a = e, _ = document.createElement("link"), void 0 === a.attrs.type && (a.attrs.type = "text/css"), a.attrs.rel = "stylesheet", A(_, a.attrs), d(a, _), t = function (e, o, n) {
      var t = n.css,
        r = n.sourceMap,
        i = void 0 === o.convertToAbsoluteUrls && r;
      (o.convertToAbsoluteUrls || i) && (t = m(t));
      r && (t += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(r)))) + " */");
      var a = new Blob([t], {
          type: "text/css"
        }),
        _ = e.href;
      e.href = URL.createObjectURL(a), _ && URL.revokeObjectURL(_);
    }.bind(null, n = _, e), function () {
      h(n), n.href && URL.revokeObjectURL(n.href);
    }) : (n = B(e), t = function (e, o) {
      var n = o.css,
        t = o.media;
      t && e.setAttribute("media", t);
      if (e.styleSheet) e.styleSheet.cssText = n;else {
        for (; e.firstChild;) e.removeChild(e.firstChild);
        e.appendChild(document.createTextNode(n));
      }
    }.bind(null, n), function () {
      h(n);
    });
    return t(o), function (e) {
      if (e) {
        if (e.css === o.css && e.media === o.media && e.sourceMap === o.sourceMap) return;
        t(o = e);
      } else r();
    };
  }
  e.exports = function (e, a) {
    if ("undefined" != typeof DEBUG && DEBUG && "object" != typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
    (a = a || {}).attrs = "object" == typeof a.attrs ? a.attrs : {}, a.singleton || "boolean" == typeof a.singleton || (a.singleton = s()), a.insertInto || (a.insertInto = "head"), a.insertAt || (a.insertAt = "bottom");
    var _ = u(e, a);
    return p(_, a), function (e) {
      for (var o = [], n = 0; n < _.length; n++) {
        var t = _[n];
        (r = l[t.id]).refs--, o.push(r);
      }
      e && p(u(e, a), a);
      for (n = 0; n < o.length; n++) {
        var r;
        if (0 === (r = o[n]).refs) {
          for (var i = 0; i < r.parts.length; i++) r.parts[i]();
          delete l[r.id];
        }
      }
    };
  };
  var f,
    y = (f = [], function (e, o) {
      return f[e] = o, f.filter(Boolean).join("\n");
    });
  function g(e, o, n, t) {
    var r = n ? "" : t.css;
    if (e.styleSheet) e.styleSheet.cssText = y(o, r);else {
      var i = document.createTextNode(r),
        a = e.childNodes;
      a[o] && e.removeChild(a[o]), a.length ? e.insertBefore(i, a[o]) : e.appendChild(i);
    }
  }
}, function (e, o) {
  e.exports = function (e) {
    var o = "undefined" != typeof window && window.location;
    if (!o) throw new Error("fixUrls requires window.location");
    if (!e || "string" != typeof e) return e;
    var r = o.protocol + "//" + o.host,
      i = r + o.pathname.replace(/\/[^\/]*$/, "/");
    return e.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (e, o) {
      var n,
        t = o.trim().replace(/^"(.*)"$/, function (e, o) {
          return o;
        }).replace(/^'(.*)'$/, function (e, o) {
          return o;
        });
      return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(t) ? e : (n = 0 === t.indexOf("//") ? t : 0 === t.indexOf("/") ? r + t : i + t.replace(/^\.\//, ""), "url(" + JSON.stringify(n) + ")");
    });
  };
}, function (e, o, n) {
  e.exports = {
    root: "ABB_CommonUX_Slider__root",
    minMaxValues: "ABB_CommonUX_Slider__minMaxValues",
    light: "ABB_CommonUX_Slider__light",
    rcSliderRoot: "ABB_CommonUX_Slider__rcSliderRoot",
    rcSliderHandle: "ABB_CommonUX_Slider__rcSliderHandle",
    disabled: "ABB_CommonUX_Slider__disabled",
    double: "ABB_CommonUX_Slider__double",
    dark: "ABB_CommonUX_Slider__dark",
    customNgSlider: "ABB_CommonUX_Slider__custom-ng-slider",
    ng5Slider: "ABB_CommonUX_Slider__ng5-slider",
    ng5SliderBar: "ABB_CommonUX_Slider__ng5-slider-bar",
    ng5SliderSelection: "ABB_CommonUX_Slider__ng5-slider-selection",
    ng5SliderPointer: "ABB_CommonUX_Slider__ng5-slider-pointer",
    ng5SliderBubble: "ABB_CommonUX_Slider__ng5-slider-bubble",
    ng5SliderModelValue: "ABB_CommonUX_Slider__ng5-slider-model-value",
    ng5SliderModelHigh: "ABB_CommonUX_Slider__ng5-slider-model-high",
    ng5SliderCombined: "ABB_CommonUX_Slider__ng5-slider-combined",
    ng5SliderTick: "ABB_CommonUX_Slider__ng5-slider-tick",
    ng5SliderSelected: "ABB_CommonUX_Slider__ng5-slider-selected",
    ng5SliderTickLegend: "ABB_CommonUX_Slider__ng5-slider-tick-legend",
    showLabelsActive: "ABB_CommonUX_Slider__showLabelsActive",
    ng5SliderPointerMin: "ABB_CommonUX_Slider__ng5-slider-pointer-min",
    ng5SliderPointerMax: "ABB_CommonUX_Slider__ng5-slider-pointer-max",
    ng5SliderActive: "ABB_CommonUX_Slider__ng5-slider-active",
    showLabelsAlways: "ABB_CommonUX_Slider__showLabelsAlways",
    showLabelsNever: "ABB_CommonUX_Slider__showLabelsNever"
  };
}, function (e, n, o) {
  "use strict";

  Object.defineProperty(n, "__esModule", {
    value: !0
  }), function (e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }(o(173));
}, function (e, o, n) {
  "use strict";

  var _t63,
    r = this && this.__extends || (_t63 = function t(e, o) {
      return (_t63 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t63(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    c = this && this.__assign || function () {
      return (c = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var b = n(0),
    m = n(1),
    p = n(3),
    u = n(2),
    d = n(28),
    h = n(48),
    i = function (o) {
      function e(e) {
        return o.call(this, e) || this;
      }
      return r(e, o), e.prototype.render = function () {
        var n = this,
          e = this.props,
          t = e.className,
          r = e.productName,
          i = e.productSubName,
          a = e.productFullName,
          _ = e.footerText,
          l = e.progress,
          s = e.copyrightText;
        return b.createElement(p.ThemeContext.Provider, {
          value: "light"
        }, b.createElement(p.ThemeContext.Consumer, null, function (e) {
          var o;
          return b.createElement("div", c({}, u.getHtmlAttributes(n.props), {
            className: m(h.root, h[e], t, (o = {}, o[h.loading] = !0, o), h.noMaxHeight)
          }), b.createElement("div", {
            className: h.loadingIndicator
          }, b.createElement(d.LoadingIndicator, {
            type: "bar",
            color: "red",
            sizeClass: "small",
            value: l,
            determinate: !0
          })), b.createElement("div", {
            className: h.header
          }, b.createElement("div", null, a), b.createElement("div", {
            className: h.logo
          })), b.createElement("div", {
            className: h.contentWrapper
          }, b.createElement("div", {
            className: m(h.content)
          }, b.createElement("h1", {
            className: h.productName
          }, r), b.createElement("h2", {
            className: h.productSubName
          }, i), b.createElement("div", {
            className: h.bottom
          }, b.createElement("div", {
            className: h.flexSpring
          }), b.createElement("div", {
            className: h.copyright
          }, s)))), _ && b.createElement("div", {
            className: h.footer
          }, b.createElement("div", null, _)));
        }));
      }, e.defaultProps = {
        productFullName: "",
        progress: 0,
        copyrightText: "All rights reserved " + new Date().getFullYear()
      }, e;
    }(b.Component);
  o.SplashScreen = i, o.default = i;
}, function (e, n, o) {
  "use strict";

  Object.defineProperty(n, "__esModule", {
    value: !0
  }), function (e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }(o(175));
}, function (e, o, n) {
  "use strict";

  var _t64,
    r = this && this.__extends || (_t64 = function t(e, o) {
      return (_t64 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t64(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    _ = this && this.__assign || function () {
      return (_ = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var l = n(0),
    s = n(1),
    c = n(3),
    b = n(2),
    m = n(176),
    i = function (n) {
      function e(e) {
        var o = n.call(this, e) || this;
        return o.handleMinimize = o.handleMinimize.bind(o), o.handleMaximize = o.handleMaximize.bind(o), o.handleRestore = o.handleRestore.bind(o), o.handleClose = o.handleClose.bind(o), o;
      }
      return r(e, n), e.prototype.render = function () {
        var o = this,
          e = this.props,
          n = e.className,
          t = e.showMinimize,
          r = e.showMaximize,
          i = e.showRestore,
          a = e.showClose;
        return l.createElement(c.ThemeContext.Consumer, null, function (e) {
          return l.createElement("div", _({}, b.getHtmlAttributes(o.props), {
            className: s(m.root, m[e], n),
            onClick: o.handleMinimize
          }), t && l.createElement("div", {
            className: m.minimize,
            onClick: o.handleMinimize
          }, l.createElement("svg", {
            x: "0px",
            y: "0px",
            viewBox: "0 0 10 1"
          }, l.createElement("rect", {
            width: "10",
            height: "1"
          }))), i && l.createElement("div", {
            className: m.maximize,
            onClick: o.handleMaximize
          }, l.createElement("svg", {
            x: "0px",
            y: "0px",
            viewBox: "0 0 10 10"
          }, l.createElement("path", {
            d: "M 0 0 L 0 10 L 10 10 L 10 0 L 0 0 z M 1 1 L 9 1 L 9 9 L 1 9 L 1 1 z "
          }))), r && l.createElement("div", {
            className: m.restore,
            onClick: o.handleRestore
          }, l.createElement("svg", {
            x: "0px",
            y: "0px",
            viewBox: "0 0 10 10"
          }, l.createElement("mask", {
            id: "Mask"
          }, l.createElement("rect", {
            width: "10",
            height: "10"
          }), l.createElement("path", {
            d: "M 3 1 L 9 1 L 9 7 L 8 7 L 8 2 L 3 2 L 3 1 z"
          }), l.createElement("path", {
            d: "M 1 3 L 7 3 L 7 9 L 1 9 L 1 3 z"
          })), l.createElement("path", {
            d: "M 2 0 L 10 0 L 10 8 L 8 8 L 8 10 L 0 10 L 0 2 L 2 2 L 2 0 z",
            mask: "url(#Mask)"
          }))), a && l.createElement("div", {
            className: m.close,
            onClick: o.handleClose
          }, l.createElement("svg", {
            x: "0px",
            y: "0px",
            viewBox: "0 0 10 10"
          }, l.createElement("polygon", {
            points: "10,1 9,0 5,4 1,0 0,1 4,5 0,9 1,10 5,6 9,10 10,9 6,5"
          }))));
        });
      }, e.prototype.handleMinimize = function (e) {
        e.preventDefault(), this.props.onMinimize && this.props.onMinimize(e);
      }, e.prototype.handleMaximize = function (e) {
        e.preventDefault(), this.props.onMaximize && this.props.onMaximize(e);
      }, e.prototype.handleRestore = function (e) {
        e.preventDefault(), this.props.onRestore && this.props.onRestore(e);
      }, e.prototype.handleClose = function (e) {
        e.preventDefault(), this.props.onClose && this.props.onClose(e);
      }, e.defaultProps = {
        showMinimize: !0,
        showMaximize: !0,
        showRestore: !0,
        showClose: !0
      }, e;
    }(l.Component);
  o.SystemControls = i, o.default = i;
}, function (e, o, n) {
  e.exports = {
    root: "ABB_CommonUX_SystemControls__root",
    minimize: "ABB_CommonUX_SystemControls__minimize",
    close: "ABB_CommonUX_SystemControls__close",
    maximize: "ABB_CommonUX_SystemControls__maximize",
    restore: "ABB_CommonUX_SystemControls__restore",
    light: "ABB_CommonUX_SystemControls__light",
    dark: "ABB_CommonUX_SystemControls__dark"
  };
}, function (e, n, o) {
  "use strict";

  function t(e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), t(o(178)), t(o(71));
}, function (e, o, n) {
  "use strict";

  var _t65,
    r = this && this.__extends || (_t65 = function t(e, o) {
      return (_t65 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t65(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    m = this && this.__assign || function () {
      return (m = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var p = n(0),
    u = n(1),
    i = n(15),
    d = n(2),
    h = n(71),
    B = n(29),
    A = n(49),
    C = n(179),
    a = n(72),
    _ = function (n) {
      function e(e) {
        var o = n.call(this, e) || this;
        return o.state = {
          id: ""
        }, o.rootDomNode = p.createRef(), o._handleChange = o._handleChange.bind(o), o;
      }
      return r(e, n), e.prototype.componentWillMount = function () {
        var e = i.createUniqueId("toggle-");
        this.setState({
          id: e
        });
      }, e.prototype.render = function () {
        var i = this,
          e = this.props,
          o = e.className,
          a = e.sizeClass,
          _ = e.multiselect,
          l = e.selected,
          s = e.type,
          n = Array.isArray(this.props.children) ? this.props.children : [this.props.children],
          c = n ? n.length - 1 : 0,
          b = [];
        return p.Children.forEach(n, function (e, o) {
          if ("function" != typeof e.type) throw new Error("Invalid child component. Expected ToggleButton. Got " + e.type + ".");
          if (e.type.componentName === h.ToggleButton.componentName) b.push(p.cloneElement(e, {
            key: o,
            _from_parent_: {
              isFirst: 0 === o,
              isLast: o === c,
              sizeClass: a,
              multiselect: _,
              colorVariation: "normal" === s ? "blue" : "black",
              name: i.state.id,
              onClick: i._handleChange,
              selected: !!l && -1 < l.indexOf(o),
              nextIsSelected: !!l && -1 < l.indexOf(o + 1)
            }
          }));else {
            if (e.type.componentName !== A.WithPopup.componentName) {
              var n = "string" == typeof e.type ? e.type : e.type.name;
              throw new Error("Invalid child component. Expected ToggleButton (or WithPopup, which contains a ToggleButton). Got: '" + n + "'");
            }
            var t = [];
            if (p.Children.forEach(e.props.children, function (e, o) {
              var n = "string" == typeof e ? e : e.type.componentName;
              t.push(n);
            }), 2 !== t.length) throw new Error("Invalid child components. Expected 2 children (ToggleButton and Popup). Got " + t.length + ".");
            if (t[0] !== h.ToggleButton.componentName || t[1] !== B.Popup.componentName) throw new Error("Invalid child component. Expected ToggleButton and Popup. Got: " + t[0] + " and " + t[1] + ".");
            var r = [p.cloneElement(e.props.children[0], {
              _from_parent_: {
                isFirst: 0 === o,
                isLast: o === c,
                sizeClass: a,
                multiselect: _,
                colorVariation: "normal" === s ? "blue" : "black",
                name: i.state.id,
                onClick: i._handleChange,
                selected: !!l && -1 < l.indexOf(o),
                nextIsSelected: !!l && -1 < l.indexOf(o + 1)
              }
            }), p.cloneElement(e.props.children[1])];
            b.push(p.cloneElement(e, {
              key: o,
              children: r
            }));
          }
        }), p.createElement("ul", m({}, d.getHtmlAttributes(this.props), {
          className: u(C.container, o),
          ref: this.rootDomNode
        }), b);
      }, e.prototype._handleChange = function (e) {
        var n = [];
        if (this.props.multiselect) {
          n = this.props.selected || [];
          for (var o = function o(_o) {
              t.rootDomNode.current.children[_o].classList.contains(a.root) && e === t.rootDomNode.current.children[_o] && (-1 < n.indexOf(_o) ? n = n.filter(function (e) {
                return e !== _o;
              }) : n.push(_o));
            }, t = this, r = 0; r < this.rootDomNode.current.children.length; r++) o(r);
        } else for (r = 0; r < this.rootDomNode.current.children.length; r++) this.rootDomNode.current.children[r].classList.contains(a.root) && e === this.rootDomNode.current.children[r] && n.push(r);
        this.props.onChange && this.props.onChange(n.sort());
      }, e.defaultProps = {
        multiselect: !1,
        sizeClass: "medium",
        type: "normal"
      }, e;
    }(p.Component);
  o.ToggleButtonGroup = _, o.default = _;
}, function (e, o, n) {
  e.exports = {
    container: "ABB_CommonUX_ToggleButtonGroup__container"
  };
}, function (e, n, o) {
  "use strict";

  Object.defineProperty(n, "__esModule", {
    value: !0
  }), function (e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }(o(181));
}, function (e, o, n) {
  "use strict";

  var _t66,
    r = this && this.__extends || (_t66 = function t(e, o) {
      return (_t66 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t66(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    l = this && this.__assign || function () {
      return (l = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var s = n(0),
    c = n(1),
    b = n(3),
    m = n(2),
    p = n(182),
    i = function (n) {
      function e(e) {
        var o = n.call(this, e) || this;
        return o._handleChange = o._handleChange.bind(o), o;
      }
      return r(e, n), e.prototype.render = function () {
        var n = this,
          e = this.props,
          t = e.className,
          r = e.label,
          i = e.value,
          a = e.disabled,
          _ = e.showIcons;
        return s.createElement(b.ThemeContext.Consumer, null, function (e) {
          var o;
          return s.createElement("div", l({}, m.getHtmlAttributes(n.props), {
            className: c(p.root, p[e], t, (o = {}, o[p.switchedOn] = i, o[p.disabled] = a, o[p.showIcons] = _, o)),
            onClick: n._handleChange
          }), s.createElement("div", {
            className: p.control
          }), s.createElement("div", {
            className: p.label
          }, r));
        });
      }, e.prototype._handleChange = function () {
        !this.props.disabled && this.props.onChange && this.props.onChange(!this.props.value);
      }, e.defaultProps = {
        label: "",
        disabled: !1,
        showIcons: !0
      }, e;
    }(s.Component);
  o.ToggleSwitch = i, o.default = i;
}, function (e, o, n) {
  e.exports = {
    root: "ABB_CommonUX_ToggleSwitch__root",
    control: "ABB_CommonUX_ToggleSwitch__control",
    label: "ABB_CommonUX_ToggleSwitch__label",
    switchedOn: "ABB_CommonUX_ToggleSwitch__switchedOn",
    disabled: "ABB_CommonUX_ToggleSwitch__disabled",
    showIcons: "ABB_CommonUX_ToggleSwitch__showIcons",
    light: "ABB_CommonUX_ToggleSwitch__light",
    dark: "ABB_CommonUX_ToggleSwitch__dark"
  };
}, function (e, n, o) {
  "use strict";

  function t(e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), t(o(184)), t(o(73));
}, function (e, o, n) {
  "use strict";

  var _t67,
    r = this && this.__extends || (_t67 = function t(e, o) {
      return (_t67 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, o) {
        e.__proto__ = o;
      } || function (e, o) {
        for (var n in o) o.hasOwnProperty(n) && (e[n] = o[n]);
      })(e, o);
    }, function (e, o) {
      function n() {
        this.constructor = e;
      }
      _t67(e, o), e.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }),
    c = this && this.__assign || function () {
      return (c = Object.assign || function (e) {
        for (var o, n = 1, t = arguments.length; n < t; n++) for (var r in o = arguments[n]) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        return e;
      }).apply(this, arguments);
    };
  Object.defineProperty(o, "__esModule", {
    value: !0
  });
  var b = n(0),
    m = n(1),
    p = n(185),
    u = n(3),
    d = n(73),
    h = n(74),
    i = function (n) {
      function t(e) {
        var o = n.call(this, e) || this;
        return o.id = "tooltip-" + t.idCounter++, o.renderActualContent = !1, o.previousProps = o.props, o._onOpen = o._onOpen.bind(o), o._getContent = o._getContent.bind(o), o;
      }
      return r(t, n), t.prototype.componentDidUpdate = function (e) {
        this.previousProps !== this.props && (this.previousProps = this.props, this.setState({}));
      }, t.prototype.render = function () {
        var n = this,
          e = this.props,
          o = e.triggerOnClick,
          t = e.followCursor,
          r = e.disabled,
          i = e.delayShow,
          a = e.delayHide,
          _ = b.Children.toArray(this.props.children);
        if (2 !== _.length || !_[1].type || _[1].type.componentName !== d.Tooltip.componentName) throw new Error("Invalid tooltip construction. Expected: <WithTooltip><any single element /><Tooltip /></WithTooltip>");
        var l = b.cloneElement(_[0], {
            "data-tip": "",
            "data-for": this.id
          }),
          s = o ? {
            event: "click"
          } : {};
        if (o && t) throw new Error("Not allowed simultaneously: triggerOnClick and followCursor.");
        return b.createElement(u.ThemeContext.Consumer, null, function (e) {
          var o;
          return b.createElement(b.Fragment, null, b.createElement("span", {
            className: m(h.trigger),
            "data-tip": "",
            "data-for": n.id
          }, l), n.previousProps === n.props && b.createElement(p, c({
            place: "bottom"
          }, s, {
            delayShow: i,
            delayHide: a,
            disable: r,
            effect: t ? "float" : "solid",
            id: n.id,
            className: m(h.container, (o = {}, o[h.alignLeft] = t, o), h[e]),
            afterShow: n._onOpen,
            getContent: n._getContent
          })));
        });
      }, t.prototype._onOpen = function () {
        this.renderActualContent = !0;
      }, t.prototype._getContent = function () {
        return !this.props.lazyLoading || this.renderActualContent ? b.createElement("div", null, b.createElement("div", {
          className: h.arrow
        }), this.props.children[1]) : (this._onOpen(), null);
      }, t.idCounter = 1, t.defaultProps = {
        triggerOnClick: !1,
        lazyLoading: !0,
        followCursor: !1,
        disabled: !1,
        delayShow: 100,
        delayHide: 300
      }, t;
    }(b.Component);
  o.WithTooltip = i, o.default = i;
}, function (e, o) {
  e.exports = require("react-tooltip");
}, function (e, n, o) {
  "use strict";

  function t(e) {
    for (var o in e) n.hasOwnProperty(o) || (n[o] = e[o]);
  }
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), t(o(75)), t(o(78)), t(o(81)), t(o(85)), t(o(88)), t(o(91)), t(o(93)), t(o(95)), t(o(98)), t(o(101)), t(o(103)), t(o(105)), t(o(107)), t(o(109)), t(o(16)), t(o(112)), t(o(27)), t(o(12)), t(o(116)), t(o(46)), t(o(119)), t(o(122)), t(o(123)), t(o(126)), t(o(129)), t(o(4)), t(o(26)), t(o(132)), t(o(45)), t(o(28)), t(o(135)), t(o(137)), t(o(140)), t(o(144)), t(o(147)), t(o(151)), t(o(152)), t(o(155)), t(o(160)), t(o(163)), t(o(172)), t(o(17)), t(o(174)), t(o(42)), t(o(177)), t(o(180)), t(o(183)), t(o(3)), t(o(6)), t(o(2)), n.default = {};
}]));